function isEmpty(obj) {
  return (
    obj &&
    Object.keys(obj).length === 0 &&
    Object.getPrototypeOf(obj) === Object.prototype
  );
}

function getImageAttachmentURL(srcMode, src, projectID) {
  projectID = src?.projectID ? src.projectID : projectID;

  if (srcMode === "cdn") {
    if (src?.og) {
      return `https://cdn.grigora.co/projects/${projectID}/${src?.og}`;
    }
    return `https://cdn.grigora.co/projects/${projectID}/${src?.name}.${src?.extension}`;
  } else if (srcMode === "link") {
    return src;
  } /* only in editor */ else if (srcMode === "preview") {
    return src;
  }
  return undefined;
}

function getImageAttachmentURLWithURL(srcMode, src, projectID) {
  var imgURL = getImageAttachmentURL(srcMode, src, projectID);
  if (imgURL) {
    return `url(${imgURL})`;
  }
  return undefined;
}

function getDirectoryData(allDirectories, directoryId, index, field) {
  var listing = allDirectories?.[directoryId]?.listings?.[index];
  if (!listing) {
    return "";
  }

  var fieldData = listing.fields?.[field];
  return fieldData ? fieldData : "";
}

class GrigoraCSSRenderer {
  constructor() {}
  fontSize(val) {
    // Todo - validation of unit
    if (val) {
      return `font-size: ${val};`;
    }
    return "";
  }
  columnCount(val) {
    // Todo - validation of number
    if (val) {
      return `column-count: ${val};`;
    }
    return "";
  }
  color(val) {
    // Todo - validation of color
    if (val) {
      return `color: ${val};`;
    }
    return "";
  }
  opacity(val) {
    if (val !== undefined && val !== null) {
      val = Number(val);
      return `opacity: ${val};`;
    }
    return "";
  }
  backgroundColor(val) {
    // Todo - validation of color
    if (val) {
      return `background-color: ${val};`;
    }
    return "";
  }
  background(val) {
    // Todo - validation of color
    if (val) {
      return `background: ${val};`;
    }
    return "";
  }
  backgroundMixBlendMode(val) {
    if (val) {
      return `mix-blend-mode: ${val};`;
    }
    return "";
  }
  lineHeight(val) {
    if (val) {
      return `line-height: ${val};`;
    }
    return "";
  }
  letterSpacing(val) {
    if (val) {
      return `letter-spacing: ${val};`;
    }
    return "";
  }
  wordSpacing(val) {
    if (val) {
      return `word-spacing: ${val};`;
    }
    return "";
  }
  fontWeight(val) {
    if (val) {
      return `font-weight: ${val};`;
    }
    return "";
  }
  textDecoration(val) {
    if (val) {
      return `text-decoration: ${val};`;
    }
    return "";
  }
  textTransform(val) {
    if (val) {
      return `text-transform: ${val};`;
    }
    return "";
  }
  fontStyle(val) {
    if (val) {
      return `font-style: ${val};`;
    }
    return "";
  }
  marginTop(val, important = false) {
    if (val) {
      return `margin-top: ${val} ${important ? "!important" : ""};`;
    }
    return "";
  }
  marginBottom(val, important = false) {
    if (val) {
      return `margin-bottom: ${val} ${important ? "!important" : ""};`;
    }
    return "";
  }
  marginLeft(val, important = false) {
    if (val) {
      return `margin-left: ${val} ${important ? "!important" : ""};`;
    }
    return "";
  }
  marginRight(val, important = false) {
    if (val) {
      return `margin-right: ${val} ${important ? "!important" : ""};`;
    }
    return "";
  }
  paddingTop(val) {
    if (val) {
      return `padding-top: ${val};`;
    }
    return "";
  }
  paddingBottom(val) {
    if (val) {
      return `padding-bottom: ${val};`;
    }
    return "";
  }
  paddingLeft(val) {
    if (val) {
      return `padding-left: ${val};`;
    }
    return "";
  }
  paddingRight(val) {
    if (val) {
      return `padding-right: ${val};`;
    }
    return "";
  }
  textAlign(val) {
    if (val) {
      return `text-align: ${val};`;
    }
    return "";
  }

  height(val, important = false) {
    if (val) {
      return `height:${val} ${important ? "!important" : ""};`;
    }
    return "";
  }

  zindex(val) {
    if (val) {
      return `z-index:${val};`;
    }
    return "";
  }

  listStyleType(val) {
    if (val) {
      return `list-style-type:${
        val === "sort"
          ? `lower-alpha`
          : val === "ul"
          ? "disc"
          : val === "ol"
          ? "decimal"
          : val === "none"
          ? "none"
          : ""
      };`;
    }
    return "";
  }

  width(val, important = false) {
    if (val) {
      return `width:${val} ${important ? "!important" : ""};`;
    }
    return "";
  }

  flexBasis(val) {
    if (val) {
      return `flex-basis:${val};`;
    }
    return "";
  }

  borderTopLeftRadius(val) {
    if (val) {
      return `border-top-left-radius:${val};`;
    }
    return "";
  }
  borderTopRightRadius(val) {
    if (val) {
      return `border-top-right-radius:${val};`;
    }
    return "";
  }
  borderBottomLeftRadius(val) {
    if (val) {
      return `border-bottom-left-radius:${val};`;
    }
    return "";
  }
  borderBottomRightRadius(val) {
    if (val) {
      return `border-bottom-right-radius:${val};`;
    }
    return "";
  }

  margin(layoutMargin, important = false) {
    if (layoutMargin) {
      return `${this.marginTop(layoutMargin?.top, important)}
      ${this.marginBottom(layoutMargin?.bottom, important)}
      ${this.marginLeft(layoutMargin?.left, important)}
      ${this.marginRight(layoutMargin?.right, important)}`;
    }
    return "";
  }
  padding(layoutPadding) {
    if (layoutPadding) {
      return `${this.paddingTop(layoutPadding.top)}
      ${this.paddingBottom(layoutPadding.bottom)}
      ${this.paddingLeft(layoutPadding.left)}
      ${this.paddingRight(layoutPadding.right)}`;
    }
    return "";
  }
  borderWidth(val) {
    if (val) {
      return `border-width:${val};`;
    }
    return "";
  }
  borderColor(val) {
    if (val) {
      return `border-color:${val};`;
    }
    return "";
  }
  borderStyle(val) {
    if (val) {
      return `border-style:${val};`;
    }
    return "";
  }

  borderRadius(borderRadius) {
    if (borderRadius) {
      return `${this.borderTopLeftRadius(borderRadius?.topLeft)}
      ${this.borderTopRightRadius(borderRadius?.topRight)}
      ${this.borderBottomLeftRadius(borderRadius?.bottomLeft)}
      ${this.borderBottomRightRadius(borderRadius?.bottomRight)}`;
    }
    return "";
  }

  blockGap(val) {
    if (val) {
      return `gap:${val};`;
    }
    return "";
  }

  maxWidth(val) {
    if (val) {
      return `max-width:${val};`;
    }
    return "";
  }
  maxHeight(val) {
    if (val) {
      return `max-height:${val};`;
    }
    return "";
  }

  minWidth(val) {
    if (val) {
      return `min-width:${val};`;
    }
    return "";
  }
  minHeight(val) {
    if (val) {
      return `min-height:${val};`;
    }
    return "";
  }

  position(val) {
    if (val) {
      return `position:${val};`;
    }
    return "";
  }

  top(val) {
    if (val) {
      return `top:${val};`;
    }
    return "";
  }

  bottom(val) {
    if (val) {
      return `bottom:${val};`;
    }
    return "";
  }
  left(val) {
    if (val) {
      return `left:${val};`;
    }
    return "";
  }
  right(val) {
    if (val) {
      return `right:${val};`;
    }
    return "";
  }

  marginBlockStart(val) {
    if (val) {
      return `margin-block-start:${val};`;
    }
    return "";
  }

  marginBlockEnd(val) {
    if (val) {
      return `margin-block-end:${val};`;
    }
    return "";
  }

  display(val) {
    if (val) {
      return `display:${val};`;
    }
    return "";
  }

  justifyContent(val) {
    if (val === "left") {
      val = "flex-start";
    }
    if (val === "right") {
      val = "flex-end";
    }
    if (val) {
      return `justify-content:${val};`;
    }
    return "";
  }
  alignItems(val) {
    if (val === "left") {
      val = "flex-start";
    }
    if (val === "right") {
      val = "flex-end";
    }
    if (val) {
      return `align-items:${val};`;
    }
    return "";
  }

  alignContent(val) {
    if (val) {
      return `align-content:${val};`;
    }
    return "";
  }

  overflow(val) {
    if (val) {
      return `overflow:${val};`;
    }
    return "";
  }

  scrollBehavior(val) {
    if (val) {
      return `scroll-behavior:${val};`;
    }
    return "";
  }

  backgroundImage(val) {
    if (val) {
      return `background-image:${val};`;
    }
    return "";
  }

  backgroundAttachment(val) {
    if (val) {
      return `background-attachment:${val};`;
    }
    return "";
  }

  backgroundSize(val) {
    if (val) {
      return `background-size:${val};`;
    }
    return "";
  }

  backgroundPosition(val) {
    if (val) {
      return `background-position:${val};`;
    }
    return "";
  }

  backgroundRepeat(val) {
    if (val) {
      return `background-repeat:${val};`;
    }
    return "";
  }

  borderTopColor(val) {
    if (val) {
      return `border-top-color:${val};`;
    }
    return "";
  }
  borderBottomColor(val) {
    if (val) {
      return `border-bottom-color:${val};`;
    }
    return "";
  }
  borderLeftColor(val) {
    if (val) {
      return `border-left-color:${val};`;
    }
    return "";
  }
  borderRightColor(val) {
    if (val) {
      return `border-right-color:${val};`;
    }
    return "";
  }

  borderTopStyle(val) {
    if (val) {
      return `border-top-style:${val};`;
    }
    return "";
  }
  borderBottomStyle(val) {
    if (val) {
      return `border-bottom-style:${val};`;
    }
    return "";
  }
  borderLeftStyle(val) {
    if (val) {
      return `border-left-style:${val};`;
    }
    return "";
  }
  borderRightStyle(val) {
    if (val) {
      return `border-right-style:${val};`;
    }
    return "";
  }

  borderTopWidth(val) {
    if (val) {
      return `border-top-width:${val};`;
    }
    return "";
  }
  borderBottomWidth(val) {
    if (val) {
      return `border-bottom-width:${val};`;
    }
    return "";
  }
  borderLeftWidth(val) {
    if (val) {
      return `border-left-width:${val};`;
    }
    return "";
  }
  borderRightWidth(val) {
    if (val) {
      return `border-right-width:${val};`;
    }
    return "";
  }

  border(border, defaultStyle) {
    return `${this.borderTopColor(
      border?.top?.color ?? defaultStyle?.top?.color,
    )}
      ${this.borderBottomColor(
        border?.bottom?.color ?? defaultStyle?.bottom?.color,
      )}
      ${this.borderLeftColor(border?.left?.color ?? defaultStyle?.left?.color)}
      ${this.borderRightColor(
        border?.right?.color ?? defaultStyle?.right?.color,
      )}

      ${this.borderTopStyle(border?.top?.style ?? defaultStyle?.top?.style)}
      ${this.borderBottomStyle(
        border?.bottom?.style ?? defaultStyle?.bottom?.style,
      )}
      ${this.borderLeftStyle(border?.left?.style ?? defaultStyle?.left?.style)}
      ${this.borderRightStyle(
        border?.right?.style ?? defaultStyle?.right?.style,
      )}

      ${this.borderTopWidth(
        border?.top?.width ?? defaultStyle?.top?.width
          ? border?.top?.width ?? defaultStyle?.top?.width
          : border?.top?.style ?? defaultStyle?.top?.style
          ? "0px"
          : "",
      )}
      ${this.borderBottomWidth(
        border?.bottom?.width ?? defaultStyle?.bottom?.width
          ? border?.bottom?.width ?? defaultStyle?.bottom?.width
          : border?.bottom?.style ?? defaultStyle?.bottom?.style
          ? "0px"
          : "",
      )}
      ${this.borderLeftWidth(
        border?.left?.width ?? defaultStyle?.left?.width
          ? border?.left?.width ?? defaultStyle?.left?.width
          : border?.left?.style ?? defaultStyle?.left?.style
          ? "0px"
          : "",
      )}
      ${this.borderRightWidth(
        border?.right?.width ?? defaultStyle?.right?.width
          ? border?.right?.width ?? defaultStyle?.right?.width
          : border?.right?.style ?? defaultStyle?.right?.style
          ? "0px"
          : "",
      )}`;
  }

  backdropFilter(val) {
    if (val && !isEmpty(val)) {
      return `backdrop-filter:${
        val.blur
          ? `blur(${
              val.blur.includes("px") || val.blur.includes("rem")
                ? val.blur
                : val.blur + "px"
            })`
          : ""
      }
      ${
        val.brightness
          ? val.brightness === 100
            ? ""
            : `brightness(${val.brightness}%)`
          : ""
      }
      ${
        val.contrast
          ? val.contrast === 100
            ? ""
            : `contrast(${val.contrast}%)`
          : ""
      }
      ${
        val.saturation
          ? val.saturation === 100
            ? ""
            : `saturate(${val.saturation}%)`
          : ""
      }
      ${
        val.opacity
          ? val.opacity === 100
            ? ""
            : `opacity(${val.opacity}%)`
          : ""
      }
      ${val.grayscale ? `grayscale(${val.grayscale}%)` : ""}
      ${val.invert ? `invert(${val.invert}%)` : ""}
      ${val.sepia ? `sepia(${val.sepia}%)` : ""}
      ${
        val.dropShadow && val.dropShadow.length > 0
          ? `drop-shadow(${val.dropShadow.map(
              (shadow) =>
                `${shadow.x} ${shadow.y} ${shadow.blur} ${shadow.color}`,
            )})`
          : ""
      }
      ${val.hue ? `hue-rotate(${val.hue}deg)` : ""};`;
    }
    return "";
  }

  filter(val) {
    if (val && !isEmpty(val)) {
      return `filter:${
        val.blur
          ? `blur(${
              val.blur.includes("px") || val.blur.includes("rem")
                ? val.blur
                : val.blur + "px"
            })`
          : ""
      }
      ${
        val.brightness
          ? val.brightness === 100
            ? ""
            : `brightness(${val.brightness}%)`
          : ""
      }
      ${
        val.contrast
          ? val.contrast === 100
            ? ""
            : `contrast(${val.contrast}%)`
          : ""
      }
      ${
        val.saturation
          ? val.saturation === 100
            ? ""
            : `saturate(${val.saturation}%)`
          : ""
      }
      ${
        val.opacity
          ? val.opacity === 100
            ? ""
            : `opacity(${val.opacity}%)`
          : ""
      }
      ${val.grayscale ? `grayscale(${val.grayscale}%)` : ""}
      ${val.invert ? `invert(${val.invert}%)` : ""}
      ${val.sepia ? `sepia(${val.sepia}%)` : ""}
      ${
        val.dropShadow && val.dropShadow.length > 0
          ? `drop-shadow(${val.dropShadow.map(
              (shadow) =>
                `${shadow.x} ${shadow.y} ${shadow.blur} ${shadow.color}`,
            )})`
          : ""
      }
      ${val.hue ? `hue-rotate(${val.hue}deg)` : ""};`;
    }
    return "";
  }

  webkitFilterTransition(val, property) {
    if (val && !isEmpty(val)) {
      return `
      -webkit-transition: ${val.duration} -webkit-${property} ${val.easing} ${val.delay};
      -moz-transition: ${val.duration} -moz-${property} ${val.easing} ${val.delay};
      -moz-transition: ${val.duration} ${property} ${val.easing} ${val.delay};
      -ms-transition: ${val.duration} -ms-${property} ${val.easing} ${val.delay};
      -o-transition: ${val.duration} -o-${property} ${val.easing} ${val.delay};
      transition: ${val.duration} ${property} ${val.easing} ${val.delay}, ${val.duration} -webkit-filter ${val.easing} ${val.delay};`;
    }
    return "";
  }

  boxShadowCSS(params) {
    if (Array.isArray(params) && params.length > 0) {
      var tempStr = [];
      params.forEach((element) => {
        tempStr.push(
          `${element.x ? element.x : "0px"} ${element.y ? element.y : "0px"} ${
            element.spread ? element.spread : "0px"
          } ${element.blur ? element.blur : "0px"} ${
            element.color ? element.color : "#000000"
          }`,
        );
      });

      return tempStr.join(", ");
    }

    return "";
  }

  flexDirection(val) {
    if (val) {
      return `flex-direction:${val};`;
    }
    return "";
  }
  flexWrap(val) {
    if (val) {
      return `flex-wrap:${val};`;
    }
    return "";
  }

  boxShadow(val) {
    if (val) {
      return `box-shadow:${val};`;
    }
    return "";
  }

  columnGap(val) {
    if (val) {
      return `column-gap: ${val};`;
    }
    return "";
  }

  rowGap(val) {
    if (val) {
      return `row-gap: ${val};`;
    }
    return "";
  }

  gap(val) {
    if (val) {
      return `gap: ${val};`;
    }
    return "";
  }

  alignSelf(val) {
    if (val === "left") {
      val = "start";
    }
    if (val === "right") {
      val = "end";
    }
    if (val) {
      return `align-self: ${val};`;
    }
    return "";
  }

  blockCSS__Text(id, props) {
    const {
      align,
      alignMobile,
      alignTablet,
      layoutColumns,
      textColor,
      hoverTextColor,
      backgroundColor,
      hoverBackgroundColor,
      typoSize,
      typoSizeTablet,
      typoSizeMobile,
      typoLineHeight,
      typoLetterSpacing,
      typoWordSpacing,
      typoTransform,
      typoStyle,
      typoDecoration,
      typoWeight,
      layoutPadding,
      layoutPaddingTablet,
      layoutPaddingMobile,
      hoverLayoutPadding,
      hoverLayoutPaddingTablet,
      hoverLayoutPaddingMobile,
      layoutMargin,
      layoutMarginTablet,
      layoutMarginMobile,
      hoverLayoutMargin,
      hoverLayoutMarginTablet,
      hoverLayoutMarginMobile,
      layoutColumnsGap,
      structureTag = "p",
      linkColor,
    } = props;
    return `.text-${id} ${
      process.env.GRIGORA_SERVICE !== "renderer" ? structureTag : ""
    } {
      ${this.transitionSupport(props)}
      ${this.fontSize(typoSize)}
      ${this.columnCount(layoutColumns)}
      ${this.color(textColor)}
      ${this.backgroundColor(backgroundColor)}
      ${this.lineHeight(typoLineHeight)}
      ${this.letterSpacing(typoLetterSpacing)}
      ${this.wordSpacing(typoWordSpacing)}
      ${this.fontWeight(typoWeight)}
      ${this.textDecoration(typoDecoration)}
      ${this.textTransform(typoTransform)}
      ${this.fontStyle(typoStyle)}
      ${this.padding(layoutPadding)}
      ${this.margin(layoutMargin, true)}
      ${this.textAlign(align)}
      ${this.columnGap(layoutColumnsGap)}
    }

    .text-${id}${
      process.env.GRIGORA_SERVICE !== "renderer" ? ` ${structureTag}` : ""
    }:hover {
      ${this.color(hoverTextColor)}
      ${this.backgroundColor(hoverBackgroundColor)}
      ${this.padding(hoverLayoutPadding)}
      ${this.margin(hoverLayoutMargin, true)}
    }

    .text-${id} ${
      process.env.GRIGORA_SERVICE !== "renderer" ? structureTag : ""
    } a{
      ${this.color(linkColor)}
    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .text-${id} ${
      process.env.GRIGORA_SERVICE !== "renderer" ? structureTag : ""
    } {
      ${this.fontSize(typoSizeTablet)}
      ${this.padding(layoutPaddingTablet)}
      ${this.margin(layoutMarginTablet)}
      ${this.textAlign(alignTablet)}
      }
    
    
    
      .text-${id}${
      process.env.GRIGORA_SERVICE !== "renderer" ? ` ${structureTag}` : ""
    }:hover {
      ${this.padding(hoverLayoutPaddingTablet)}
      ${this.margin(hoverLayoutMarginTablet)}
      }
    }
    

    /* Mobile */
    @media (max-width: 767px) {
      .text-${id} ${
      process.env.GRIGORA_SERVICE !== "renderer" ? structureTag : ""
    } {
      ${this.fontSize(typoSizeMobile)}
      ${this.padding(layoutPaddingMobile)}
      ${this.textAlign(alignMobile)}
      ${this.margin(layoutMarginMobile)}
        }

      .text-${id}${
      process.env.GRIGORA_SERVICE !== "renderer" ? ` ${structureTag}` : ""
    }:hover {
        ${this.padding(hoverLayoutPaddingMobile)}
        ${this.margin(hoverLayoutMarginMobile)}
      }
    }
    `;
  }

  blockCSS__Spacer(id, props) {
    const {
      width = "100%",
      widthTablet,
      widthMobile,
      height = "100px",
      heightTablet,
      heightMobile,
      maxWidth,
      maxWidthTablet,
      maxWidthMobile,
      maxHeight,
      maxHeightTablet,
      maxHeightMobile,
      minWidth,
      minWidthTablet,
      minWidthMobile,
      minHeight,
      minHeightTablet,
      minHeightMobile,
      margin,
      marginTablet,
      marginMobile,
    } = props;
    return `
    .spacer-${id} {
      ${this.width(width)}
      ${this.height(height)}
      ${this.maxWidth(maxWidth)}
      ${this.maxHeight(maxHeight)}
      ${this.minWidth(minWidth)}
      ${this.minHeight(minHeight)}
      ${this.margin(margin)}

    }
    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .spacer-${id}{
      ${this.width(widthTablet)}
      ${this.height(heightTablet)}
      ${this.maxWidth(maxWidthTablet)}
      ${this.maxHeight(maxHeightTablet)}
      ${this.minWidth(minWidthTablet)}
      ${this.minHeight(minHeightTablet)}
      ${this.margin(marginTablet)}
      }
    }
    
    /* Mobile */
    @media (max-width: 767px) {
      .spacer-${id}{
        ${this.width(widthMobile)}
        ${this.height(heightMobile)}
        ${this.maxWidth(maxWidthMobile)}
        ${this.maxHeight(maxHeightMobile)}
        ${this.minWidth(minWidthMobile)}
        ${this.minHeight(minHeightMobile)}
        ${this.margin(marginMobile)}
      }
    }
    
    `;
  }

  blockCSS__Image(id, props) {
    const {
      width,
      widthTablet,
      widthMobile,
      height,
      heightTablet,
      heightMobile,
      align,
      alignTablet,
      alignMobile,
      boxShadow,
      border,
      borderRadius,
      layoutPadding,
      layoutPaddingTablet,
      layoutMargin,
      layoutMarginTablet,
      layoutMarginMobile,
      hoverBoxShadow,
      hoverBorder,
      hoverBorderRadius,
      hoverLayoutPadding,
      hoverLayoutPaddingTablet,
      hoverLayoutPaddingMobile,
      hoverLayoutMargin,
      hoverLayoutMarginTablet,
      hoverLayoutMarginMobile,
      cssFilter,
    } = props;
    return `
    .image-${id}{
      ${this.transitionSupport(props)}
      ${this.margin(layoutMargin)}
      ${this.padding(layoutPadding)}
      ${align === "left" ? `${this.alignItems("start")}` : ``}
      ${align === "center" ? `${this.alignItems("center")}` : ``}
      ${align === "right" ? `${this.alignItems("end")}` : ``}
      ${align === "justify" ? `${this.alignItems("justify")}` : ``}
    }

    .image-${id} img{
      ${this.width(width)}
      ${this.height(height)}
      ${this.transitionSupport(props)}

      ${this.border(
        border,
        hoverBorder
          ? {
              top: {
                width: "0px",
                style: "solid",
                color: hoverBorder?.top?.color,
              },
              bottom: {
                width: "0px",
                style: "solid",
                color: hoverBorder?.bottom?.color,
              },
              left: {
                width: "0px",
                style: "solid",
                color: hoverBorder?.left?.color,
              },
              right: {
                width: "0px",
                style: "solid",
                color: hoverBorder?.right?.color,
              },
            }
          : undefined,
      )}
      ${this.borderRadius(borderRadius)}
      ${this.boxShadow(this.boxShadowCSS(boxShadow))}
      ${this.filter(cssFilter)}
    }
    .image-${id} figcaption{
      ${this.textAlign(align)}
    }

    .image-${id}:hover{
      ${this.margin(hoverLayoutMargin)}
      ${this.padding(hoverLayoutPadding)}
    }

    .image-${id} img:hover{
      ${this.border(hoverBorder)}
      ${this.borderRadius(hoverBorderRadius)}
      ${this.boxShadow(this.boxShadowCSS(hoverBoxShadow))}
    }
    
    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .image-${id}{
        ${this.margin(layoutMarginTablet)}
        ${this.padding(layoutPaddingTablet)}
        ${alignTablet === "left" ? `${this.alignItems("start")}` : ``}
        ${alignTablet === "center" ? `${this.alignItems("center")}` : ``}
        ${alignTablet === "right" ? `${this.alignItems("end")}` : ``}
        ${align === "justify" ? `${this.alignItems("justify")}` : ``}
        
      }
      .image-${id} img{
        ${this.width(widthTablet)}
        ${this.height(heightTablet)}
      }
      .image-${id} figcaption{
        ${this.textAlign(alignTablet)}
      }
      .image-${id}:hover{
        ${this.margin(hoverLayoutMarginTablet)}
        ${this.padding(hoverLayoutPaddingTablet)}
      }
     
    }
    
    /* Mobile */
    @media (max-width: 767px) {
      .image-${id}{
        ${this.margin(layoutMarginMobile)}
        ${this.padding(layoutPadding)}
        ${alignMobile === "left" ? `${this.alignItems("start")}` : ``}
        ${alignMobile === "center" ? `${this.alignItems("center")}` : ``}
        ${alignMobile === "right" ? `${this.alignItems("end")}` : ``}
        ${align === "justify" ? `${this.alignItems("justify")}` : ``}
        
      }
      .image-${id} img{
        ${this.width(widthMobile)}
        ${this.height(heightMobile)}
      }
      .image-${id} figcaption{
        ${this.textAlign(alignMobile)}
      }
      .image-${id}:hover{
        ${this.margin(hoverLayoutMarginMobile)}
        ${this.padding(hoverLayoutPaddingMobile)}
      }
     
    }

  `;
  }

  blockCSS__GoogleMap(id, props) {
    const {
      align,
      alignTablet,
      alignMobile,
      height = "500px",
      heightTablet,
      heightMobile,
      maxWidth,
      maxWidthTablet,
      maxWidthMobile,
      layoutMargin,
      layoutMarginTablet,
      layoutMarginMobile,
      layoutPadding,
      layoutPaddingTablet,
      layoutPaddingMobile,
    } = props;
    return `.google-map-${id}{
      ${this.justifyContent(align)}
      ${this.margin(layoutMargin)}
      ${this.padding(layoutPadding)}

    }
    .google-map-${id} .container {
      ${this.maxWidth(maxWidth)}
      ${this.height(height)}
    }
    
    /* Tablet  */
    @media (min-width: 768px) and (max-width: 1024px) {
      .google-map-${id}{
        ${this.justifyContent(alignTablet)}
        ${this.margin(layoutMarginTablet)}
        ${this.padding(layoutPaddingTablet)}}
      .google-map-${id} .container{
        ${this.maxWidth(maxWidthTablet)}
        ${this.height(heightTablet)}
      }
    }
    
    /* Mobile */
    @media (max-width: 767px) {
      .google-map-${id}{
        ${this.justifyContent(alignMobile)}
        ${this.margin(layoutMarginMobile)}
        ${this.padding(layoutPaddingMobile)}
      .google-map-${id} .container{
        ${this.maxWidth(maxWidthMobile)}
        ${this.height(heightMobile)}
      }
    }
    `;
  }

  blockCSS__Portal(id, props) {
    const {
      alignChildren,
      alignChildrenTablet,
      alignChildrenMobile,
      alignVerticalChildren,
      alignVerticalChildrenTablet,
      alignVerticalChildrenMobile,
      width,
      widthTablet,
      widthMobile,
      maxWidth,
      maxWidthTablet,
      maxWidthMobile,
      height,
      heightTablet,
      heightMobile,
      maxHeight,
      maxHeightTablet,
      maxHeightMobile,
      background,
    } = props;
    return `
    .portal-${id}, .portal-${id}.is-post-editor{
      ${this.justifyContent(alignChildren)}
      ${this.alignItems(alignVerticalChildren)}
      ${this.background(background)}
    }

    .portal-${id} > .childrens, .portal-${id}.is-post-editor > .children{
      ${this.width(width)}
      ${this.height(height)}
      ${this.maxWidth(maxWidth)}
      ${this.maxHeight(maxHeight)}
    }
    
    /* Tablet  */
    @media (min-width: 768px) and (max-width: 1024px) {
      .portal-${id}, .portal-${id}.is-post-editor{
        ${this.justifyContent(alignChildrenTablet)}
        ${this.alignItems(alignVerticalChildrenTablet)}
      }
      .portal-${id} > .childrens, .portal-${id}.is-post-editor > .children {
        ${this.width(widthTablet)}
        ${this.height(heightTablet)}
        ${this.maxWidth(maxWidthTablet)}
        ${this.maxHeight(maxHeightTablet)}
      }
    }
    
    /* Mobile */
    @media (max-width: 767px) {
      .portal-${id}, .portal-${id}.is-post-editor{
        ${this.justifyContent(alignChildrenMobile)}
        ${this.alignItems(alignVerticalChildrenMobile)}
      }
      .portal-${id} > .childrens, .portal-${id}.is-post-editor > .children {
        ${this.width(widthMobile)}
        ${this.height(heightMobile)}
        ${this.maxWidth(maxWidthMobile)}
        ${this.maxHeight(maxHeightMobile)}
      }
    }
    `;
  }

  blockCSS__PortalClose(id, props) {
    const {
      align,
      alignTablet,
      alignMobile,
      alignVertical,
      alignVerticalTablet,
      alignVerticalMobile,
      width,
      widthTablet,
      widthMobile,
      height,
      heightTablet,
      heightMobile,
      background,
      color,
      boxShadow,
      border,
      borderRadius,
      margin,
      marginTablet,
      marginMobile,
      padding,
      paddingTablet,
      paddingMobile,
      hoverBackground,
      hoverColor,
      hoverBoxShadow,
      hoverBorder,
      hoverBorderRadius,
      hoverMargin,
      hoverMarginTablet,
      hoverMarginMobile,
      hoverPadding,
      hoverPaddingTablet,
      hoverPaddingMobile,
      transition,
    } = props;
    return `
    .portal-close-${id}{
      ${this.transitionSupport(props)}
      ${this.justifyContent(align)}
      ${this.alignItems(alignVertical)}
      ${this.background(background)}
      ${this.color(color)}
      ${this.margin(margin)}
      ${this.padding(padding)}
      ${this.boxShadow(this.boxShadowCSS(boxShadow))}
      ${this.borderRadius(borderRadius)}
      ${this.border(border)}
      ${this.width(width)}
      ${this.height(height)}
    }

    .portal-close-${id}:hover{
      ${this.background(hoverBackground)}
      ${this.color(hoverColor)}
      ${this.margin(hoverMargin)}
      ${this.padding(hoverPadding)}
      ${this.boxShadow(this.boxShadowCSS(hoverBoxShadow))}
      ${this.borderRadius(hoverBorderRadius)}
      ${this.border(hoverBorder)}
    }
    
    /* Tablet  */
    @media (min-width: 768px) and (max-width: 1024px) {
      .portal-close-${id}{
        ${this.justifyContent(alignTablet)}
        ${this.alignItems(alignVerticalTablet)}
        ${this.margin(marginTablet)}
        ${this.padding(paddingTablet)}
        ${this.width(widthTablet)}
        ${this.height(heightTablet)}
      }

      .portal-close-${id}:hover:{
        ${this.margin(hoverMarginTablet)}
        ${this.padding(hoverPaddingTablet)}
      }
    }
    
    /* Mobile */
    @media (max-width: 767px) {
      .portal-close-${id}{
        ${this.justifyContent(alignMobile)}
        ${this.alignItems(alignVerticalMobile)}
        ${this.margin(marginMobile)}
        ${this.padding(paddingMobile)}
        ${this.width(widthMobile)}
        ${this.height(heightMobile)}
      }

      .portal-close-${id}:hover:{
        ${this.margin(hoverPaddingTablet)}
        ${this.padding(hoverPaddingMobile)}
      }
    }
    `;
  }

  transitionSupport(props) {
    var { transition, filters, transformAnimation } = props;

    if (!transition?.types || isEmpty(transition?.types)) return "";

    var css = "";

    // Modify Filter and Backdrop Filter from support props
    if (filters?.hover?.duration) {
      transition = {
        ...(transition ? transition : {}),
        types: {
          ...(transition?.types ? transition?.types : {}),
          filter: {
            duration: filters?.hover?.duration,
            easing: filters?.hover?.easing,
            delay: filters?.hover?.delay,
          },
        },
      };
    }

    // Modify Transform Animation from support props
    if (transformAnimation?.desktop?.hover?.duration) {
      transition = {
        ...(transition ? transition : {}),
        types: {
          ...(transition?.types ? transition?.types : {}),
          transform: {
            duration: transformAnimation?.desktop?.hover?.duration,
            easing: transformAnimation?.desktop?.hover?.easing,
            delay: transformAnimation?.desktop?.hover?.delay,
          },
        },
      };
    }

    Object.keys(transition.types).forEach((type) => {
      css += `${type} ${
        transition?.types?.[type]?.duration
          ? `${transition?.types?.[type]?.duration}s`
          : "0.3s"
      } ${
        transition?.types?.[type]?.easing
          ? transition?.types?.[type]?.easing
          : ""
      } ${
        transition?.types?.[type]?.delay
          ? `${transition?.types?.[type]?.delay}s`
          : ""
      },`;
    });

    if (css === "") return "";

    return `transition: ${css.slice(0, -1)};`;
  }

  blockCSS__Container(id, props, contexts, projectID) {
    var {
      display = "block",
      width = "100%",
      widthTablet = "100%",
      widthMobile = "100%",
      height,
      heightTablet,
      heightMobile,
      maxWidth,
      maxWidthMobile,
      maxWidthTablet,
      maxHeight,
      maxHeightTablet,
      maxHeightMobile,
      blockGap = "1rem",
      blockGapTablet,
      blockGapMobile,
      padding = {
        top: "20px",
        bottom: "20px",
        left: "20px",
        right: "20px",
      },
      paddingTablet,
      paddingMobile,
      margin,
      marginTablet,
      marginMobile,
      overflow,
      textColor,
      linkColor,
      border,
      borderTablet,
      borderMobile,
      borderRadius,
      boxShadow,
      alignItems = "start",
      alignItemsTablet,
      alignItemsMobile,
      url,
      isUrlDynamic,
      dynamicUrlSrc,
      justifyContent = "start",
      justifyContentTablet,
      justifyContentMobile,
      minWidth,
      minWidthTablet,
      minWidthMobile,
      minHeight,
      minHeightTablet,
      minHeightMobile,
      direction = "column",
      directionTablet,
      directionMobile,
      wrap = "wrap",
      wrapTablet,
      wrapMobile,
      backgroundLayer,
      backgroundLayerTablet,
      backgroundLayerMobile,
      linkDecoration,
      backgroundColor,
      hideDesktop,
      hideTablet,
      hideMobile,
      isBackgroundLayerDynamic,
      dynamicBackgroundLayerSrc,
      backgroundOverlayLayer,
      backgroundOverlayLayerTablet,
      backgroundOverlayLayerMobile,
      backgroundOverlayLayerOpacity = 0.7,
      backgroundOverlayLayerOpacityTablet,
      backgroundOverlayLayerOpacityMobile,
      isComponent,
      hoverPadding,
      hoverPaddingTablet,
      hoverPaddingMobile,
      hoverMargin,
      hoverMarginTablet,
      hoverMarginMobile,
      hoverTextColor,
      hoverLinkColor,
      hoverBorder,
      hoverBorderTablet,
      hoverBorderMobile,
      hoverBorderRadius,
      hoverBoxShadow,
      hoverIsBackgroundLayerDynamic,
      hoverDynamicBackgroundLayerSrc,
      hoverBackgroundLayer,
      hoverBackgroundLayerTablet,
      hoverBackgroundLayerMobile,
      hoverBackgroundOverlayLayer,
      hoverBackgroundOverlayLayerTablet,
      hoverBackgroundOverlayLayerMobile,
      hoverBackgroundOverlayLayerOpacity = 0.7,
      hoverBackgroundOverlayLayerOpacityTablet,
      hoverBackgroundOverlayLayerOpacityMobile,
      transition,
    } = props;

    // For Backend
    if (process.env.GRIGORA_SERVICE === "renderer") {
      // Background Layer
      if (isBackgroundLayerDynamic) {
        if (dynamicBackgroundLayerSrc === "post-featured-image") {
          var post = contexts?.CMSPostContext;
          backgroundLayer = {
            mode: "image",
            image: {
              srcMode: post?.featured_image?.srcMode,
              src: post?.featured_image?.src,
            },
          };
        }
        if (dynamicBackgroundLayerSrc === "category-featured-image") {
          var category = contexts?.CMSCategoryContext;
          backgroundLayer = {
            mode: "image",
            image: {
              srcMode: category?.thumbnail?.srcMode,
              src: category?.thumbnail?.src,
            },
          };
        }
        if (dynamicBackgroundLayerSrc === "directory-listing") {
          var field = getDirectoryData(
            props?.context_all_directories,
            props?.context_directory_id,
            props?.context_directory_index,
            backgroundLayer?.image?.directoryFieldId,
          );
          backgroundLayer = {
            mode: "image",
            image: {
              srcMode: field?.srcMode,
              src: field?.src,
            },
          };
        }
      }
      if (hoverIsBackgroundLayerDynamic) {
        if (hoverDynamicBackgroundLayerSrc === "post-featured-image") {
          var post = contexts?.CMSPostContext;
          hoverBackgroundLayer = {
            mode: "image",
            image: {
              srcMode: post?.featured_image?.srcMode,
              src: post?.featured_image?.src,
            },
          };
        }
        if (hoverDynamicBackgroundLayerSrc === "category-featured-image") {
          var category = contexts?.CMSCategoryContext;
          hoverBackgroundLayer = {
            mode: "image",
            image: {
              srcMode: category?.thumbnail?.srcMode,
              src: category?.thumbnail?.src,
            },
          };
        }
        if (hoverDynamicBackgroundLayerSrc === "directory-listing") {
          var field = getDirectoryData(
            props?.context_all_directories,
            props?.context_directory_id,
            props?.context_directory_index,
            hoverBackgroundLayer?.image?.directoryFieldId,
          );
          hoverBackgroundLayer = {
            mode: "image",
            image: {
              srcMode: field?.srcMode,
              src: field?.src,
            },
          };
        }
      }
    } else {
      if (isBackgroundLayerDynamic) {
        if (dynamicBackgroundLayerSrc === "post-featured-image") {
          var post = contexts?.CMSPostContext;
          backgroundLayer = {
            mode: "image",
            image: {
              srcMode: post?.featured_image?.srcMode || "link",
              src:
                post?.featured_image?.src ||
                "https://cdn.grigora.co/defaults/img/post-featured-image-placeholder.webp",
            },
          };
        } else {
          backgroundLayer = {
            mode: "image",
            image: {
              srcMode: "link",
              src: "https://cdn.grigora.co/defaults/img/post-featured-image-placeholder.webp",
            },
          };
          backgroundLayerTablet = undefined;
          backgroundLayerMobile = undefined;
        }
      }
      if (hoverIsBackgroundLayerDynamic) {
        if (hoverDynamicBackgroundLayerSrc === "post-featured-image") {
          var post = contexts?.CMSPostContext;
          hoverBackgroundLayer = {
            mode: "image",
            image: {
              srcMode: post?.featured_image?.srcMode || "link",
              src:
                post?.featured_image?.src ||
                "https://cdn.grigora.co/defaults/img/post-featured-image-placeholder.webp",
            },
          };
        } else {
          hoverBackgroundLayer = {
            mode: "image",
            image: {
              srcMode: "link",
              src: "https://cdn.grigora.co/defaults/img/post-featured-image-placeholder.webp",
            },
          };
          hoverBackgroundLayerTablet = undefined;
          hoverBackgroundLayerMobile = undefined;
        }
      }
    }

    // Anchor Link
    if (isUrlDynamic) {
      if (dynamicUrlSrc === "current-cms-post") {
        url = "#";
      } else if (dynamicUrlSrc === "current-cms-category") {
        url = "#";
      }
    }

    return `
    .container-${id} {
      ${
        backgroundOverlayLayer ||
        backgroundOverlayLayerTablet ||
        backgroundOverlayLayerMobile
          ? `${this.position("relative")}`
          : ``
      }
      ${
        process.env.GRIGORA_SERVICE !== "renderer" && isComponent
          ? `${this.position("relative")}`
          : ``
      }
      ${this.transitionSupport(props)}
      ${this.width(width)}
      ${this.height(height)}
      ${this.maxWidth(maxWidth)}
      ${this.maxHeight(maxHeight)}
      ${this.minWidth(minWidth)}
      ${this.minHeight(minHeight)}
      ${this.margin(margin)}
      ${url ? `` : `${this.padding(padding)}`}
      ${this.overflow(overflow)}
      ${this.color(textColor)}
      ${this.backgroundColor(backgroundColor)}
      ${this.border(
        border,
        hoverBorder
          ? {
              top: {
                width: "0px",
                style: "solid",
                color: hoverBorder?.top?.color,
              },
              bottom: {
                width: "0px",
                style: "solid",
                color: hoverBorder?.bottom?.color,
              },
              left: {
                width: "0px",
                style: "solid",
                color: hoverBorder?.left?.color,
              },
              right: {
                width: "0px",
                style: "solid",
                color: hoverBorder?.right?.color,
              },
            }
          : undefined,
      )}
      ${this.borderRadius(borderRadius)}
      ${this.boxShadow(this.boxShadowCSS(boxShadow))}
      ${
        backgroundLayer?.mode === "color"
          ? `
        ${this.background(backgroundLayer?.value)}
        `
          : ``
      }
      ${
        backgroundLayer?.mode === "gradient"
          ? `
        ${this.background(backgroundLayer?.value)}
        ${this.backgroundAttachment(
          backgroundLayer?.fixed ? "fixed" : undefined,
        )}
        `
          : ``
      }
      ${
        backgroundLayer?.mode === "image"
          ? `
        ${this.background(
          getImageAttachmentURLWithURL(
            backgroundLayer?.image?.srcMode,
            backgroundLayer?.image?.src,
            projectID,
          ),
        )}
        ${this.backgroundSize(
          backgroundLayer?.size === "custom"
            ? `${backgroundLayer?.sizeCustomWidth} ${backgroundLayer?.sizeCustomHeight}`
            : backgroundLayer?.size
            ? backgroundLayer?.size
            : "cover",
        )}
        ${this.backgroundPosition(
          `${backgroundLayer?.positionX ? backgroundLayer?.positionX : "50%"} ${
            backgroundLayer?.positionY ? backgroundLayer?.positionY : "50%"
          }`,
        )}
        ${this.backgroundRepeat(
          backgroundLayer?.repeat ? backgroundLayer?.repeat : "repeat",
        )}
        ${this.backgroundAttachment(
          backgroundLayer?.fixed ? "fixed" : undefined,
        )}

        `
          : ``
      }
    }
    
    .container-${id} > .hover-container{
      ${this.transition(
        transition?.types?.["background"]?.duration
          ? transition?.types?.["background"]?.duration + "s"
          : undefined,
      )}

      ${
        hoverBackgroundLayer?.mode === "color"
          ? `
        ${this.background(hoverBackgroundLayer?.value)}
        `
          : ``
      }

      ${
        hoverBackgroundLayer?.mode === "gradient"
          ? `
        ${this.background(hoverBackgroundLayer?.value)}
        ${this.backgroundAttachment(
          hoverBackgroundLayer?.fixed ? "fixed" : undefined,
        )}
        `
          : ``
      }
      ${
        hoverBackgroundLayer?.mode === "image"
          ? `
        ${this.background(
          getImageAttachmentURLWithURL(
            hoverBackgroundLayer?.image?.srcMode,
            hoverBackgroundLayer?.image?.src,
            projectID,
          ),
        )}
        ${this.backgroundSize(
          hoverBackgroundLayer?.size === "custom"
            ? `${hoverBackgroundLayer?.sizeCustomWidth} ${hoverBackgroundLayer?.sizeCustomHeight}`
            : hoverBackgroundLayer?.size
            ? hoverBackgroundLayer?.size
            : "cover",
        )}
        ${this.backgroundPosition(
          `${
            hoverBackgroundLayer?.positionX
              ? hoverBackgroundLayer?.positionX
              : "50%"
          } ${
            hoverBackgroundLayer?.positionY
              ? hoverBackgroundLayer?.positionY
              : "50%"
          }`,
        )}
        ${this.backgroundRepeat(
          hoverBackgroundLayer?.repeat
            ? hoverBackgroundLayer?.repeat
            : "repeat",
        )}
        ${this.backgroundAttachment(
          hoverBackgroundLayer?.fixed ? "fixed" : undefined,
        )}

        `
          : ``
      }

    }


    .container-${id}:hover{
      ${this.color(hoverTextColor)}
      ${this.border(hoverBorder)}
      ${this.borderRadius(hoverBorderRadius)}
      ${this.boxShadow(this.boxShadowCSS(hoverBoxShadow))}
      ${this.margin(hoverMargin)}
      ${url ? `` : `${this.padding(hoverPadding)}`}
    }

    .container-${id} > .overlay {
      ${this.opacity(backgroundOverlayLayerOpacity)}
      ${
        backgroundOverlayLayer?.mode === "color"
          ? `
        ${this.background(backgroundOverlayLayer?.value)}
        `
          : ``
      }
      ${
        backgroundOverlayLayer?.mode === "gradient"
          ? `
        ${this.background(backgroundOverlayLayer?.value)}
        ${this.backgroundAttachment(
          backgroundOverlayLayer?.fixed ? "fixed" : undefined,
        )}
        `
          : ``
      }
      ${
        backgroundOverlayLayer?.mode === "image"
          ? `
        ${this.background(
          getImageAttachmentURLWithURL(
            backgroundOverlayLayer?.image?.srcMode,
            backgroundOverlayLayer?.image?.src,
            projectID,
          ),
        )}
        ${this.backgroundSize(
          backgroundOverlayLayer?.size === "custom"
            ? `${backgroundOverlayLayer?.sizeCustomWidth} ${backgroundOverlayLayer?.sizeCustomHeight}`
            : backgroundOverlayLayer?.size
            ? backgroundOverlayLayer?.size
            : "cover",
        )}
        ${this.backgroundPosition(
          `${
            backgroundOverlayLayer?.positionX
              ? backgroundOverlayLayer?.positionX
              : "50%"
          } ${
            backgroundOverlayLayer?.positionY
              ? backgroundOverlayLayer?.positionY
              : "50%"
          }`,
        )}
        ${this.backgroundRepeat(
          backgroundOverlayLayer?.repeat
            ? backgroundOverlayLayer?.repeat
            : "repeat",
        )}
        ${this.backgroundAttachment(
          backgroundOverlayLayer?.fixed ? "fixed" : undefined,
        )}

        `
          : ``
      }
    }
    .container-${id} > .hover-overlay{
      ${this.transition(
        transition?.types?.["background"]?.duration
          ? transition?.types?.["background"]?.duration + "s"
          : undefined,
      )}
      ${
        hoverBackgroundOverlayLayer?.mode === "color"
          ? `
        ${this.background(hoverBackgroundOverlayLayer?.value)}
        `
          : ``
      }
      ${
        hoverBackgroundOverlayLayer?.mode === "gradient"
          ? `
        ${this.background(hoverBackgroundOverlayLayer?.value)}
        ${this.backgroundAttachment(
          hoverBackgroundOverlayLayer?.fixed ? "fixed" : undefined,
        )}
        `
          : ``
      }
      ${
        hoverBackgroundOverlayLayer?.mode === "image"
          ? `
        ${this.background(
          getImageAttachmentURLWithURL(
            hoverBackgroundOverlayLayer?.image?.srcMode,
            hoverBackgroundOverlayLayer?.image?.src,
            projectID,
          ),
        )}
        ${this.backgroundSize(
          hoverBackgroundOverlayLayer?.size === "custom"
            ? `${hoverBackgroundOverlayLayer?.sizeCustomWidth} ${hoverBackgroundOverlayLayer?.sizeCustomHeight}`
            : hoverBackgroundOverlayLayer?.size
            ? hoverBackgroundOverlayLayer?.size
            : "cover",
        )}
        ${this.backgroundPosition(
          `${
            hoverBackgroundOverlayLayer?.positionX
              ? hoverBackgroundOverlayLayer?.positionX
              : "50%"
          } ${
            hoverBackgroundOverlayLayer?.positionY
              ? hoverBackgroundOverlayLayer?.positionY
              : "50%"
          }`,
        )}
        ${this.backgroundRepeat(
          hoverBackgroundOverlayLayer?.repeat
            ? hoverBackgroundOverlayLayer?.repeat
            : "repeat",
        )}
        ${this.backgroundAttachment(
          hoverBackgroundOverlayLayer?.fixed ? "fixed" : undefined,
        )}

        `
          : ``
      }
    }

    ${
      hoverBackgroundOverlayLayer ||
      hoverBackgroundOverlayLayerTablet ||
      hoverBackgroundOverlayLayerMobile
        ? `
    .container-${id} > .overlay{
      ${this.transition(
        transition?.types?.["background"]?.duration
          ? transition?.types?.["background"]?.duration + "s"
          : undefined,
      )}
    }

    .container-${id}:hover > .overlay{
      ${this.opacity(0)}
    }
    `
        : ``
    }

    .container-${id}:hover > .hover-overlay{
      ${this.opacity(hoverBackgroundOverlayLayerOpacity)}
    }

    ${
      url
        ? `
    .container-${id} > a{
      ${this.padding(padding)}
      ${this.display(display === "flex" ? "flex" : undefined)}
    }
    .container-${id} > a:hover{
      ${this.padding(hoverPadding)}
    }
    `
        : ``
    }

    .container-${id} ${url ? ` > a` : ``} > .childrens {
      ${this.display(display)}

      ${
        display === "flex"
          ? `
      ${this.flexDirection(direction)}
      ${this.flexWrap(wrap)}
      ${this.justifyContent(justifyContent)}
      ${
        display === "flex" && direction === "row" && wrap === "wrap"
          ? `${this.alignContent(alignItems)}${this.alignItems(alignItems)}`
          : `${this.alignItems(alignItems)}`
      }
      ${this.blockGap(blockGap)}
      `
          : ``
      }
    }

    ${
      display !== "flex"
        ? `
        .container-${id}.is-block ${
            url ? ` > a` : ``
          } > .childrens > * + *, .container-${id}.is-block > .childrens > * + * {
          ${this.marginBlockStart(blockGap)}
        }
    `
        : ``
    }

    ${url ? `.container-${id} > a` : `.container-${id} > .childrens a`}  {
      ${this.color(linkColor)}
      ${this.textDecoration(linkDecoration ? "none" : undefined)}
      ${this.transitionSupport(props)}
    }

    ${
      url
        ? `.container-${id} > a:hover`
        : `.container-${id} > .childrens a:hover`
    }  {
      ${this.color(hoverLinkColor)}
    }

    @media (min-width: 1024px) {
      .container-${id} {
        ${this.display(hideDesktop ? "none !important" : undefined)}
      }
    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .container-${id} {
        ${this.display(hideTablet ? "none !important" : undefined)}
        ${this.width(widthTablet)}
        ${this.height(heightTablet)}
        ${this.maxWidth(maxWidthTablet)}
        ${this.maxHeight(maxHeightTablet)}
        ${this.minWidth(minWidthTablet)}
        ${this.minHeight(minHeightTablet)}
        ${this.margin(marginTablet)}
        ${this.border(borderTablet)}
        ${url ? `` : `${this.padding(paddingTablet)}`}
        ${
          backgroundLayerTablet?.mode === "color"
            ? `
          ${this.background(backgroundLayerTablet?.value)}
          `
            : ``
        }
        ${
          backgroundLayerTablet?.mode === "gradient"
            ? `
          ${this.background(backgroundLayerTablet?.value)}
          ${this.backgroundAttachment(
            backgroundLayerTablet?.fixed ? "fixed" : undefined,
          )}
          `
            : ``
        }
        ${
          backgroundLayerTablet?.mode === "image" &&
          backgroundLayerTablet?.image?.srcMode &&
          backgroundLayerTablet?.image?.src
            ? `
            ${this.background(
              getImageAttachmentURLWithURL(
                backgroundLayerTablet?.image?.srcMode,
                backgroundLayerTablet?.image?.src,
                projectID,
              ),
            )}
            ${this.backgroundSize(
              backgroundLayerTablet?.size === "custom"
                ? `${backgroundLayerTablet?.sizeCustomWidth} ${backgroundLayerTablet?.sizeCustomHeight}`
                : backgroundLayerTablet?.size
                ? backgroundLayerTablet?.size
                : "cover",
            )}
            ${this.backgroundPosition(
              `${
                backgroundLayerTablet?.positionX
                  ? backgroundLayerTablet?.positionX
                  : "50%"
              } ${
                backgroundLayerTablet?.positionY
                  ? backgroundLayerTablet?.positionY
                  : "50%"
              }`,
            )}
            ${this.backgroundRepeat(
              backgroundLayerTablet?.repeat
                ? backgroundLayerTablet?.repeat
                : "repeat",
            )}
            ${this.backgroundAttachment(
              backgroundLayerTablet?.fixed ? "fixed" : undefined,
            )}
          `
            : ``
        }
      }

      .container-${id} > .hover-container{
        ${this.transition(
          transition?.types?.["background"]?.duration
            ? transition?.types?.["background"]?.duration + "s"
            : undefined,
        )}
        ${
          hoverBackgroundLayerTablet?.mode === "color"
            ? `
          ${this.background(hoverBackgroundLayerTablet?.value)}
          `
            : ``
        }
        ${
          hoverBackgroundLayerTablet?.mode === "gradient"
            ? `
          ${this.background(hoverBackgroundLayerTablet?.value)}
          ${this.backgroundAttachment(
            hoverBackgroundLayerTablet?.fixed ? "fixed" : undefined,
          )}
          `
            : ``
        }
        ${
          hoverBackgroundLayerTablet?.mode === "image"
            ? `
          ${this.background(
            getImageAttachmentURLWithURL(
              hoverBackgroundLayerTablet?.image?.srcMode,
              hoverBackgroundLayerTablet?.image?.src,
              projectID,
            ),
          )}
          ${this.backgroundSize(
            hoverBackgroundLayerTablet?.size === "custom"
              ? `${hoverBackgroundLayerTablet?.sizeCustomWidth} ${hoverBackgroundLayerTablet?.sizeCustomHeight}`
              : hoverBackgroundLayerTablet?.size
              ? hoverBackgroundLayerTablet?.size
              : "cover",
          )}
          ${this.backgroundPosition(
            `${
              hoverBackgroundLayerTablet?.positionX
                ? hoverBackgroundLayerTablet?.positionX
                : "50%"
            } ${
              hoverBackgroundLayerTablet?.positionY
                ? hoverBackgroundLayerTablet?.positionY
                : "50%"
            }`,
          )}
          ${this.backgroundRepeat(
            hoverBackgroundLayerTablet?.repeat
              ? hoverBackgroundLayerTablet?.repeat
              : "repeat",
          )}
          ${this.backgroundAttachment(
            hoverBackgroundLayerTablet?.fixed ? "fixed" : undefined,
          )}
  
          `
            : ``
        }
  
      }

      .container-${id}:hover{
        ${this.border(hoverBorderTablet)}
        ${this.margin(hoverMarginTablet)}
        ${url ? `` : `${this.padding(hoverPadding)}`}
      }

      .container-${id} > .overlay {
        ${this.opacity(backgroundOverlayLayerOpacityTablet)}
        ${
          backgroundOverlayLayerTablet?.mode === "color"
            ? `
          ${this.background(backgroundOverlayLayerTablet?.value)}
          `
            : ``
        }
        ${
          backgroundOverlayLayerTablet?.mode === "gradient"
            ? `
          ${this.background(backgroundOverlayLayerTablet?.value)}
          ${this.backgroundAttachment(
            backgroundOverlayLayerTablet?.fixed ? "fixed" : undefined,
          )}
          `
            : ``
        }
        ${
          backgroundOverlayLayerTablet?.mode === "image"
            ? `
          ${this.background(
            getImageAttachmentURLWithURL(
              backgroundOverlayLayerTablet?.image?.srcMode,
              backgroundOverlayLayerTablet?.image?.src,
              projectID,
            ),
          )}
          ${this.backgroundSize(
            backgroundOverlayLayerTablet?.size === "custom"
              ? `${backgroundOverlayLayerTablet?.sizeCustomWidth} ${backgroundOverlayLayerTablet?.sizeCustomHeight}`
              : backgroundOverlayLayerTablet?.size
              ? backgroundOverlayLayerTablet?.size
              : "cover",
          )}
          ${this.backgroundPosition(
            `${
              backgroundOverlayLayerTablet?.positionX
                ? backgroundOverlayLayerTablet?.positionX
                : "50%"
            } ${
              backgroundOverlayLayerTablet?.positionY
                ? backgroundOverlayLayerTablet?.positionY
                : "50%"
            }`,
          )}
          ${this.backgroundRepeat(
            backgroundOverlayLayerTablet?.repeat
              ? backgroundOverlayLayerTablet?.repeat
              : "repeat",
          )}
          ${this.backgroundAttachment(
            backgroundOverlayLayerTablet?.fixed ? "fixed" : undefined,
          )}
  
          `
            : ``
        }
      }

      ${
        hoverBackgroundOverlayLayer ||
        hoverBackgroundOverlayLayerTablet ||
        hoverBackgroundOverlayLayerMobile
          ? `
      .container-${id} > .overlay{
        ${this.transition(
          transition?.types?.["background"]?.duration
            ? transition?.types?.["background"]?.duration + "s"
            : undefined,
        )}
      }
  
      .container-${id}:hover > .overlay{
        ${this.opacity(0)}
      }
      `
          : ``
      }

      .container-${id} > .hover-overlay {
        ${this.transition(
          transition?.types?.["background"]?.duration
            ? transition?.types?.["background"]?.duration + "s"
            : undefined,
        )}
        ${
          hoverBackgroundOverlayLayerTablet?.mode === "color"
            ? `
          ${this.background(hoverBackgroundOverlayLayerTablet?.value)}
          `
            : ``
        }
        ${
          hoverBackgroundOverlayLayerTablet?.mode === "gradient"
            ? `
          ${this.background(hoverBackgroundOverlayLayerTablet?.value)}
          ${this.backgroundAttachment(
            hoverBackgroundOverlayLayerTablet?.fixed ? "fixed" : undefined,
          )}
          `
            : ``
        }
        ${
          hoverBackgroundOverlayLayerTablet?.mode === "image"
            ? `
          ${this.background(
            getImageAttachmentURLWithURL(
              hoverBackgroundOverlayLayerTablet?.image?.srcMode,
              hoverBackgroundOverlayLayerTablet?.image?.src,
              projectID,
            ),
          )}
          ${this.backgroundSize(
            hoverBackgroundOverlayLayerTablet?.size === "custom"
              ? `${hoverBackgroundOverlayLayerTablet?.sizeCustomWidth} ${hoverBackgroundOverlayLayerTablet?.sizeCustomHeight}`
              : hoverBackgroundOverlayLayerTablet?.size
              ? hoverBackgroundOverlayLayerTablet?.size
              : "cover",
          )}
          ${this.backgroundPosition(
            `${
              hoverBackgroundOverlayLayerTablet?.positionX
                ? hoverBackgroundOverlayLayerTablet?.positionX
                : "50%"
            } ${
              hoverBackgroundOverlayLayerTablet?.positionY
                ? hoverBackgroundOverlayLayerTablet?.positionY
                : "50%"
            }`,
          )}
          ${this.backgroundRepeat(
            hoverBackgroundOverlayLayerTablet?.repeat
              ? hoverBackgroundOverlayLayerTablet?.repeat
              : "repeat",
          )}
          ${this.backgroundAttachment(
            hoverBackgroundOverlayLayerTablet?.fixed ? "fixed" : undefined,
          )}
  
          `
            : ``
        }
      }

      .container-${id}:hover > .hover-overlay{
        ${this.opacity(hoverBackgroundOverlayLayerOpacityTablet)}
      }

      ${
        url
          ? `
      .container-${id} > a{
        ${this.padding(paddingTablet)}
      }
      `
          : ``
      }

      ${
        url
          ? `
      .container-${id} > a:hover{
        ${this.padding(hoverPaddingTablet)}
      }
      `
          : ``
      }

      .container-${id} ${url ? ` > a` : ``} > .childrens{
        ${this.flexDirection(directionTablet)}
        ${this.flexWrap(wrapTablet)}
        ${
          display === "flex" &&
          directionTablet === "row" &&
          wrapTablet === "wrap"
            ? `${this.alignContent(alignItemsTablet)}${this.alignItems(
                alignItemsTablet,
              )}`
            : `${this.alignItems(alignItemsTablet)}`
        }
      ${this.justifyContent(justifyContentTablet)}
      ${this.blockGap(blockGapTablet)}
      }
      ${
        display !== "flex"
          ? `
        .container-${id}.is-block ${
              url ? ` > a` : ``
            } > .childrens > * + *, .container-${id}.is-block > .childrens > * + * {
          ${this.marginBlockStart(blockGapTablet)}
        }
    `
          : ``
      }

    }
    
    /* Mobile */
    @media (max-width: 767px) {
      .container-${id} {
        ${this.display(hideMobile ? "none !important" : undefined)}
        ${this.width(widthMobile)}
        ${this.height(heightMobile)}
        ${this.maxWidth(maxWidthMobile)}
        ${this.maxHeight(maxHeightMobile)}
        ${this.minWidth(minWidthMobile)}
        ${this.minHeight(minHeightMobile)}
        ${this.margin(marginMobile)}
        ${this.border(borderMobile)}
        ${url ? `` : `${this.padding(paddingMobile)}`}
        ${
          backgroundLayerMobile?.mode === "color"
            ? `
          ${this.background(backgroundLayerMobile?.value)}
          `
            : ``
        }
        ${
          backgroundLayerMobile?.mode === "gradient"
            ? `
          ${this.background(backgroundLayerMobile?.value)}
          ${this.backgroundAttachment(
            backgroundLayerMobile?.fixed ? "fixed" : undefined,
          )}
          `
            : ``
        }
        ${
          backgroundLayerMobile?.mode === "image" &&
          backgroundLayerMobile?.image?.srcMode &&
          backgroundLayerMobile?.image?.src
            ? `
              ${this.background(
                getImageAttachmentURLWithURL(
                  backgroundLayerMobile?.image?.srcMode,
                  backgroundLayerMobile?.image?.src,
                  projectID,
                ),
              )}
              ${this.backgroundSize(
                backgroundLayerMobile?.size === "custom"
                  ? `${backgroundLayerMobile?.sizeCustomWidth} ${backgroundLayerMobile?.sizeCustomHeight}`
                  : backgroundLayerMobile?.size
                  ? backgroundLayerMobile?.size
                  : "cover",
              )}
              ${this.backgroundPosition(
                `${
                  backgroundLayerMobile?.positionX
                    ? backgroundLayerMobile?.positionX
                    : "50%"
                } ${
                  backgroundLayerMobile?.positionY
                    ? backgroundLayerMobile?.positionY
                    : "50%"
                }`,
              )}
              ${this.backgroundRepeat(
                backgroundLayerMobile?.repeat
                  ? backgroundLayerMobile?.repeat
                  : "repeat",
              )}
              ${this.backgroundAttachment(
                backgroundLayerMobile?.fixed ? "fixed" : undefined,
              )}
            `
            : ``
        }
      }

      .container-${id} > .hover-container{
        ${this.transition(
          transition?.types?.["background"]?.duration
            ? transition?.types?.["background"]?.duration + "s"
            : undefined,
        )}

        ${
          hoverBackgroundLayerMobile?.mode === "color"
            ? `
          ${this.background(hoverBackgroundLayerMobile?.value)}
          `
            : ``
        }

        ${
          hoverBackgroundLayerMobile?.mode === "gradient"
            ? `
          ${this.background(hoverBackgroundLayerMobile?.value)}
          ${this.backgroundAttachment(
            hoverBackgroundLayerMobile?.fixed ? "fixed" : undefined,
          )}
          `
            : ``
        }
        ${
          hoverBackgroundLayerMobile?.mode === "image"
            ? `
          ${this.background(
            getImageAttachmentURLWithURL(
              hoverBackgroundLayerMobile?.image?.srcMode,
              hoverBackgroundLayerMobile?.image?.src,
              projectID,
            ),
          )}
          ${this.backgroundSize(
            hoverBackgroundLayerMobile?.size === "custom"
              ? `${hoverBackgroundLayerMobile?.sizeCustomWidth} ${hoverBackgroundLayerMobile?.sizeCustomHeight}`
              : hoverBackgroundLayerMobile?.size
              ? hoverBackgroundLayerMobile?.size
              : "cover",
          )}
          ${this.backgroundPosition(
            `${
              hoverBackgroundLayerMobile?.positionX
                ? hoverBackgroundLayerMobile?.positionX
                : "50%"
            } ${
              hoverBackgroundLayerMobile?.positionY
                ? hoverBackgroundLayerMobile?.positionY
                : "50%"
            }`,
          )}
          ${this.backgroundRepeat(
            hoverBackgroundLayerMobile?.repeat
              ? hoverBackgroundLayerMobile?.repeat
              : "repeat",
          )}
          ${this.backgroundAttachment(
            hoverBackgroundLayerMobile?.fixed ? "fixed" : undefined,
          )}
  
          `
            : ``
        }
       
  
      }

      .container-${id}:hover{
        ${this.border(hoverBorderMobile)}
        ${this.margin(hoverMarginMobile)}
        ${url ? `` : `${this.padding(hoverPaddingMobile)}`}
      }

      .container-${id} > .overlay {
        ${this.opacity(backgroundOverlayLayerOpacityMobile)}
        ${
          backgroundOverlayLayerMobile?.mode === "color"
            ? `
          ${this.background(backgroundOverlayLayerMobile?.value)}
          `
            : ``
        }
        ${
          backgroundOverlayLayerMobile?.mode === "gradient"
            ? `
          ${this.background(backgroundOverlayLayerMobile?.value)}
          ${this.backgroundAttachment(
            backgroundOverlayLayerMobile?.fixed ? "fixed" : undefined,
          )}
          `
            : ``
        }
        ${
          backgroundOverlayLayerMobile?.mode === "image"
            ? `
          ${this.background(
            getImageAttachmentURLWithURL(
              backgroundOverlayLayerMobile?.image?.srcMode,
              backgroundOverlayLayerMobile?.image?.src,
              projectID,
            ),
          )}
          ${this.backgroundSize(
            backgroundOverlayLayerMobile?.size === "custom"
              ? `${backgroundOverlayLayerMobile?.sizeCustomWidth} ${backgroundOverlayLayerMobile?.sizeCustomHeight}`
              : backgroundOverlayLayerMobile?.size
              ? backgroundOverlayLayerMobile?.size
              : "cover",
          )}
          ${this.backgroundPosition(
            `${
              backgroundOverlayLayerMobile?.positionX
                ? backgroundOverlayLayerMobile?.positionX
                : "50%"
            } ${
              backgroundOverlayLayerMobile?.positionY
                ? backgroundOverlayLayerMobile?.positionY
                : "50%"
            }`,
          )}
          ${this.backgroundRepeat(
            backgroundOverlayLayerMobile?.repeat
              ? backgroundOverlayLayerMobile?.repeat
              : "repeat",
          )}
          ${this.backgroundAttachment(
            backgroundOverlayLayerMobile?.fixed ? "fixed" : undefined,
          )}
  
          `
            : ``
        }
      }

      ${
        hoverBackgroundOverlayLayer ||
        hoverBackgroundOverlayLayerTablet ||
        hoverBackgroundOverlayLayerMobile
          ? `
      .container-${id} > .overlay{
        ${this.transition(
          transition?.types?.["background"]?.duration
            ? transition?.types?.["background"]?.duration + "s"
            : undefined,
        )}
      }
  
      .container-${id}:hover > .overlay{
        ${this.opacity(0)}
      }
      `
          : ``
      }

      .container-${id} > .hover-overlay {
        ${this.transition(
          transition?.types?.["background"]?.duration
            ? transition?.types?.["background"]?.duration + "s"
            : undefined,
        )}
        ${
          hoverBackgroundOverlayLayerMobile?.mode === "color"
            ? `
          ${this.background(hoverBackgroundOverlayLayerMobile?.value)}
          `
            : ``
        }
        ${
          hoverBackgroundOverlayLayerMobile?.mode === "gradient"
            ? `
          ${this.background(hoverBackgroundOverlayLayerMobile?.value)}
          ${this.backgroundAttachment(
            hoverBackgroundOverlayLayerMobile?.fixed ? "fixed" : undefined,
          )}
          `
            : ``
        }
        ${
          hoverBackgroundOverlayLayerMobile?.mode === "image"
            ? `
          ${this.background(
            getImageAttachmentURLWithURL(
              hoverBackgroundOverlayLayerMobile?.image?.srcMode,
              hoverBackgroundOverlayLayerMobile?.image?.src,
              projectID,
            ),
          )}
          ${this.backgroundSize(
            hoverBackgroundOverlayLayerMobile?.size === "custom"
              ? `${hoverBackgroundOverlayLayerMobile?.sizeCustomWidth} ${hoverBackgroundOverlayLayerMobile?.sizeCustomHeight}`
              : hoverBackgroundOverlayLayerMobile?.size
              ? hoverBackgroundOverlayLayerMobile?.size
              : "cover",
          )}
          ${this.backgroundPosition(
            `${
              hoverBackgroundOverlayLayerMobile?.positionX
                ? hoverBackgroundOverlayLayerMobile?.positionX
                : "50%"
            } ${
              hoverBackgroundOverlayLayerMobile?.positionY
                ? hoverBackgroundOverlayLayerMobile?.positionY
                : "50%"
            }`,
          )}
          ${this.backgroundRepeat(
            hoverBackgroundOverlayLayerMobile?.repeat
              ? hoverBackgroundOverlayLayerMobile?.repeat
              : "repeat",
          )}
          ${this.backgroundAttachment(
            hoverBackgroundOverlayLayerMobile?.fixed ? "fixed" : undefined,
          )}
  
          `
            : ``
        }
      }
      .container-${id}:hover > .hover-overlay{
        ${this.opacity(hoverBackgroundOverlayLayerOpacityMobile)}
      }

      ${
        url
          ? `
      .container-${id} > a{
        ${this.padding(paddingMobile)}
      }
      `
          : ``
      }

      ${
        url
          ? `
      .container-${id} > a:hover{
        ${this.padding(hoverPaddingMobile)}
      }
      `
          : ``
      }

      .container-${id} ${url ? ` > a` : ``} > .childrens{
        ${this.flexDirection(directionMobile)}
        ${this.flexWrap(wrapMobile)}
        ${
          display === "flex" &&
          directionMobile === "row" &&
          wrapTablet === "wrap"
            ? `${this.alignContent(alignItemsMobile)}${this.alignItems(
                alignItemsMobile,
              )}`
            : `${this.alignItems(alignItemsMobile)}`
        }
      ${this.justifyContent(justifyContentMobile)}
      ${this.blockGap(blockGapMobile)}
      }
      ${
        display !== "flex"
          ? `
        .container-${id}.is-block ${
              url ? ` > a` : ``
            } > .childrens > * + *, .container-${id}.is-block > .childrens > * + * {
          ${this.marginBlockStart(blockGapMobile)}
        }
    `
          : ``
      }
    }

    `;
  }

  blockCSS__Form(id, props, state) {
    const {
      padding = { top: "20px", bottom: "20px", left: "20px", right: "20px" },
      hideOnSuccess = true,
      hideOnFail = true,
      width,
      widthTablet,
      widthMobile,
      height,
      heightTablet,
      heightMobile,
      maxHeight,
      maxHeightTablet,
      maxHeightMobile,
      maxWidth,
      maxWidthTablet,
      maxWidthMobile,
      minHeight,
      minHeightMobile,
      minHeightTablet,
      minWidth,
      minWidthTablet,
      minWidthMobile,
      marginTablet,
      marginMobile,
      margin,
      paddingMobile,
      paddingTablet,
      textColor,
      linkColor,
      border,
      borderTablet,
      borderMobile,
      boxShadow,
      borderRadius,
      borderRadiusTablet,
      borderRadiusMobile,
      gap,
    } = props;

    return `.form-${id}{
      ${this.padding(padding)}
      ${this.margin(margin)}
      ${this.maxWidth(maxWidth)}
      ${this.maxHeight(maxHeight)}
      ${this.width(width)}
      ${this.height(height)}
      ${this.minHeight(minHeight)}
      ${this.minWidth(minWidth)}
      ${this.color(textColor)}
      ${this.color(linkColor)}
      ${this.border(border)}
      ${this.borderRadius(borderRadius)}
      ${this.boxShadow(this.boxShadowCSS(boxShadow))}
    }

    .form-${id} .childrens > * {
      ${this.marginBlockEnd(gap)}
    }

    ${
      state === "success"
        ? `
      .form-${id} .g-form-success{
        ${this.display("block")}
      }
      `
        : ``
    }

    ${
      state === "success" && hideOnSuccess
        ? `
      .form-${id} .form-content{
        ${this.display("none")}
      }
      `
        : ``
    }

    ${
      state === "fail"
        ? `
      .form-${id} .g-form-fail{
        ${this.display("block")}
      }
      `
        : ``
    }

    ${
      state === "fail" && hideOnFail
        ? `
      .form-${id} .form-content{
        ${this.display("none")}
      }
      `
        : ``
    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
        .form-${id}{
              ${this.padding(paddingTablet)}
              ${this.margin(marginTablet)}
              ${this.maxWidth(maxWidthTablet)}
              ${this.maxHeight(maxHeightTablet)}
              ${this.width(widthTablet)}
              ${this.height(heightTablet)}
              ${this.minHeight(minHeightTablet)}
              ${this.minWidth(minWidthTablet)}
              ${this.border(borderTablet)}
        }
    }

    /* Mobile */
    @media (max-width: 767px) {
        .form-${id}{
              ${this.padding(paddingMobile)}
              ${this.margin(marginMobile)}
              ${this.maxWidth(maxWidthMobile)}
              ${this.maxHeight(maxHeightMobile)}
              ${this.width(widthMobile)}
              ${this.height(heightMobile)}
              ${this.minHeight(minHeightMobile)}
              ${this.minWidth(minWidthMobile)}
              ${this.border(borderMobile)}
        }
    }

    `;
  }

  blockCSS__Button(id, props) {
    const {
      typoSize,
      typoSizeTablet,
      typoSizeMobile,
      typoLineHeight,
      typoLetterSpacing,
      typoWordSpacing,
      typoTransform,
      typoStyle,
      typoDecoration,
      typoWeight,
      textColor = "#ffffff",
      hoverTextColor,
      linkColor,
      width,
      widthTablet,
      widthMobile,
      height,
      heightTablet,
      heightMobile,
      display,
      align,
      alignTablet,
      alignMobile,
      verticalAlign = "center",
      textAlign,
      textAlignTablet,
      textAlignMobile,
      padding = { top: "10px", bottom: "10px", left: "10px", right: "10px" },
      paddingTablet = {
        top: "10px",
        bottom: "10px",
        left: "10px",
        right: "10px",
      },
      paddingMobile = {
        top: "10px",
        bottom: "10px",
        left: "10px",
        right: "10px",
      },
      backgroundColor = "#055099",
      hoverBackgroundColor,
      border,
      hoverBorder,
      borderRadius,
      boxShadow,
      hoverBoxShadow,
      iconPadding,
      iconPaddingTablet,
      iconPaddingMobile,
      iconColor,
      hoverIconColor,
      iconSize,
      iconSizeTablet,
      iconSizeMobile,
      transformAnimation,
      hoverPadding,
      hoverBorderRadius,
    } = props;

    return `.button-${id}{
      ${this.justifyContent(align)}
    }

    .button-${id} .btn{
      ${this.transitionSupport(props)}
      ${this.padding(padding)}
      ${this.display(display)}
      ${this.width(width)}
      ${this.height(height)}
      ${this.color(textColor)}
      ${this.backgroundColor(backgroundColor)}
      ${this.fontSize(typoSize)}
      ${this.fontWeight(typoWeight)}
      ${this.fontStyle(typoStyle)}
      ${this.lineHeight(typoLineHeight)}
      ${this.letterSpacing(typoLetterSpacing)}
      ${this.textDecoration(typoDecoration)}
      ${this.textTransform(typoTransform)}
      ${this.textAlign(textAlign)}
      ${this.justifyContent(textAlign)}
      ${this.wordSpacing(typoWordSpacing)}
      ${this.boxShadow(this.boxShadowCSS(boxShadow))}
      ${this.borderRadius(borderRadius)}
      ${this.border(
        border,
        hoverBorder
          ? {
              top: {
                width: "0px",
                style: "solid",
                color: hoverBorder?.top?.color,
              },
              bottom: {
                width: "0px",
                style: "solid",
                color: hoverBorder?.bottom?.color,
              },
              left: {
                width: "0px",
                style: "solid",
                color: hoverBorder?.left?.color,
              },
              right: {
                width: "0px",
                style: "solid",
                color: hoverBorder?.right?.color,
              },
            }
          : undefined,
      )}
      ${this.alignItems(
        verticalAlign === "top"
          ? "start"
          : verticalAlign === "center"
          ? "center"
          : verticalAlign === "bottom"
          ? "end"
          : "",
      )}
    }

    .button-${id} .btn:hover{
      ${this.border(hoverBorder)}
      ${this.boxShadow(this.boxShadowCSS(hoverBoxShadow))}
      ${this.padding(hoverPadding)}
      ${this.borderRadius(hoverBorderRadius)}
      ${this.color(hoverTextColor)}
      ${this.backgroundColor(hoverBackgroundColor)}
    }

    .button-${id} .btn svg{
      ${this.width(iconSize)}
      ${this.height(iconSize)}
      ${this.padding(iconPadding)}
      ${this.color(iconColor)}
    }

    .button-${id} .btn:hover svg{
      ${this.color(hoverIconColor)}
    }
    
    .button-${id} .btn .grigora-richtext-input .grigora-richtext-input__field a{
      ${this.color(linkColor)}
    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .button-${id}{
        ${this.justifyContent(alignTablet)}
      }
      .button-${id} .btn{
        ${this.width(widthTablet)}
        ${this.height(heightTablet)}
        ${this.fontSize(typoSizeTablet)}
        ${this.padding(paddingTablet)}
        ${this.textAlign(textAlignTablet)}
        ${this.justifyContent(textAlignTablet)}
      }
       .button-${id} .btn .btn-icon{
          ${this.width(iconSizeTablet)}
          ${this.height(iconSizeTablet)}
          ${this.padding(iconPaddingTablet)}
        }
    }

    /* Mobile */
    @media (max-width: 767px) {
      .button-${id}{
        ${this.justifyContent(alignMobile)}
      }
      .button-${id} .btn{
        ${this.width(widthMobile)}
        ${this.height(heightMobile)}
        ${this.fontSize(typoSizeMobile)}
        ${this.padding(paddingMobile)}
        ${this.textAlign(textAlignMobile)}
        ${this.justifyContent(textAlignMobile)}
      }
       .button-${id} .btn .btn-icon{
          ${this.width(iconSizeMobile)}
          ${this.height(iconSizeMobile)}
          ${this.padding(iconPaddingMobile)}
        }
    }

    `;
  }

  animation(animation, duration, mode, delay, direction) {
    if (animation) {
      return `animation: ${animation} ${duration ? duration : "2s"} ${
        mode ?? ""
      } ${delay ? delay : "0s"} ${direction ?? ""};`;
    }
    return "";
  }

  animationPlayState(val) {
    if (val) {
      return `animation-play-state: ${val};`;
    }
    return "";
  }

  transitionTimingFunction(val) {
    if (val) {
      return `transition-timing-function: ${val};`;
    }
    return "";
  }

  animationTimingFunction(val) {
    if (val) {
      return `animation-timing-function: ${val};`;
    }
    return "";
  }

  transitionDelay(val) {
    if (val) {
      return `transition-delay: ${val};`;
    }
    return "";
  }

  transition(val) {
    if (val) {
      return `transition: ${val};`;
    }
    return "";
  }

  backfaceVisibility(val) {
    if (val) {
      return `backface-visibility: ${val};`;
    }
    return "";
  }

  transformStyle(val) {
    if (val) {
      return `transform-style: ${val};`;
    }
    return "";
  }

  transformOrigin(val) {
    if (val) {
      return `transform-origin: ${val};`;
    }
    return "";
  }

  transformFn(wrapper, value) {
    if (wrapper && value) {
      return `${wrapper}(${value})`;
    }
    return ``;
  }

  transform(functions) {
    if (functions && functions.length) {
      var transformLiteral = functions
        .map((fn) => {
          return this.transformFn(fn.wrapper, fn.value);
        })
        .join(" ")
        .trim();

      if (transformLiteral) {
        return `transform: ${transformLiteral};`;
      }

      return ``;
    }
    return ``;
  }

  blockCSS__Navigation(id, props) {
    const {
      menuTrigger = "tablet",
      menuIconSize = "26px",
      menuIconBorder,
      menuIconBorderRadius,
      menuIconPadding = {
        top: "8px",
        bottom: "8px",
        right: "8px",
        left: "8px",
      },
      menuIconColor,
      menuIconBackgroundColor,
      menuDirection = "row",
      menuWrap = "wrap",
      menuJustifyContent = "start",
      menuAlignItems = "center",
      menuGap = "1rem",
      portalPadding = {
        top: "20px",
        bottom: "20px",
        left: "20px",
        right: "20px",
      },
      portalGap = "1rem",
      portalWidth = "100vw",
      portalHeight,
      portalAlign,
      portalSelfAlign,
      portalCloseIconColor,
      portalCloseIconAlign,
      portalColor,
      portalBackgroundColor = "#E8E8E8",
      hoverPortalColor,
      hoverPortalBackgroundColor,
      hoverPortalCloseIconColor,
      hoverMenuIconBorder,
      hoverMenuIconBorderRadius,
      hoverMenuIconColor,
      hoverMenuIconBackgroundColor,
    } = props;
    return `
    .navigation-portal-${id} {
      ${
        process.env.GRIGORA_SERVICE !== "renderer"
          ? ""
          : `${this.display("none")}`
      }
      ${this.justifyContent(portalSelfAlign)}
    }
    .navigation-portal-${id} > .childrens{
      ${this.transitionSupport(props)}
      ${this.padding(portalPadding)}
      ${this.blockGap(portalGap)}
      ${this.width(portalWidth)}
      ${this.height(portalHeight)}
      ${this.justifyContent(portalAlign)}
      ${this.textAlign(portalAlign)}
      ${this.color(portalColor)}
      ${this.backgroundColor(portalBackgroundColor)}
    }

    .navigation-portal-${id} > .childrens:hover{
      ${this.color(hoverPortalColor)}
      ${this.backgroundColor(hoverPortalBackgroundColor)}
    }

    .navigation-portal-${id} > .childrens .close-icon{
      ${this.alignSelf(portalCloseIconAlign)}
      ${this.color(portalCloseIconColor)}
    }

    .navigation-portal-${id} > .childrens .close-icon:hover{
      ${this.color(hoverPortalCloseIconColor)}
    }

    .navigation-${id} > .childrens{
      ${this.flexDirection(menuDirection)}
      ${this.flexWrap(menuWrap)}
      ${this.justifyContent(menuJustifyContent)}
      ${
        menuDirection === "row" && menuWrap === "wrap"
          ? `${this.alignItems(menuAlignItems)}`
          : `${this.alignItems(menuAlignItems)}`
      }
      ${this.blockGap(menuGap)}
    }
    
    .navigation-${id} .menu-btn{
      ${this.transitionSupport(props)}
      ${this.border(
        menuIconBorder,
        hoverMenuIconBorder
          ? {
              top: {
                width: "0px",
                style: "solid",
                color: hoverMenuIconBorder?.top?.color,
              },
              bottom: {
                width: "0px",
                style: "solid",
                color: hoverMenuIconBorder?.bottom?.color,
              },
              left: {
                width: "0px",
                style: "solid",
                color: hoverMenuIconBorder?.left?.color,
              },
              right: {
                width: "0px",
                style: "solid",
                color: hoverMenuIconBorder?.right?.color,
              },
            }
          : undefined,
      )}
      ${this.borderRadius(menuIconBorderRadius)}
      ${this.padding(menuIconPadding)}
      ${this.backgroundColor(menuIconBackgroundColor)}
    }

    .navigation-${id} .menu-btn:hover{
      ${this.border(hoverMenuIconBorder)}
      ${this.borderRadius(hoverMenuIconBorderRadius)}
      ${this.backgroundColor(hoverMenuIconBackgroundColor)}
    }

    .navigation-${id} .menu-btn svg{
      ${this.transitionSupport(props)}
      ${this.width(menuIconSize)}
      ${this.height(menuIconSize)}
      ${this.color(menuIconColor)}
    }
    
    .navigation-${id} .menu-btn:hover svg{
      ${this.color(hoverMenuIconColor)}
    }

    ${
      menuTrigger === "desktop"
        ? `
      .navigation-portal-${id}.active{
        display: flex;
      }
      .navigation-${id} > .childrens{
        display: none;
      }
      .navigation-${id} .menu-btn{
        display: inline-block;
      }
      `
        : ``
    }
    ${
      menuTrigger === "tablet"
        ? `
      @media only screen and (max-width: 1024px) {
        .navigation-portal-${id}.active{
          display: flex;
        }
        .navigation-${id} > .childrens{
          display: none;
        }
        .navigation-${id} .menu-btn{
          display: inline-block;
        }
      }
      `
        : ``
    }
    ${
      menuTrigger === "mobile"
        ? `
      @media only screen and (max-width: 769px) {
        .navigation-portal-${id}.active{
          display: flex;
        }
        .navigation-${id} > .childrens{
          display: none;
        }
        .navigation-${id} .menu-btn{
          display: inline-block;
        }
      }
      `
        : ``
    }
    
    `;
  }

  blockCSS__Column(id, props) {
    const {
      width,
      align,
      textColor,
      backgroundColor,
      typoSize,
      typoLineHeight,
      typoLetterSpacing,
      typoWordSpacing,
      typoWeight,
      typoTransform,
      typoDecoration,
      typoStyle,
      border,
      borderTablet,
      borderMobile,
      borderRadius,
      layoutPadding,
      layoutPaddingTablet,
      layoutPaddingMobile,
      boxShadow,
      blockGap = "1rem",
      hoverTextColor,
      hoverBackgroundColor,
      hoverBorder,
      hoverBorderTablet,
      hoverBorderMobile,
      hoverBorderRadius,
    } = props;
    return `
    
    .column-${id}{
      ${this.transitionSupport(props)}
      ${this.flexBasis(width)}
      ${this.alignSelf(align)}
      ${this.color(textColor)}
      ${this.backgroundColor(backgroundColor)}
      ${this.fontSize(typoSize)}
      ${this.fontWeight(typoWeight)}
      ${this.fontStyle(typoStyle)}
      ${this.lineHeight(typoLineHeight)}
      ${this.letterSpacing(typoLetterSpacing)}
      ${this.textDecoration(typoDecoration)}
      ${this.textTransform(typoTransform)}
      ${this.wordSpacing(typoWordSpacing)}
      ${this.borderRadius(borderRadius)}
      ${this.padding(layoutPadding)}
      ${this.border(border)}
      ${this.boxShadow(this.boxShadowCSS(boxShadow))}
    }
    .column-${id} > .childrens > * + * {
      ${this.marginBlockStart(blockGap)}
    }

    .column-${id}:hover{
      ${this.color(hoverTextColor)}
      ${this.backgroundColor(hoverBackgroundColor)}
      ${this.border(
        hoverBorder,
        hoverBorder
          ? {
              top: {
                width: "0px",
                style: "solid",
                color: hoverBorder?.top?.color,
              },
              bottom: {
                width: "0px",
                style: "solid",
                color: hoverBorder?.bottom?.color,
              },
              left: {
                width: "0px",
                style: "solid",
                color: hoverBorder?.left?.color,
              },
              right: {
                width: "0px",
                style: "solid",
                color: hoverBorder?.right?.color,
              },
            }
          : undefined,
      )}
      ${this.borderRadius(hoverBorderRadius)}
    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .column-${id} {
        ${this.flexBasis(width)}
        ${this.border(borderTablet)}
        ${this.padding(layoutPaddingTablet)}
      }
      .column-${id}:hover{
        ${this.border(hoverBorderTablet)}
      }
    }

    /* Mobile */
    @media (max-width: 767px) {
      .column-${id} {
        ${this.border(borderMobile)}
        ${this.padding(layoutPaddingMobile)}
      }
      .column-${id}:hover{
        ${this.border(hoverBorderMobile)}
      }
    }
    
    `;
  }

  blockCSS__CMSTemplate(id, props) {
    const {
      align,
      textColor,
      backgroundColor,
      typoSize,
      typoLineHeight,
      typoLetterSpacing,
      typoWordSpacing,
      typoWeight,
      typoTransform,
      typoDecoration,
      typoStyle,
      border,
      borderTablet,
      borderMobile,
      borderRadius,
      layoutPadding,
      layoutPaddingTablet,
      layoutPaddingMobile,
      boxShadow,
      blockGap = "1rem",
    } = props;
    return `
    .cms-template-${id}{
      ${this.alignSelf(align)}
      ${this.color(textColor)}
      ${this.backgroundColor(backgroundColor)}
      ${this.fontSize(typoSize)}
      ${this.fontWeight(typoWeight)}
      ${this.fontStyle(typoStyle)}
      ${this.lineHeight(typoLineHeight)}
      ${this.letterSpacing(typoLetterSpacing)}
      ${this.textDecoration(typoDecoration)}
      ${this.textTransform(typoTransform)}
      ${this.wordSpacing(typoWordSpacing)}
      ${this.borderRadius(borderRadius)}
      ${this.padding(layoutPadding)}
      ${this.border(border)}
      ${this.boxShadow(this.boxShadowCSS(boxShadow))}
    }
    .cms-template-${id} > .childrens > * + * {
      ${this.marginBlockStart(blockGap)}
    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .cms-template-${id} {
        ${this.border(borderTablet)}
        ${this.padding(layoutPaddingTablet)}
      }
    }

    /* Mobile */
    @media (max-width: 767px) {
      .cms-template-${id} {
        ${this.border(borderMobile)}
        ${this.padding(layoutPaddingMobile)}
      }
    }
    
    `;
  }

  blockCSS__DirectoryTemplate(id, props) {
    const {
      align,
      textColor,
      backgroundColor,
      typoSize,
      typoLineHeight,
      typoLetterSpacing,
      typoWordSpacing,
      typoWeight,
      typoTransform,
      typoDecoration,
      typoStyle,
      border,
      borderTablet,
      borderMobile,
      borderRadius,
      layoutPadding,
      layoutPaddingTablet,
      layoutPaddingMobile,
      boxShadow,
      blockGap = "1rem",
    } = props;
    return `
    .directory-template-${id}{
      ${this.alignSelf(align)}
      ${this.color(textColor)}
      ${this.backgroundColor(backgroundColor)}
      ${this.fontSize(typoSize)}
      ${this.fontWeight(typoWeight)}
      ${this.fontStyle(typoStyle)}
      ${this.lineHeight(typoLineHeight)}
      ${this.letterSpacing(typoLetterSpacing)}
      ${this.textDecoration(typoDecoration)}
      ${this.textTransform(typoTransform)}
      ${this.wordSpacing(typoWordSpacing)}
      ${this.borderRadius(borderRadius)}
      ${this.padding(layoutPadding)}
      ${this.border(border)}
      ${this.boxShadow(this.boxShadowCSS(boxShadow))}
    }
    .directory-template-${id} > .childrens > * + * {
      ${this.marginBlockStart(blockGap)}
    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .directory-template-${id} {
        ${this.border(borderTablet)}
        ${this.padding(layoutPaddingTablet)}
      }
    }

    /* Mobile */
    @media (max-width: 767px) {
      .directory-template-${id} {
        ${this.border(borderMobile)}
        ${this.padding(layoutPaddingMobile)}
      }
    }
    
    `;
  }

  blockCSS__CategoryTemplate(id, props) {
    const {
      align,
      textColor,
      backgroundColor,
      typoSize,
      typoLineHeight,
      typoLetterSpacing,
      typoWordSpacing,
      typoWeight,
      typoTransform,
      typoDecoration,
      typoStyle,
      border,
      borderTablet,
      borderMobile,
      borderRadius,
      layoutPadding,
      layoutPaddingTablet,
      layoutPaddingMobile,
      boxShadow,
      blockGap = "1rem",
    } = props;
    return `
    .category-template-${id}{
      ${this.alignSelf(align)}
      ${this.color(textColor)}
      ${this.backgroundColor(backgroundColor)}
      ${this.fontSize(typoSize)}
      ${this.fontWeight(typoWeight)}
      ${this.fontStyle(typoStyle)}
      ${this.lineHeight(typoLineHeight)}
      ${this.letterSpacing(typoLetterSpacing)}
      ${this.textDecoration(typoDecoration)}
      ${this.textTransform(typoTransform)}
      ${this.wordSpacing(typoWordSpacing)}
      ${this.borderRadius(borderRadius)}
      ${this.padding(layoutPadding)}
      ${this.border(border)}
      ${this.boxShadow(this.boxShadowCSS(boxShadow))}
    }
    .category-template-${id} > .childrens > * + * {
      ${this.marginBlockStart(blockGap)}
    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .category-template-${id} {
        ${this.border(borderTablet)}
        ${this.padding(layoutPaddingTablet)}
      }
    }

    /* Mobile */
    @media (max-width: 767px) {
      .category-template-${id} {
        ${this.border(borderMobile)}
        ${this.padding(layoutPaddingMobile)}
      }
    }
    
    `;
  }

  blockCSS__Columns(id, props) {
    const {
      blockGap = "1rem",
      blockGapTablet,
      blockGapMobile,
      textColor,
      backgroundColor,
      typoSize,
      typoLineHeight,
      typoLetterSpacing,
      typoWordSpacing,
      typoWeight,
      typoTransform,
      typoDecoration,
      typoStyle,
      border,
      borderRadius,
      layoutPadding,
      width,
      maxWidth,
      minWidth,
      alignItems,
      tabletColumnsCount = 1,
      mobileColumnsCount = 1,
      boxShadow,
      hoverBorder,
      hoverBorderRadius,
      hoverTextColor,
      hoverBackgroundColor,
    } = props;
    return `
    .columns-${id}{
      ${this.transitionSupport(props)}
      ${this.width(width)}
      ${this.minWidth(minWidth)}
      ${this.maxWidth(maxWidth)}
      ${this.blockGap(blockGap)}
      ${this.alignItems(alignItems)}
      ${this.color(textColor)}
      ${this.backgroundColor(backgroundColor)}
      ${this.fontSize(typoSize)}
      ${this.fontWeight(typoWeight)}
      ${this.fontStyle(typoStyle)}
      ${this.lineHeight(typoLineHeight)}
      ${this.letterSpacing(typoLetterSpacing)}
      ${this.textDecoration(typoDecoration)}
      ${this.textTransform(typoTransform)}
      ${this.wordSpacing(typoWordSpacing)}
      ${this.borderRadius(borderRadius)}
      ${this.border(border)}
      ${this.padding(layoutPadding)}
      ${this.boxShadow(this.boxShadowCSS(boxShadow))}
    }

    .columns-${id}:hover{
      ${this.color(hoverTextColor)}
      ${this.backgroundColor(hoverBackgroundColor)}
      ${this.borderRadius(hoverBorderRadius)}
      ${this.border(hoverBorder)}
    }

    @media only screen and (min-width: 769px) and (max-width: 1024px) {
      .columns-${id}{
        ${this.blockGap(blockGapTablet)}
      }
      .columns-${id}.collapse-tablet > .g-column{  
        ${this.flexBasis(
          `calc(${100 / tabletColumnsCount}% - ((${
            blockGapTablet ? blockGapTablet : blockGap
          }*${tabletColumnsCount - 1})/${tabletColumnsCount}))`,
        )}
      }
    }
    @media only screen and (max-width: 768px) {
      .columns-${id}{
        ${this.blockGap(blockGapMobile)}
      }
      .columns-${id}.collapse-mobile > .g-column{  
        ${this.flexBasis(
          `calc(${100 / mobileColumnsCount}% - ((${
            blockGapMobile ? blockGapMobile : blockGap
          }*${mobileColumnsCount - 1})/${mobileColumnsCount}))`,
        )}
      }
    }
    `;
  }

  blockCSS__Directory(id, props) {
    const {
      changesOnSearchQuery,
      blockGap = "1rem",
      blockGapTablet,
      blockGapMobile,
      textColor,
      backgroundColor,
      typoSize,
      typoLineHeight,
      typoLetterSpacing,
      typoWordSpacing,
      typoWeight,
      typoTransform,
      typoDecoration,
      typoStyle,
      border,
      borderRadius,
      layoutPadding,
      width,
      maxWidth,
      minWidth,
      alignItems,
      columns = 1,
      columnsTablet = 1,
      columnsMobile = 1,
      boxShadow,
    } = props;
    return `
    .directory-${id}{
      ${this.width(width)}
      ${this.minWidth(minWidth)}
      ${this.maxWidth(maxWidth)}
      ${this.blockGap(blockGap)}
      ${this.alignItems(alignItems)}
      ${this.color(textColor)}
      ${this.backgroundColor(backgroundColor)}
      ${this.fontSize(typoSize)}
      ${this.fontWeight(typoWeight)}
      ${this.fontStyle(typoStyle)}
      ${this.lineHeight(typoLineHeight)}
      ${this.letterSpacing(typoLetterSpacing)}
      ${this.textDecoration(typoDecoration)}
      ${this.textTransform(typoTransform)}
      ${this.wordSpacing(typoWordSpacing)}
      ${this.borderRadius(borderRadius)}
      ${this.border(border)}
      ${this.padding(layoutPadding)}
      ${this.boxShadow(this.boxShadowCSS(boxShadow))}
    }

    ${
      process.env.GRIGORA_SERVICE === "renderer" && changesOnSearchQuery
        ? `
      .directory-${id} > .g-directory-template{
        display: none;
      }
      `
        : ""
    }

    .directory-${id} > .g-directory-template{  
      ${this.flexBasis(
        `calc(${100 / columns}% - ((${blockGap ? blockGap : blockGap}*${
          columns - 1
        })/${columns}))`,
      )}
    }

    @media only screen and (min-width: 769px) and (max-width: 1024px) {
      .directory-${id}{
        ${this.blockGap(blockGapTablet)}
      }
      .directory-${id} > .g-directory-template{  
        ${this.flexBasis(
          `calc(${100 / columnsTablet}% - ((${
            blockGapTablet ? blockGapTablet : blockGap
          }*${columnsTablet - 1})/${columnsTablet}))`,
        )}
      }
    }
    @media only screen and (max-width: 768px) {
      .directory-${id}{
        ${this.blockGap(blockGapMobile)}
      }
      .directory-${id} > .g-directory-template{  
        ${this.flexBasis(
          `calc(${100 / columnsMobile}% - ((${
            blockGapMobile ? blockGapMobile : blockGap
          }*${columnsMobile - 1})/${columnsMobile}))`,
        )}
      }
    }
    `;
  }

  blockCSS__CMS(id, props) {
    const {
      changesOnSearchQuery,
      blockGap = "1rem",
      blockGapTablet,
      blockGapMobile,
      textColor,
      backgroundColor,
      typoSize,
      typoLineHeight,
      typoLetterSpacing,
      typoWordSpacing,
      typoWeight,
      typoTransform,
      typoDecoration,
      typoStyle,
      border,
      borderRadius,
      layoutPadding,
      width,
      maxWidth,
      minWidth,
      alignItems,
      columns = 1,
      columnsTablet = 1,
      columnsMobile = 1,
      boxShadow,
    } = props;
    return `
    .cms-${id}{
      ${this.width(width)}
      ${this.minWidth(minWidth)}
      ${this.maxWidth(maxWidth)}
      ${this.blockGap(blockGap)}
      ${this.alignItems(alignItems)}
      ${this.color(textColor)}
      ${this.backgroundColor(backgroundColor)}
      ${this.fontSize(typoSize)}
      ${this.fontWeight(typoWeight)}
      ${this.fontStyle(typoStyle)}
      ${this.lineHeight(typoLineHeight)}
      ${this.letterSpacing(typoLetterSpacing)}
      ${this.textDecoration(typoDecoration)}
      ${this.textTransform(typoTransform)}
      ${this.wordSpacing(typoWordSpacing)}
      ${this.borderRadius(borderRadius)}
      ${this.border(border)}
      ${this.padding(layoutPadding)}
      ${this.boxShadow(this.boxShadowCSS(boxShadow))}
    }

    ${
      process.env.GRIGORA_SERVICE === "renderer" && changesOnSearchQuery
        ? `
      .cms-${id} > .g-cms-template{
        display: none;
      }
      `
        : ""
    }

    .cms-${id} > .g-cms-template{  
      ${this.flexBasis(
        `calc(${100 / columns}% - ((${blockGap ? blockGap : blockGap}*${
          columns - 1
        })/${columns}))`,
      )}
    }

    @media only screen and (min-width: 769px) and (max-width: 1024px) {
      .cms-${id}{
        ${this.blockGap(blockGapTablet)}
      }
      .cms-${id} > .g-cms-template{  
        ${this.flexBasis(
          `calc(${100 / columnsTablet}% - ((${
            blockGapTablet ? blockGapTablet : blockGap
          }*${columnsTablet - 1})/${columnsTablet}))`,
        )}
      }
    }
    @media only screen and (max-width: 768px) {
      .cms-${id}{
        ${this.blockGap(blockGapMobile)}
      }
      .cms-${id} > .g-cms-template{  
        ${this.flexBasis(
          `calc(${100 / columnsMobile}% - ((${
            blockGapMobile ? blockGapMobile : blockGap
          }*${columnsMobile - 1})/${columnsMobile}))`,
        )}
      }
    }
    `;
  }

  blockCSS__Category(id, props) {
    const {
      blockGap = "1rem",
      blockGapTablet,
      blockGapMobile,
      textColor,
      backgroundColor,
      typoSize,
      typoLineHeight,
      typoLetterSpacing,
      typoWordSpacing,
      typoWeight,
      typoTransform,
      typoDecoration,
      typoStyle,
      border,
      borderRadius,
      layoutPadding,
      width,
      maxWidth,
      minWidth,
      alignItems,
      columns = 1,
      columnsTablet = 1,
      columnsMobile = 1,
      boxShadow,
    } = props;
    return `
    .category-${id}{
      ${this.width(width)}
      ${this.minWidth(minWidth)}
      ${this.maxWidth(maxWidth)}
      ${this.blockGap(blockGap)}
      ${this.alignItems(alignItems)}
      ${this.color(textColor)}
      ${this.backgroundColor(backgroundColor)}
      ${this.fontSize(typoSize)}
      ${this.fontWeight(typoWeight)}
      ${this.fontStyle(typoStyle)}
      ${this.lineHeight(typoLineHeight)}
      ${this.letterSpacing(typoLetterSpacing)}
      ${this.textDecoration(typoDecoration)}
      ${this.textTransform(typoTransform)}
      ${this.wordSpacing(typoWordSpacing)}
      ${this.borderRadius(borderRadius)}
      ${this.border(border)}
      ${this.padding(layoutPadding)}
      ${this.boxShadow(this.boxShadowCSS(boxShadow))}
    }

    .category-${id} > .g-category-template{  
      ${this.flexBasis(
        `calc(${100 / columns}% - ((${blockGap ? blockGap : blockGap}*${
          columns - 1
        })/${columns}))`,
      )}
    }

    @media only screen and (min-width: 769px) and (max-width: 1024px) {
      .category-${id}{
        ${this.blockGap(blockGapTablet)}
      }
      .category-${id} > .g-category-template{  
        ${this.flexBasis(
          `calc(${100 / columnsTablet}% - ((${
            blockGapTablet ? blockGapTablet : blockGap
          }*${columnsTablet - 1})/${columnsTablet}))`,
        )}
      }
    }
    @media only screen and (max-width: 768px) {
      .category-${id}{
        ${this.blockGap(blockGapMobile)}
      }
      .category-${id} > .g-category-template{  
        ${this.flexBasis(
          `calc(${100 / columnsMobile}% - ((${
            blockGapMobile ? blockGapMobile : blockGap
          }*${columnsMobile - 1})/${columnsMobile}))`,
        )}
      }
    }
    `;
  }

  blockCSS__CountUp(id, props) {
    const {
      align,
      typoSize = "50px",
      typoLineHeight,
      typoLetterSpacing,
      typoWordSpacing,
      typoWeight,
      typoTransform,
      typoDecoration,
      typoStyle,
      textColor,
      hoverTextColor,
    } = props;
    return `

    .count-up-${id} {
      ${this.transitionSupport(props)}
      ${this.textAlign(align)}
      ${this.fontSize(typoSize)}
      ${this.fontSize(typoSize)}
      ${this.fontWeight(typoWeight)}
      ${this.fontStyle(typoStyle)}
      ${this.lineHeight(typoLineHeight)}
      ${this.letterSpacing(typoLetterSpacing)}
      ${this.textTransform(typoTransform)}
      ${this.wordSpacing(typoWordSpacing)}  
      ${this.color(textColor)}
    }
    .count-up-${id} span{
      ${this.textDecoration(typoDecoration)}
    }
    .count-up-${id}:hover{
      ${this.color(hoverTextColor)}
    }

    `;
  }
  blockCSS__Quote(id, props, isPostEditor = false) {
    const {
      typoSize,
      typoSizeTablet,
      typoSizeMobile,
      typoLineHeight,
      typoLetterSpacing,
      typoWordSpacing,
      typoWeight,
      typoTransform,
      typoDecoration,
      typoStyle,
      backgroundColor,
      textColor,
      containerBorder,
      quoteColor,
      containerPadding,
      containerPaddingTablet,
      containerPaddingMobile,
      containerMargin,
      containerMarginTablet,
      containerMarginMobile,
      quoteBoxShadow,
      quoteBorder,
      citationColor,
      quoteDesign,
      quoteSize,
      quoteSizeTablet,
      quoteSizeMobile,
      quotePadding,
      quotePaddingMobile,
      quotePaddingTablet,
      quoteOpacity,
      linkColor,
    } = props;

    return `

    ${
      quoteDesign === "design-1"
        ? `
    
    ${
      isPostEditor ? ".grigora-editor-renderer-canvas" : ""
    } .quote-${id}.design-1 .quote{
      ${this.backgroundColor(backgroundColor)}
      ${this.color(textColor)}
      ${this.padding(quotePadding)}
    }
    
    ${
      isPostEditor ? ".grigora-editor-renderer-canvas" : ""
    } .quote-${id}.design-1 .quote::before{
      ${this.opacity(quoteOpacity)}
      ${this.fontSize(quoteSize)}
      ${this.color(quoteColor)}
      ${this.backgroundColor(backgroundColor)}
    }


    `
        : quoteDesign === "design-2"
        ? `

     ${
       isPostEditor ? ".grigora-editor-renderer-canvas" : ""
     } .quote-${id}.design-2 .quote{
      ${this.padding(quotePadding)}
      ${this.color(textColor)}
      ${this.border(quoteBorder)}
      ${this.backgroundColor(backgroundColor)}
      ${this.boxShadow(this.boxShadowCSS(quoteBoxShadow))}
    }

    `
        : quoteDesign === "design-3"
        ? `

     ${
       isPostEditor ? ".grigora-editor-renderer-canvas" : ""
     } .quote-${id}.design-3 .quote{
      ${this.backgroundColor(backgroundColor)}
      ${backgroundColor ? this.backgroundImage("none") : ""}
    }
    
     ${
       isPostEditor ? ".grigora-editor-renderer-canvas" : ""
     } .quote-${id}.design-3 .quote p{
      ${this.color(textColor)}
    }

     ${
       isPostEditor ? ".grigora-editor-renderer-canvas" : ""
     } .quote-${id}.design-3 .quote::before{
       ${this.fontSize(quoteSize)}
       ${this.opacity(quoteOpacity)}
       ${this.color(quoteColor)}
    }

     ${
       isPostEditor ? ".grigora-editor-renderer-canvas" : ""
     } .quote-${id}.design-3 .quote p::after {
       ${this.fontSize(quoteSize)}
       ${this.opacity(quoteOpacity)}
       ${this.color(quoteColor)}
    }

     ${
       isPostEditor ? ".grigora-editor-renderer-canvas" : ""
     } .quote-${id}.design-3 .quote cite{
      ${this.color(citationColor)}
    }
  
    `
        : quoteDesign === "design-4"
        ? `
    
     ${
       isPostEditor ? ".grigora-editor-renderer-canvas" : ""
     } .quote-${id}.design-4 .quote{
      ${this.boxShadow(this.boxShadowCSS(quoteBoxShadow))}
      ${this.padding(quotePadding)}
      ${this.color(textColor)}
      ${this.border(quoteBorder)}
      ${this.backgroundColor(backgroundColor)}
    }
    
    `
        : quoteDesign === "design-5"
        ? `

     ${
       isPostEditor ? ".grigora-editor-renderer-canvas" : ""
     } .quote-${id}.design-5 .quote{
      ${this.backgroundColor(backgroundColor)}
      ${this.color(textColor)}
      ${this.border(quoteBorder)}
      ${this.padding(quotePadding)}
      ${this.boxShadow(this.boxShadowCSS(quoteBoxShadow))}
    }
    `
        : `

     ${
       isPostEditor ? ".grigora-editor-renderer-canvas" : ""
     } .quote-${id} .quote:before {
      ${this.color(quoteColor)}
      ${this.opacity(quoteOpacity)}
      ${this.fontSize(quoteSize)}
    } 

    `
    }

    ${
      isPostEditor ? ".grigora-editor-renderer-canvas" : ""
    } .quote-${id} .quote cite{
      ${this.color(citationColor)}
    }

    ${isPostEditor ? ".grigora-editor-renderer-canvas" : ""} .quote-${id} p{
      ${this.textDecoration(typoDecoration)}
      ${this.fontSize(typoSize)}
      ${this.fontWeight(typoWeight)}
      ${this.fontStyle(typoStyle)}
      ${this.lineHeight(typoLineHeight)}
      ${this.letterSpacing(typoLetterSpacing)}
      ${this.textTransform(typoTransform)}
      ${this.wordSpacing(typoWordSpacing)}  
      ${this.color(textColor)}
    }

    ${
      isPostEditor ? ".grigora-editor-renderer-canvas" : ""
    } .quote-${id} .quote{
      ${this.border(containerBorder)}
      ${this.padding(containerPadding)}
      ${this.margin(containerMargin)}
      ${this.backgroundColor(backgroundColor)}
    }

    .quote-${id} .quote .grigora-richtext-input .grigora-richtext-input__field a{
      ${this.color(linkColor)}
    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
     
        ${
          quoteDesign === "design-1"
            ? `
        
          .quote-${id} .quote::after{
            ${this.fontSize(quoteSize)}
          }

        `
            : quoteDesign === "design-2"
            ? `

          .quote-${id} .quote{
            ${this.padding(quotePadding)}
          }

        `
            : quoteDesign === "design-3"
            ? `

          .quote-${id} .quote::before{
            ${this.fontSize(quoteSize)}
          }

          .quote-${id} .quote p::after {
            ${this.fontSize(quoteSize)}
          }

        `
            : quoteDesign === "design-4"
            ? `
        
          .quote-${id} .quote{
            ${this.padding(quotePadding)}
          }
        
        `
            : quoteDesign === "design-5"
            ? `

          .quote-${id} .quote{
            ${this.padding(quotePadding)}
          }

        `
            : `
          .quote-${id} .quote:before {
            ${this.fontSize(quoteSize)}
          } 
        `
        }

          .quote-${id}{
            ${this.padding(containerPadding)}
            ${this.margin(containerMargin)}
          }

          .quote-${id} p{
            ${this.fontSize(typoSize)}
          }
    }
     /* Mobile */
    @media (max-width: 767px) {
     
        ${
          quoteDesign === "design-1"
            ? `
        
            .quote-${id} .quote::after{
              ${this.fontSize(quoteSize)}
            }

        `
            : quoteDesign === "design-2"
            ? `

            .quote-${id} .quote{
              ${this.padding(quotePadding)}
            }

        `
            : quoteDesign === "design-3"
            ? `

            .quote-${id} .quote::before{
              ${this.fontSize(quoteSize)}
            }

            .quote-${id} .quote p::after {
              ${this.fontSize(quoteSize)}
            }
        
        `
            : quoteDesign === "design-4"
            ? `
        
            .quote-${id} .quote{
              ${this.padding(quotePadding)}
            }
        
        `
            : quoteDesign === "design-5"
            ? `

            .quote-${id} .quote{
              ${this.padding(quotePadding)}
            }

        `
            : `
            .quote-${id} .quote:before {
              ${this.fontSize(quoteSize)}
            } 
        `
        }

          .quote-${id}{
            ${this.padding(containerPadding)}
            ${this.margin(containerMargin)}
          }

          .quote-${id} .quote{
            ${this.backgroundColor(backgroundColor)}
          }

          .quote-${id} p{
            ${this.fontSize(typoSize)}
          }
    }
    `;
  }

  blockCSS__Code(id, props) {
    const {
      textColor,
      backgroundColor,
      typoSize,
      typoSizeTablet,
      typoSizeMobile,
      layoutPadding,
      linkColor,
    } = props;
    return `
    .code-${id} .grigora-richtext-input{
      ${this.padding(layoutPadding)}
    }
    .code-${id} .grigora-richtext-input code{
      ${this.fontSize(typoSize)}
      ${this.color(textColor)}
      ${this.backgroundColor(backgroundColor)}
    }
    .code-${id} .grigora-richtext-input code a{
      ${this.color(linkColor)}
    }
      
    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
       .code-${id} .grigora-richtext-input code{
         ${this.fontSize(typoSizeTablet)}
       }
    }
    
    /* Mobile */
    @media (max-width: 767px) {
       .code-${id} .grigora-richtext-input code{
         ${this.fontSize(typoSizeMobile)}
       }
    }
    
    `;
  }

  blockCSS__StarRating(id, props) {
    const {
      iconSize = 20,
      iconSpacing,
      align,
      activeColor = "#ffa500",
      inactiveColor = "#000000",
      verticalAlign,
    } = props;
    return `

    .star-rating-${id} .star-rating-container{
      ${this.blockGap(iconSpacing ? iconSpacing + "px" : "")}
      ${this.justifyContent(align)} 
      ${this.alignItems(verticalAlign)} 
    }

    .star-rating-${id} .star-rating-container .star .star-icon{
      ${this.width(iconSize + "px")}
      ${this.height(iconSize + "px")}
    }

    .star-rating-${id} .star-rating-container .star .star-icon{
      ${this.color(inactiveColor)}
    }

    .star-rating-${id}  .star-rating-container .star .star-icon.on{
      ${this.color(activeColor)}
    }
    `;
  }

  blockCSS__Table(id, props) {
    const {} = props;
    return `
    `;
  }

  blockCSS__List(id, props) {
    const {
      textColor,
      backgroundColor,
      typoSize,
      typoSizeTablet,
      typoSizeMobile,
      typoLineHeight,
      typoLetterSpacing,
      typoWordSpacing,
      typoTransform,
      typoStyle,
      typoDecoration,
      typoWeight,
      listType = "ul",
      layoutMargin,
      layoutPadding,
      hoverTextColor,
      hoverBackgroundColor,
      linkColor,
    } = props;
    return `
    .list-${id} {
      ${this.transitionSupport(props)}
      ${this.backgroundColor(backgroundColor)}
    }

    .list-${id}:hover {
      ${this.backgroundColor(hoverBackgroundColor)}
    }

    .list-${id} ${listType === "sort" ? "ol" : listType}{
     ${this.listStyleType(listType)}
     ${this.padding(layoutPadding)} 
     ${this.margin(layoutMargin)} 
     ${this.color(textColor)}
    }

    .list-${id} p{
      ${this.textDecoration(typoDecoration)}
      ${this.fontSize(typoSize)}
      ${this.fontSize(typoSize)}
      ${this.fontWeight(typoWeight)}
      ${this.fontStyle(typoStyle)}
      ${this.lineHeight(typoLineHeight)}
      ${this.letterSpacing(typoLetterSpacing)}
      ${this.textTransform(typoTransform)}
      ${this.wordSpacing(typoWordSpacing)}  
      ${this.color(textColor)}
    }

    .list-${id} .c li,p{
      ${this.transitionSupport(props)}
    }

    .list-${id} .c li:hover,p:hover{
      ${this.color(hoverTextColor)}
    }

    .list-${id} ${listType === "sort" ? "ol" : listType} li p a{
      ${this.color(linkColor)}
    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .list-${id} p{
        ${this.fontSize(typoSizeTablet)}
      }
    }
    
    /* Mobile */
    @media (max-width: 767px) {
      .list-${id} p{
        ${this.fontSize(typoSizeMobile)}
      }
    }

    `;
  }

  blockCSS__Icon(id, props) {
    const {
      align,
      size,
      sizeMobile,
      sizeTablet,
      color,
      padding,
      margin,
      hoverColor,
      hoverPadding,
      hoverMargin,
    } = props;
    return `

    .icon-${id}{
      ${this.justifyContent(align)}
    }

    .icon-${id} svg{
      ${this.color(color)}
      ${this.padding(padding)}
      ${this.margin(margin)}
      ${this.width(size)}
      ${this.height(size)}
      ${this.transitionSupport(props)}
    }
    
    .icon-${id} svg:hover{
      ${this.color(hoverColor)}
      ${this.padding(hoverPadding)}
      ${this.margin(hoverMargin)}
    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
        .icon-${id} svg{
          ${this.width(sizeTablet)}
          ${this.height(sizeTablet)}
        }
    }
    
    /* Mobile */
    @media (max-width: 767px) {
        .icon-${id} svg{
          ${this.width(sizeMobile)}
          ${this.height(sizeMobile)}
        }
    }

    `;
  }

  blockCSS__Table(id, props) {
    const {
      typoSize,
      typoSizeTablet,
      typoSizeMobile,
      typoLineHeight,
      typoLetterSpacing,
      typoWordSpacing,
      typoTransform,
      typoStyle,
      typoDecoration,
      typoWeight,
      textColor,
      backgroundColor,
      headerTextColor,
      headerBackgroundColor,
      footerTextColor,
      footerBackgroundColor,
      layoutPadding,
      layoutPaddingTablet,
      layoutPaddingMobile,
      layoutMargin,
      layoutMarginTablet,
      layoutMarginMobile,
      linkColor,
    } = props;
    return `

    .table-${id} table tbody tr td .grigora-richtext-input .grigora-richtext-input__field{
      ${this.textDecoration(typoDecoration)}
      ${this.fontSize(typoSize)}
      ${this.fontWeight(typoWeight)}
      ${this.fontStyle(typoStyle)}
      ${this.lineHeight(typoLineHeight)}
      ${this.letterSpacing(typoLetterSpacing)}
      ${this.textTransform(typoTransform)}
      ${this.wordSpacing(typoWordSpacing)}  
      ${this.color(textColor)}
    }

    .table-${id} table{
      ${this.backgroundColor(backgroundColor)}
    }

    .table-${id} table thead tr th .grigora-richtext-input .grigora-richtext-input__field{
      ${this.color(headerTextColor)}
    }

    .table-${id} table thead tr th .grigora-richtext-input .grigora-richtext-input__field a, tbody tr td .grigora-richtext-input .grigora-richtext-input__field a, tfoot tr td .grigora-richtext-input .grigora-richtext-input__field a{
      ${this.color(linkColor)}
    }

    .table-${id} table thead{
      ${this.backgroundColor(headerBackgroundColor)}
    }

    .table-${id} table tfoot tr td .grigora-richtext-input .grigora-richtext-input__field{
      ${this.color(footerTextColor)}
    }

    .table-${id} table tfoot{
      ${this.backgroundColor(footerBackgroundColor)}
    }
   
    .table-${id}{
      ${this.margin(layoutMargin)}
      ${this.padding(layoutPadding)}
    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .table-${id}{
        ${this.margin(layoutMarginTablet)}
        ${this.padding(layoutPaddingTablet)}
      }

      .table-${id} table tbody tr td .grigora-richtext-input .grigora-richtext-input__field{
        ${this.fontSize(typoSizeTablet)}
      }
    }
    
    /* Mobile */
    @media (max-width: 767px) {
      .table-${id}{
        ${this.margin(layoutMarginMobile)}
        ${this.padding(layoutPaddingMobile)}
      }

      .table-${id} table tbody tr td .grigora-richtext-input .grigora-richtext-input__field{
        ${this.fontSize(typoSizeMobile)}
      }
    }
    `;
  }

  blockCSS__Tab(id, props, activeTab) {
    const {
      initialOpen = 0,
      minHeight,
      maxWidth,
      align,
      tabsGap,
      tabContentGap,
      typoSize,
      typoLineHeight,
      typoLetterSpacing,
      typoWordSpacing,
      typoTransform,
      typoStyle,
      typoDecoration,
      typoWeight,
      titleTextColor,
      titleBackgroundColor,
      titlePadding = {
        top: "10px",
        botton: "20px",
        left: "10px",
        right: "20px",
      },
      titleMargin,
      contentBackgroundColor,
      contentPadding,
      contentMargin,
      contentBorder,
      titleBorderWidth,
      titleBorderStyle,
      titleBorderRadius,
      titleBorderColor,
      contentBorderWidth,
      contentBorderStyle,
      contentBorderRadius,
      contentBorderColor,
      tabPosition,
      linkColor,
    } = props;
    return `

    .tab-${id}{
      ${
        tabPosition === "top"
          ? this.flexDirection("column")
          : tabPosition === "bottom"
          ? this.flexDirection("column-reverse")
          : tabPosition === "left"
          ? this.flexDirection("row")
          : tabPosition === "right"
          ? this.flexDirection("row-reverse")
          : ""
      }
      ${this.blockGap(tabContentGap)} 
    }

    .tab-${id} .tab-title-container{
      ${
        tabPosition === "left" || tabPosition === "right"
          ? this.flexDirection("column")
          : ""
      }
      ${this.minHeight(minHeight)}
      ${this.maxWidth(maxWidth)}
      ${this.blockGap(tabsGap)}
      ${this.backgroundColor(titleBackgroundColor)} 
      ${this.color(titleTextColor)} 
      ${this.justifyContent(align)} 
    }

    .tab-${id} .tab-title-container .tab-title{
      ${this.borderWidth(titleBorderWidth)} 
      ${this.borderRadius(titleBorderRadius)} 
      ${this.borderColor(titleBorderColor)} 
      ${this.borderStyle(titleBorderStyle)} 
      ${this.margin(titleMargin)} 
      ${this.padding(titlePadding)} 
    }

    .tab-${id} .tab-title-container .tab-title p{
      ${this.textDecoration(typoDecoration)}
      ${this.fontSize(typoSize)}
      ${this.fontSize(typoSize)}
      ${this.fontWeight(typoWeight)}
      ${this.fontStyle(typoStyle)}
      ${this.lineHeight(typoLineHeight)}
      ${this.letterSpacing(typoLetterSpacing)}
      ${this.textTransform(typoTransform)}
      ${this.wordSpacing(typoWordSpacing)} 
    }

    .tab-${id} .tab-title-container .tab-title p a{
      ${this.color(linkColor)} 
    }

    .tab-${id} .tab-content-container{
      ${this.padding(contentPadding)} 
      ${this.margin(contentMargin)} 
      ${this.padding(contentPadding)} 
      ${this.border(contentBorder)} 
      ${this.borderWidth(contentBorderWidth)} 
      ${this.borderStyle(contentBorderStyle)} 
      ${this.borderRadius(contentBorderRadius)} 
      ${this.borderColor(contentBorderColor)} 
      ${this.backgroundColor(contentBackgroundColor)} 
    }

    .tab-${id} .tab-content-container .g-inner-tab:nth-child(${
      process.env.GRIGORA_SERVICE !== "renderer"
        ? Number(activeTab) + 1
        : Number(initialOpen) + 1
    }){
      ${this.display("block")} 
    }
    
    `;
  }

  blockCSS__FAQ(id, props) {
    const {
      listStyle = "ul",
      titleWrapper = "h3",
      questionTypoSize,
      questionTypoSizeTablet,
      questionTypoSizeMobile,
      questionTypoLineHeight,
      questionTypoLetterSpacing,
      questionTypoWordSpacing,
      questionTypoTransform,
      questionTypoStyle,
      questionTypoDecoration,
      questionTypoWeight,
      answerTypoSize,
      answerTypoSizeTablet,
      answerTypoSizeMobile,
      answerTypoLineHeight,
      answerTypoLetterSpacing,
      answerTypoWordSpacing,
      answerTypoTransform,
      answerTypoStyle,
      answerTypoDecoration,
      answerTypoWeight,
      questionColor,
      answerColor,
      questionBackgroundColor,
      answerBackgroundColor,
      layoutMargin,
      layoutPadding,
      border,
      hoverQuestionColor,
      hoverAnswerColor,
      hoverQuestionBackgroundColor,
      hoverAnswerBackgroundColor,
      hoverLayoutMargin,
      hoverLayoutPadding,
      hoverBorder,
      linkColor,
    } = props;
    return `

    .faq-${id} .faq-container{
      ${this.transitionSupport(props)}
      ${this.margin(layoutMargin)} 
      ${this.padding(layoutPadding)}
      ${this.border(border)}
    }

    .faq-${id} .faq-container:hover{
      ${this.transitionSupport(props)}
      ${this.margin(hoverLayoutMargin)} 
      ${this.padding(hoverLayoutPadding)}
      ${this.border(hoverBorder)}
    }

    .faq-${id} .faq-container .faq-question-container ${titleWrapper}{
      ${this.transitionSupport(props)}
      ${this.fontSize(questionTypoSize)}
      ${this.color(questionColor)}
      ${this.backgroundColor(questionBackgroundColor)}
      ${this.color(questionColor)}
      ${this.lineHeight(questionTypoLineHeight)}
      ${this.letterSpacing(questionTypoLetterSpacing)}
      ${this.wordSpacing(questionTypoWordSpacing)}
      ${this.fontWeight(questionTypoWeight)}
      ${this.textDecoration(questionTypoDecoration)}
      ${this.textTransform(questionTypoTransform)}
      ${this.fontStyle(questionTypoStyle)}
    }

    .faq-${id} .faq-container .faq-question-container ${titleWrapper}:hover{
      ${this.color(hoverQuestionColor)}
      ${this.backgroundColor(hoverQuestionBackgroundColor)}
    }

    .faq-${id} .faq-container .faq-answer-container p{
      ${this.transitionSupport(props)}
      ${this.fontSize(answerTypoSize)}
      ${this.color(answerColor)}
      ${this.backgroundColor(answerBackgroundColor)}
      ${this.lineHeight(answerTypoLineHeight)}
      ${this.letterSpacing(answerTypoLetterSpacing)}
      ${this.wordSpacing(answerTypoWordSpacing)}
      ${this.fontWeight(answerTypoWeight)}
      ${this.textDecoration(answerTypoDecoration)}
      ${this.textTransform(answerTypoTransform)}
      ${this.fontStyle(answerTypoStyle)}
    }

    .faq-${id} .faq-container .faq-answer-container p:hover{
      ${this.color(hoverAnswerColor)}
      ${this.backgroundColor(hoverAnswerBackgroundColor)}
    }

    .faq-${id} .faq-container .faq-question-container ${titleWrapper} a, .faq-answer-container p a{
      ${this.color(linkColor)}
    }
    
    /* Tablet  */
    @media (min-width: 768px) and (max-width: 1024px){
      .faq-${id} .faq-container .faq-question-container ${titleWrapper}{
        ${this.fontSize(questionTypoSizeTablet)}
      }
      .faq-${id} .faq-container .faq-answer-container p{
        ${this.fontSize(answerTypoSizeTablet)}
       }
    }

    /* Mobile */
    @media (max-width: 767px) {
        .faq-${id} .faq-container .faq-question-container ${titleWrapper}{
          ${this.fontSize(questionTypoSizeMobile)}
        }

      .faq-${id} .faq-container .faq-answer-container p{
        ${this.fontSize(answerTypoSizeMobile)}
      }

    } 

    `;
  }

  blockCSS__SiteLogo(id, props) {
    const {
      width,
      widthTablet,
      widthMobile,
      height,
      heightTablet,
      heightMobile,
      align,
      alignTablet,
      alignMobile,
      boxShadow,
      border,
      layoutPadding,
      layoutPaddingTablet,
      layoutPaddingMobile,
      layoutMargin,
      layoutMarginTablet,
      layoutMarginMobile,
      borderRadius,
      cssFilter,
    } = props;
    return `.site-logo-${id}{
      ${this.margin(layoutMargin)}
      ${this.padding(layoutPadding)}
      ${this.justifyContent(align)}
    }

     .site-logo-${id} img{
      ${this.width(width)}
      ${this.height(height)}
      ${this.border(border)}
      ${this.borderRadius(borderRadius)}
      ${this.boxShadow(this.boxShadowCSS(boxShadow))}
      ${this.filter(cssFilter)}
  }
  /* Tablet  */
  @media (min-width: 768px) and (max-width: 1024px) {
    .site-logo-${id}{
      ${this.margin(layoutMarginTablet)}
      ${this.padding(layoutPaddingTablet)}
      ${this.justifyContent(alignTablet)}
    }

    .site-logo-${id} img{
      ${this.width(widthTablet)}
      ${this.height(heightTablet)}
    }
  }
  
  /* Mobile */
  @media (max-width: 767px) {
    .site-logo-${id}{
      ${this.margin(layoutMarginMobile)}
      ${this.padding(layoutPaddingMobile)}
      ${this.justifyContent(alignMobile)}
    }

    .site-logo-${id} img{
      ${this.width(widthMobile)}
      ${this.height(heightMobile)}
    }
  }
  
  `;
  }

  blockCSS__SiteTitle(id, props) {
    const {
      align,
      alignTablet,
      alignMobile,
      layoutColumns,
      textColor,
      backgroundColor,
      typoSize,
      typoSizeTablet,
      typoSizeMobile,
      typoLineHeight,
      typoLetterSpacing,
      typoWordSpacing,
      typoTransform,
      typoStyle,
      typoDecoration,
      typoWeight,
      layoutPadding,
      layoutPaddingTablet,
      layoutPaddingMobile,
      layoutMargin,
      layoutMarginTablet,
      layoutMarginMobile,
      layoutColumnsGap,
      structureTag = "h1",
    } = props;

    return `.site-title-${id} ${structureTag} {
      ${this.fontSize(typoSize)}
      ${this.columnCount(layoutColumns)}
      ${this.color(textColor)}
      ${this.backgroundColor(backgroundColor)}
      ${this.lineHeight(typoLineHeight)}
      ${this.letterSpacing(typoLetterSpacing)}
      ${this.wordSpacing(typoWordSpacing)}
      ${this.fontWeight(typoWeight)}
      ${this.textDecoration(typoDecoration)}
      ${this.textTransform(typoTransform)}
      ${this.fontStyle(typoStyle)}
      ${this.padding(layoutPadding)}
      ${this.margin(layoutMargin)}
      ${this.textAlign(align)}
      ${this.columnGap(layoutColumnsGap)}
    }
    
    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .site-title-${id} ${
      process.env.GRIGORA_SERVICE !== "renderer" ? structureTag : ""
    }{
        ${this.fontSize(typoSizeTablet)}
        ${this.padding(layoutPaddingTablet)}
        ${this.margin(layoutMarginTablet)}
        ${this.textAlign(alignTablet)}
      }

    }
    
    /* Mobile */
    @media (max-width: 767px) {
      .site-title-${id} ${
      process.env.GRIGORA_SERVICE !== "renderer" ? structureTag : ""
    }{
        ${this.fontSize(typoSizeMobile)}
        ${this.padding(layoutPaddingMobile)}
        ${this.margin(layoutMarginMobile)}
        ${this.textAlign(alignMobile)}
      }

    }

    `;
  }

  blockCSS__TableOfContents(id, props) {
    const {
      typography,
      typographyActive,
      typographyHover,
      color,
      colorActive,
      colorHover,
      border,
      borderActive,
      borderHover,
      padding,
      paddingActive,
      paddingHover,
      gap,
      hasListIcon,
      iconColor,
      iconColorActive,
      iconColorHover,
      iconSize,
      iconSizeActive,
      iconSizeHover,
    } = props;

    return `

    ${
      hasListIcon
        ? `
      .table-of-contents-${id} .toc-list{
        ${this.listStyleType("none")}
      }

      .table-of-contents-${id} .toc-list .toc-list-item{
        ${this.display("flex")}
        ${this.alignItems("center")}
        ${this.gap("5px")}
      }
      
      .table-of-contents-${id} .toc-list .toc-list-item svg{
        ${this.color(iconColor)}
        ${this.width(iconSize)}
        ${this.height(iconSize)}
      }

      .table-of-contents-${id} .toc-list .toc-list-item:hover svg{
        ${this.color(iconColorHover)}
      }

      .table-of-contents-${id} .toc-list .list-active svg{
        ${this.color(iconColorActive)}
      }

    `
        : ""
    }
    
    .table-of-contents-${id} .toc-list .toc-list-item{
      ${this.padding(padding)}
      ${this.marginBottom(gap)}
    }

    .table-of-contents-${id} .toc-list .toc-list-item:hover{
      ${this.padding(paddingHover)}
    }
    
    .table-of-contents-${id} .toc-list .list-active{ 
      ${this.padding(paddingActive)}
    }

    .table-of-contents-${id} .toc-list .toc-list-item .toc-list-anchor{
      ${this.border(border)}
    }

    .table-of-contents-${id} .toc-list .toc-list-item .toc-list-anchor:hover{
      ${this.border(borderHover)}
    }

    .table-of-contents-${id} .toc-list .toc-list-item .active{
      ${this.border(borderActive)}
    }
    
    
      .table-of-contents-${id} .toc-list .toc-list-item, .toc-list-item .toc-list-anchor{
        ${this.transitionSupport(props)}
        ${this.fontSize(typography?.size)}
        ${this.color(color)}
        ${this.lineHeight(typography?.lineHeight)}
        ${this.letterSpacing(typography?.letterSpacing)}
        ${this.wordSpacing(typography?.wordSpacing)}
        ${this.fontWeight(typography?.weight)}
        ${this.textDecoration(typography?.decoration)}
        ${this.textTransform(typography?.transform)}
        ${this.fontStyle(typography?.style)}
      }

      .table-of-contents-${id} .toc-list .toc-list-item:hover, .toc-list-item:hover .toc-list-anchor{
        ${this.fontSize(typographyHover?.size)}
        ${this.color(colorHover)}
        ${this.lineHeight(typographyHover?.lineHeight)}
        ${this.letterSpacing(typographyHover?.letterSpacing)}
        ${this.wordSpacing(typographyHover?.wordSpacing)}
        ${this.fontWeight(typographyHover?.weight)}
        ${this.textDecoration(typographyHover?.decoration)}
        ${this.textTransform(typographyHover?.transform)}
        ${this.fontStyle(typographyHover?.style)}
      }

      .table-of-contents-${id} .toc-list .list-active, .list-active .active{
        ${this.fontSize(typographyActive?.size)}
        ${this.color(colorActive)}
        ${this.lineHeight(typographyActive?.lineHeight)}
        ${this.letterSpacing(typographyActive?.letterSpacing)}
        ${this.wordSpacing(typographyActive?.wordSpacing)}
        ${this.fontWeight(typographyActive?.weight)}
        ${this.textDecoration(typographyActive?.decoration)}
        ${this.textTransform(typographyActive?.transform)}
        ${this.fontStyle(typographyActive?.style)}
      }

    `;
  }

  blockCSS__PostTitle(id, props) {
    const {
      structureTag = "h1",
      align,
      alignTablet,
      alignMobile,
      textColor,
      backgroundColor,
      typoSize,
      typoSizeTablet,
      typoSizeMobile,
      typoLineHeight,
      typoLetterSpacing,
      typoWordSpacing,
      typoTransform,
      typoStyle,
      typoDecoration,
      typoWeight,
      layoutPadding,
      layoutPaddingTablet,
      layoutPaddingMobile,
      layoutMargin,
      layoutMarginTablet,
      layoutMarginMobile,
      hoverTextColor,
      hoverBackgroundColor,
    } = props;
    return `
    .post-title-${id} ${structureTag} {
      ${this.transitionSupport(props)}
      ${this.fontSize(typoSize)}
      ${this.color(textColor)}
      ${this.backgroundColor(backgroundColor)}
      ${this.lineHeight(typoLineHeight)}
      ${this.letterSpacing(typoLetterSpacing)}
      ${this.wordSpacing(typoWordSpacing)}
      ${this.fontWeight(typoWeight)}
      ${this.textDecoration(typoDecoration)}
      ${this.textTransform(typoTransform)}
      ${this.fontStyle(typoStyle)}
      ${this.padding(layoutPadding)}
      ${this.margin(layoutMargin)}
      ${this.textAlign(align)}
    }
    
    .post-title-${id} ${structureTag}:hover{
      ${this.color(hoverTextColor)}
      ${this.backgroundColor(hoverBackgroundColor)}
    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .post-title-${id} ${structureTag}{
        ${this.margin(layoutMarginTablet)}
        ${this.padding(layoutPaddingTablet)}
        ${this.fontSize(typoSizeTablet)}
        ${this.textAlign(alignTablet)}
      }
    }
    
    /* Mobile */
    @media (max-width: 767px) {
      .post-title-${id} ${structureTag}{
        ${this.margin(layoutMarginMobile)}
        ${this.padding(layoutPaddingMobile)}
        ${this.fontSize(typoSizeMobile)}
        ${this.textAlign(alignMobile)}}
    }
    
    `;
  }

  blockCSS__PostExcerpt(id, props) {
    const {
      align,
      textColor,
      backgroundColor,
      typoSize,
      typoLineHeight,
      typoLetterSpacing,
      typoWordSpacing,
      typoTransform,
      typoStyle,
      typoDecoration,
      typoWeight,
      layoutPadding,
      layoutMargin,
      hoverTextColor,
      hoverBackgroundColor,
    } = props;
    return `
    .post-excerpt-${id}  {
      ${this.transitionSupport(props)}
      ${this.fontSize(typoSize)}
      ${this.color(textColor)}
      ${this.backgroundColor(backgroundColor)}
      ${this.lineHeight(typoLineHeight)}
      ${this.letterSpacing(typoLetterSpacing)}
      ${this.wordSpacing(typoWordSpacing)}
      ${this.fontWeight(typoWeight)}
      ${this.textDecoration(typoDecoration)}
      ${this.textTransform(typoTransform)}
      ${this.fontStyle(typoStyle)}
      ${this.padding(layoutPadding)}
      ${this.margin(layoutMargin)}
      ${this.textAlign(align)}
    }
    .post-excerpt-${id}:hover{
      ${this.color(hoverTextColor)}
      ${this.backgroundColor(hoverBackgroundColor)}
    }
    `;
  }

  blockCSS__PostFeaturedImage(id, props) {
    const {
      width = "100%",
      widthTablet,
      widthMobile,
      height,
      heightTablet,
      heightMobile,
      align,
      alignMobile,
      alignTablet,
      boxShadow,
      border,
      layoutPadding,
      layoutPaddingTablet,
      layoutPaddingMobile,
      layoutMargin,
      layoutMarginTablet,
      layoutMarginMobile,
      borderRadius,
      cssFilter,
      hoverBorderRadius,
      hoverBoxShadow,
      hoverBorder,
    } = props;
    return `
    .post-featured-image-${id}{
      ${this.margin(layoutMargin)}
      ${this.padding(layoutPadding)}
      ${this.justifyContent(align)}
    }

    .post-featured-image-${id} img{
      ${this.transitionSupport(props)}
      ${this.width(width)}
      ${this.height(height)}
      ${this.border(border)}
      ${this.borderRadius(borderRadius)}
      ${this.boxShadow(this.boxShadowCSS(boxShadow))}
      ${this.filter(cssFilter)}
    }

    .post-featured-image-${id} img:hover{
      ${this.border(hoverBorder)}
      ${this.borderRadius(hoverBorderRadius)}
      ${this.boxShadow(this.boxShadowCSS(hoverBoxShadow))}
    }
  
  /* Tablet */
  @media (min-width: 768px) and (max-width: 1024px) {
    .post-featured-image-${id}{
      ${this.margin(layoutMarginTablet)}
      ${this.padding(layoutPaddingTablet)}
      ${this.justifyContent(alignTablet)}
    }

    .post-featured-image-${id} img{
      ${this.width(widthTablet)}
      ${this.height(heightTablet)}
    }
  }
  
  /* Mobile */
  @media (max-width: 767px) {
    .post-featured-image-${id}{
      ${this.margin(layoutMarginMobile)}
      ${this.padding(layoutPaddingMobile)}
      ${this.justifyContent(alignMobile)}
    }

    .post-featured-image-${id} img{
      ${this.width(widthMobile)}
      ${this.height(heightMobile)}
    }
  }
  
  `;
  }

  blockCSS__PostContent(id, props) {
    const {
      align,
      alignMobile,
      alignTablet,
      textColor,
      backgroundColor,
      typoSize,
      typoSizeTablet,
      typoSizeMobile,
      typoLineHeight,
      typoLetterSpacing,
      typoWordSpacing,
      typoTransform,
      typoStyle,
      typoDecoration,
      typoWeight,
      layoutPadding,
      layoutPaddingTablet,
      layoutPaddingMobile,
      layoutMargin,
      layoutMarginTablet,
      layoutMarginMobile,
    } = props;
    return `

    .post-content-${id} {
      ${this.fontSize(typoSize)}
      ${this.color(textColor)}
      ${this.backgroundColor(backgroundColor)}
      ${this.lineHeight(typoLineHeight)}
      ${this.letterSpacing(typoLetterSpacing)}
      ${this.wordSpacing(typoWordSpacing)}
      ${this.fontWeight(typoWeight)}
      ${this.textDecoration(typoDecoration)}
      ${this.textTransform(typoTransform)}
      ${this.fontStyle(typoStyle)}
      ${this.padding(layoutPadding)}
      ${this.margin(layoutMargin)}
      ${this.textAlign(align)}
    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
       .post-content-${id} {
         ${this.padding(layoutPaddingTablet)}
         ${this.margin(layoutMarginTablet)}
         ${this.fontSize(typoSizeTablet)}
         ${this.textAlign(alignTablet)}
        }
    }

    /* Mobile */
    @media (max-width: 767px) {
       .post-content-${id} {
         ${this.padding(layoutPaddingMobile)}
         ${this.margin(layoutMarginMobile)}
         ${this.fontSize(typoSizeMobile)}
         ${this.textAlign(alignMobile)}
        }
    }

    `;
  }

  blockCSS__PostDate(id, props) {
    const {
      border,
      textColor,
      backgroundColor,
      typoSize,
      typoSizeTablet,
      typoSizeMobile,
      typoLineHeight,
      typoLetterSpacing,
      typoWordSpacing,
      typoTransform,
      typoStyle,
      typoDecoration,
      typoWeight,
      layoutPadding,
      layoutMargin,
      borderRadius,
      align,
      hoverTextColor,
      hoverBackgroundColor,
    } = props;

    return `

    .post-date-${id}{ 
      ${this.transitionSupport(props)}
      ${this.fontSize(typoSize)}
      ${this.textAlign(align)}
      ${this.fontWeight(typoWeight)}
      ${this.fontStyle(typoStyle)}
      ${this.lineHeight(typoLineHeight)}
      ${this.letterSpacing(typoLetterSpacing)}
      ${this.textTransform(typoTransform)}
      ${this.wordSpacing(typoWordSpacing)}  
      ${this.color(textColor)}
      ${this.textDecoration(typoDecoration)}
      ${this.backgroundColor(backgroundColor)}
      ${this.border(border)}
      ${this.borderRadius(borderRadius)}
      ${this.margin(layoutMargin)}
      ${this.padding(layoutPadding)}
    }

    .post-date-${id}:hover{
      ${this.backgroundColor(hoverBackgroundColor)}
      ${this.color(hoverTextColor)}
    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .post-date-${id}{
        ${this.fontSize(typoSizeTablet)}
      }
    }
    
    /* Mobile */
    @media (max-width: 767px) {
      .post-date-${id}{
        ${this.fontSize(typoSizeMobile)}
      }
    }

    `;
  }

  blockCSS__PostAuthor(id, props) {
    const {
      typoNameSize,
      typoNameLineHeight,
      typoNameLetterSpacing,
      typoNameWordSpacing,
      typoNameTransform,
      typoNameStyle,
      typoNameDecoration,
      typoNameWeight,
      typoBioSize,
      typoBioLineHeight,
      typoBioLetterSpacing,
      typoBioWordSpacing,
      typoBioTransform,
      typoBioStyle,
      typoBioDecoration,
      typoBioWeight,
      align,
      border,
      layoutPadding,
      layoutMargin,
      borderRadius,
      authorNameColor,
      authorBioColor,
      backgroundColor,
      structureTag = "h2",
      boxShadow,
      layout = "left",
      avatarVerticalAlign = "start",
      avatarVerticalAlignTablet,
      avatarVerticalAlignMobile,
      avatarSize = "96px",
      avatarSizeTablet,
      avatarSizeMobile,
      avatarGap = "10px",
      avatarGapTablet,
      avatarGapMobile,
      avatarBorder,
      avatarBorderRadius,
      hoverAuthorNameColor,
      hoverAuthorBioColor,
      hoverBackgroundColor,
      hoverAvatarBorder,
      hoverAvatarBorderRadius,
      hoverBorder,
      hoverBorderRadius,
      hoverBoxShadow,
      hoverLayoutPadding,
      hoverLayoutMargin,
    } = props;

    var getLayout = "";

    var aboveLayout = "";
    if (layout == "right") {
      getLayout = `flex-direction:row-reverse;text-align:end;${this.justifyContent(
        align,
      )}`;
    } else if (layout == "left") {
      getLayout = `${this.justifyContent(align)}`;
    } else if (layout == "above") {
      if (align == "left") {
        getLayout = `flex-direction:column;align-items:start;`;
        aboveLayout = "text-align:start;";
      } else if (align == "right") {
        getLayout = `flex-direction:column;align-items:end;`;
        aboveLayout = "text-align:end;";
      } else {
        getLayout = `flex-direction:column;${this.alignItems(align)}`;
        aboveLayout = "text-align:center;";
      }
    }

    return `
     
    .post-author-${id} .post-author-container{
      ${getLayout}
      ${this.transitionSupport(props)}
      ${this.margin(layoutMargin)}
      ${this.padding(layoutPadding)}
      ${this.backgroundColor(backgroundColor)}
      ${this.border(border)}
      ${this.borderRadius(borderRadius)}
      ${this.boxShadow(this.boxShadowCSS(boxShadow))}
      ${this.gap(avatarGap)}
    }

    .post-author-${id} .post-author-container:hover{
      ${this.margin(hoverLayoutMargin)}
      ${this.padding(hoverLayoutPadding)}
      ${this.backgroundColor(hoverBackgroundColor)}
      ${this.border(hoverBorder)}
      ${this.borderRadius(hoverBorderRadius)}
      ${this.boxShadow(this.boxShadowCSS(hoverBoxShadow))}
    }

    .post-author-${id} .post-author-container .post-author-details{
      ${aboveLayout}
    }

    .post-author-${id} .post-author-image{
      ${
        layout != "above" && avatarVerticalAlign
          ? `align-self: ${avatarVerticalAlign};`
          : ``
      }
      ${this.width(avatarSize)}
    }

    .post-author-${id} .post-author-image img{
      ${this.borderRadius(avatarBorderRadius)}
      ${this.border(avatarBorder)}
    }

    .post-author-${id} .post-author-image img:hover{
      ${this.borderRadius(hoverAvatarBorderRadius)}
      ${this.border(hoverAvatarBorder)}
    }

    .post-author-${id} .post-author-container .post-author-details ${structureTag}{
       ${this.textDecoration(typoNameDecoration)}
      ${this.fontSize(typoNameSize)}
      ${this.fontWeight(typoNameWeight)}
      ${this.fontStyle(typoNameStyle)}
      ${this.lineHeight(typoNameLineHeight)}
      ${this.letterSpacing(typoNameLetterSpacing)}
      ${this.textTransform(typoNameTransform)}
      ${this.wordSpacing(typoNameWordSpacing)} 
      ${this.color(authorNameColor)} 
    }

    .post-author-${id} .post-author-container .post-author-details ${structureTag}:hover{
      ${this.color(hoverAuthorNameColor)} 
    }

    .post-author-${id} .post-author-container .post-author-details span{
      ${this.textDecoration(typoBioDecoration)}
      ${this.fontSize(typoBioSize)}
      ${this.fontWeight(typoBioWeight)}
      ${this.fontStyle(typoBioStyle)}
      ${this.lineHeight(typoBioLineHeight)}
      ${this.letterSpacing(typoBioLetterSpacing)}
      ${this.textTransform(typoBioTransform)}
      ${this.wordSpacing(typoBioWordSpacing)} 
      ${this.color(authorBioColor)} 
    }

    .post-author-${id} .post-author-container .post-author-details span:hover{
      ${this.color(hoverAuthorBioColor)} 
    }

    `;
  }

  blockCSS__SocialLinks(id, props) {
    const {
      layoutPadding = {
        top: "8px",
        bottom: "8px",
        left: "10px",
        right: "10px",
      },
      layoutPaddingTablet,
      layoutPaddingMobile,
      iconSize = "25px",
      iconSizeTablet,
      iconSizeMobile,
      color,
      backgroundColor,
      border,
      borderRadius = {
        topLeft: "20px",
        topRight: "20px",
        bottomLeft: "20px",
        bottomRight: "20px",
      },
      labelGap = "4px",
      labelGapTablet,
      labelGapMobile,
      gapX = "6px",
      gapXTablet,
      gapXMobile,
      gapY = "10px",
      gapYTablet,
      gapYMobile,
      align,
      alignTablet,
      alignMobile,
      typoFontSize,
      typoFontSizeTablet,
      typoFontSizeMobile,
      justifyContent,
      justifyContentTablet,
      justifyContentMobile,
      columnLayout = false,
      columnLayoutTablet = false,
      columnLayoutMobile = false,
    } = props;

    return `

    .social-links-${id} .g-social-media__container{
      ${this.columnGap(gapX)}
      ${this.rowGap(gapY)}
      ${this.flexDirection(columnLayout ? "column" : "row")}
      ${
        columnLayout
          ? this.alignItems(justifyContent)
          : this.justifyContent(align)
      }
    }

    .social-links-${id} .icon-container{
      ${this.border(border)}
      ${this.borderRadius(borderRadius)}
      ${this.padding(layoutPadding)}
      ${this.color(color)}
      ${this.backgroundColor(backgroundColor)}
      ${this.gap(labelGap)}
    }
    
    .social-links-${id} .g-social-media__container .icon-container svg{
      ${this.width(iconSize)}
      ${this.height(iconSize)}
    }

    .social-links-${id} .g-social-media__container  .icon-container .icon-label{
      ${this.fontSize(typoFontSize)}
    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .social-links-${id} .g-social-media__container{
        ${this.flexDirection(columnLayoutTablet ? "column" : "row")}
        ${
          columnLayoutTablet
            ? this.alignItems(justifyContentTablet)
            : this.justifyContent(alignTablet)
        }
      ${this.columnGap(gapXTablet)}
      ${this.rowGap(gapYTablet)}
      }
      
      .social-links-${id} .icon-container{
        ${this.padding(layoutPaddingTablet)}
        ${this.gap(labelGapTablet)}
      }

      .social-links-${id} .icon-container svg{
        ${this.width(iconSizeTablet)}
        ${this.height(iconSizeTablet)}
      }
      .social-links-${id} .g-social-media__container .icon-container .icon-label{
        ${this.fontSize(typoFontSizeTablet)}
      }
    }

    /* Mobile */
    @media (max-width: 767px) {
      .social-links-${id} .g-social-media__container{ 
      ${this.flexDirection(columnLayoutMobile ? "column" : "row")}
      ${
        columnLayoutMobile
          ? this.alignItems(justifyContentMobile)
          : this.justifyContent(alignMobile)
      }
      ${this.columnGap(gapXMobile)}
      ${this.rowGap(gapYMobile)}
      }
      
      .social-links-${id} .icon-container{
        ${this.padding(layoutPaddingMobile)}
        ${this.gap(labelGapMobile)}
      }

      .social-links-${id} .icon-container svg{
        ${this.width(iconSizeMobile)}
        ${this.height(iconSizeMobile)}
      }
      .social-links-${id} .g-social-media__container .icon-container .icon-label{
        ${this.fontSize(typoFontSizeMobile)}
      }
       
    }

    `;
  }

  blockCSS__Separator(id, props) {
    const {
      width = "100%",
      widthTablet,
      widthMobile,
      height,
      heightTablet,
      heightMobile,
      color,
      align,
      alignTablet,
      alignMobile,
      layoutMargin,
      layoutMarginTablet,
      layoutMarginMobile,
    } = props;
    return `
    .separator-${id}{
      ${this.justifyContent(align)}
    }

    .separator-${id} .separator{
      ${this.width(width)}
      ${this.height(height)}
      ${this.color(color)}
      ${this.margin(layoutMargin)}
    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .separator-${id}{
        ${this.justifyContent(alignTablet)}
      }
      .separator-${id} .separator{
        ${this.width(widthTablet)}
        ${this.height(heightTablet)}
        ${this.margin(layoutMarginTablet)}
      }
    }

    /* Mobile */
    @media (max-width: 767px) {
      .separator-${id}{
        ${this.justifyContent(alignMobile)}
      }
      .separator-${id} .separator{
        ${this.width(widthMobile)}
        ${this.height(heightMobile)}
        ${this.margin(layoutMarginMobile)}
      }
    }
    `;
  }

  blockCSS__Search(id, props) {
    const {
      containerWidth,
      containerWidthTablet,
      containerWidthMobile,
      containerHeight,
      containerHeightTablet,
      containerHeightMobile,
      containerMaxWidth = "100%",
      containerMaxHeight,
      gap,
      gapTablet,
      gapMobile,
      inputWidth,
      inputWidthTablet,
      inputWidthMobile,
      inputHeight,
      inputHeightTablet,
      inputHeightMobile,
      inputMaxWidth,
      inputMaxHeight,
      isSearchButtonVisible = true,
      isSearchButtonIcon = true,
      iconSize = "20px",
      iconSizeTablet,
      iconSizeMobile,
      containerBackground,
      inputColor,
      inputPlaceholderColor,
      inputBackgroundColor,
      searchColor = "#ffffff",
      searchBackground = "#745dcd",
      containerPadding,
      containerPaddingTablet,
      containerPaddingMobile,
      containerBorder = {
        top: {
          width: "1px",
          style: "solid",
          color: "#666666",
        },
        left: {
          width: "1px",
          style: "solid",
          color: "#666666",
        },
        right: {
          width: "1px",
          style: "solid",
          color: "#666666",
        },
        bottom: {
          width: "1px",
          style: "solid",
          color: "#666666",
        },
      },
      containerBorderRadius,
      containerBoxShadow,
      inputPadding,
      inputPaddingTablet,
      inputPaddingMobile,
      inputBorder,
      inputBorderRadius,
      inputBoxShadow,
      searchButtonPadding = {
        top: "15px",
        left: "15px",
        right: "15px",
        bottom: "15px",
      },
      searchButtonBorder,
      searchButtonBorderRadius,
      searchButtonBoxShadow,
      placeholderSize,
    } = props;
    return `
    
    .search-${id} .search-input-field::placeholder {
      ${this.color(inputPlaceholderColor)}
      ${this.fontSize(placeholderSize)}
    }
    
    .search-${id}{
      ${this.blockGap(gap)}
      ${this.width(containerWidth)}
      ${this.maxWidth(containerMaxWidth)}
      ${this.height(containerHeight)}
      ${this.maxHeight(containerMaxHeight)}
      ${this.backgroundColor(containerBackground)}
      ${this.padding(containerPadding)}
      ${this.border(containerBorder)}
      ${this.borderRadius(containerBorderRadius)}
      ${this.boxShadow(this.boxShadowCSS(containerBoxShadow))}
    }
    .search-${id} .search-input-field{
      ${this.width(inputWidth)}
      ${this.maxWidth(inputMaxWidth)}
      ${this.height(inputHeight)}
      ${this.maxHeight(inputMaxHeight)}
      ${this.color(inputColor)}
      ${this.backgroundColor(inputBackgroundColor)}
      ${this.padding(inputPadding)}
      ${this.border(inputBorder)}
      ${this.borderRadius(inputBorderRadius)}
      ${this.boxShadow(this.boxShadowCSS(inputBoxShadow))}
    }
    ${
      isSearchButtonVisible &&
      `
      .search-${id} .svg-icon{
        ${this.width(iconSize)}
        ${this.height(iconSize)}
      }

      .search-${id} .search-icon{
          ${this.color(searchColor)}
          ${this.backgroundColor(searchBackground)}
          ${this.padding(searchButtonPadding)}
          ${this.border(searchButtonBorder)}
          ${this.borderRadius(searchButtonBorderRadius)}
          ${this.boxShadow(this.boxShadowCSS(searchButtonBoxShadow))}
        }
        ${
          !isSearchButtonIcon
            ? `
            .search-${id} .search-icon .search-text{
              ${this.fontSize(iconSize)}
            }
        `
            : ""
        }
        `
    }
    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .search-${id}{
        ${this.blockGap(gapTablet)}
        ${this.width(containerWidthTablet)}
        ${this.height(containerHeightTablet)}
        ${this.padding(containerPaddingTablet)}
      }
       .search-${id} .search-input-field{
        ${this.width(inputWidthTablet)}
        ${this.height(inputHeightTablet)}
        ${this.padding(inputPaddingTablet)}
       }

        ${
          isSearchButtonVisible &&
          `
          .search-${id} .svg-icon{
            ${this.width(iconSizeTablet)}
            ${this.height(iconSizeTablet)}

          }`
        }
    }

    /* Mobile */
    @media (max-width: 767px){
      .search-${id}{
        ${this.blockGap(gapMobile)}
        ${this.width(containerWidthMobile)}
        ${this.height(containerHeightMobile)}
        ${this.padding(containerPaddingMobile)}
      }
       .search-${id} .search-input-field{
        ${this.width(inputWidthMobile)}
        ${this.height(inputHeightMobile)}
        ${this.padding(inputPaddingMobile)}
       }

        ${
          isSearchButtonVisible &&
          `
          .search-${id} .svg-icon{
            ${this.width(iconSizeMobile)}
            ${this.height(iconSizeMobile)}
          }`
        }
    }
    `;
  }

  blockCSS__Newsletter(id, props) {
    const {
      containerWidth,
      containerWidthTablet,
      containerWidthMobile,
      containerHeight,
      containerHeightTablet,
      containerHeightMobile,
      containerMaxWidth = "100%",
      containerMaxHeight,
      gap,
      gapTablet,
      gapMobile,
      inputWidth,
      inputWidthTablet,
      inputWidthMobile,
      inputHeight,
      inputHeightTablet,
      inputHeightMobile,
      inputMaxWidth,
      inputMaxHeight,
      isSubmitButtonVisible = true,
      isSubmitButtonIcon = true,
      iconSize = "20px",
      iconSizeTablet,
      iconSizeMobile,
      containerBackground,
      inputColor,
      inputPlaceholderColor,
      inputBackgroundColor,
      submitColor = "#ffffff",
      submitBackground = "#745dcd",
      containerPadding,
      containerPaddingTablet,
      containerPaddingMobile,
      containerBorder = {
        top: {
          width: "1px",
          style: "solid",
          color: "#666666",
        },
        left: {
          width: "1px",
          style: "solid",
          color: "#666666",
        },
        right: {
          width: "1px",
          style: "solid",
          color: "#666666",
        },
        bottom: {
          width: "1px",
          style: "solid",
          color: "#666666",
        },
      },
      containerBorderRadius,
      containerBoxShadow,
      inputPadding,
      inputPaddingTablet,
      inputPaddingMobile,
      inputBorder,
      inputBorderRadius,
      inputBoxShadow,
      submitButtonPadding = {
        top: "15px",
        left: "15px",
        right: "15px",
        bottom: "15px",
      },
      submitButtonBorder,
      submitButtonBorderRadius,
      submitButtonBoxShadow,
    } = props;
    return `
    
    .newsletter-${id} input[type="text"]::placeholder {
      ${this.color(inputPlaceholderColor)}

    }
    .newsletter-${id}{
      ${this.blockGap(gap)}
      ${this.width(containerWidth)}
      ${this.maxWidth(containerMaxWidth)}
      ${this.height(containerHeight)}
      ${this.maxHeight(containerMaxHeight)}
      ${this.backgroundColor(containerBackground)}
      ${this.padding(containerPadding)}
      ${this.border(containerBorder)}
      ${this.borderRadius(containerBorderRadius)}
      ${this.boxShadow(this.boxShadowCSS(containerBoxShadow))}
    }
    .newsletter-${id} .newsletter-input-field{
      ${this.width(inputWidth)}
      ${this.maxWidth(inputMaxWidth)}
      ${this.height(inputHeight)}
      ${this.maxHeight(inputMaxHeight)}
      ${this.color(inputColor)}
      ${this.backgroundColor(inputBackgroundColor)}
      ${this.padding(inputPadding)}
      ${this.border(inputBorder)}
      ${this.borderRadius(inputBorderRadius)}
      ${this.boxShadow(this.boxShadowCSS(inputBoxShadow))}
    }
    ${
      isSubmitButtonVisible &&
      `
      .newsletter-${id} .svg-icon{
        ${this.width(iconSize)}
        ${this.height(iconSize)}
      }

      .newsletter-${id} .newsletter-icon{
          ${this.color(submitColor)}
          ${this.backgroundColor(submitBackground)}
          ${this.padding(submitButtonPadding)}
          ${this.border(submitButtonBorder)}
          ${this.borderRadius(submitButtonBorderRadius)}
          ${this.boxShadow(this.boxShadowCSS(submitButtonBoxShadow))}
        }
        ${
          !isSubmitButtonIcon
            ? `
            .newsletter-${id} .newsletter-icon .newsletter-text{
              ${this.fontSize(iconSize)}
            }
        `
            : ""
        }
        `
    }
    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .newsletter-${id}{
        ${this.blockGap(gapTablet)}
        ${this.width(containerWidthTablet)}
        ${this.height(containerHeightTablet)}
        ${this.padding(containerPaddingTablet)}
      }
       .newsletter-${id} .newsletter-input-field{
        ${this.width(inputWidthTablet)}
        ${this.height(inputHeightTablet)}
        ${this.padding(inputPaddingTablet)}
       }

        ${
          isSubmitButtonVisible &&
          `
          .newsletter-${id} .svg-icon{
            ${this.width(iconSizeTablet)}
            ${this.height(iconSizeTablet)}

          }`
        }
    }

    /* Mobile */
    @media (max-width: 767px){
      .newsletter-${id}{
        ${this.blockGap(gapMobile)}
        ${this.width(containerWidthMobile)}
        ${this.height(containerHeightMobile)}
        ${this.padding(containerPaddingMobile)}
      }
       .newsletter-${id} .newsletter-input-field{
      ${this.width(inputWidthMobile)}
      ${this.height(inputHeightMobile)}
      ${this.padding(inputPaddingMobile)}
       }

        ${
          isSubmitButtonVisible &&
          `
          .newsletter-${id} .svg-icon{
            ${this.width(iconSizeMobile)}
            ${this.height(iconSizeMobile)}
          }`
        }
    }
    `;
  }

  blockCSS__Video(id, props) {
    const {
      width,
      widthTablet,
      widthMobile,
      height,
      heightTablet,
      heightMobile,
      align,
      alignTablet,
      alignMobile,
    } = props;
    return `
    .video-${id}{
      ${this.alignItems(align)}
    }

    .video-${id} .video-frame{
      ${this.width(width)}
      ${this.height(height)}
    }


    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .video-${id}{
        ${this.alignItems(alignTablet)}
      }
      .video-${id} .video-frame{
        ${this.width(widthTablet)}
        ${this.height(heightTablet)}
      }
    }

    /* Mobile */
    @media (max-width: 767px) {
      .video-${id}{
        ${this.alignItems(alignMobile)}
      }
      .video-${id} .video-frame{
        ${this.width(widthMobile)}
        ${this.height(heightMobile)}
      }
    }
    `;
  }

  blockCSS__Youtube(id, props) {
    const {
      url,
      width,
      widthTablet,
      widthMobile,
      height,
      heightTablet,
      heightMobile,
      align,
      alignTablet,
      alignMobile,
    } = props;
    return `
    .youtube-${id}{
      ${this.justifyContent(align)}
      ${
        !url
          ? `
            justify-content: center;
            padding: 10px 0px;
               `
          : ""
      }
    }

    .youtube-${id} .youtube-video-frame{
      ${this.width(width)}
      ${this.height(height)}
    }


    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .youtube-${id}{
        ${this.justifyContent(alignTablet)}
      }
      .youtube-${id} .youtube-video-frame{
        ${this.width(widthTablet)}
        ${this.height(heightTablet)}
      }
    }

    /* Mobile */
    @media (max-width: 767px) {
      .youtube-${id}{
        ${this.justifyContent(alignMobile)}
      }
      .youtube-${id} .youtube-video-frame{
        ${this.width(widthMobile)}
        ${this.height(heightMobile)}
      }
    }
    `;
  }

  blockCSS__Twitter(id, props) {
    const {
      tweet,
      width,
      widthMobile,
      widthTablet,
      height,
      heightTablet,
      heightMobile,
      align,
      alignTablet,
      alignMobile,
    } = props;
    return `
    
    ${
      !tweet
        ? `.twitter-${id}{
            ${this.justifyContent("center")}
          }`
        : `.twitter-${id}{
            ${this.justifyContent(align)}
          }`
    }

    .twitter-${id} .tweet-frame{
      ${this.width(width, true)}
      ${this.height(height, true)}
    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
     .twitter-${id}{
       ${this.justifyContent(alignTablet)}
     }

     .twitter-${id} .tweet-frame{
        ${this.width(widthTablet)}
        ${this.height(heightTablet)}
      }
    }

    /* Mobile */
    @media (max-width: 767px) {
      .twitter-${id}{
        ${this.justifyContent(alignMobile)}
      }

      .twitter-${id} .tweet-frame{
        ${this.width(widthMobile)}
        ${this.height(heightMobile)}
      }
    }
    `;
  }

  blockCSS__ScrollToTop(id, props) {
    const {
      size = "24px",
      color = "#ffffff",
      backgroundColor = "#16537e",
      layoutPadding = {
        top: "8px",
        bottom: "8px",
        left: "8px",
        right: "8px",
      },
      layoutMargin,
      border,
      borderRadius = {
        bottomLeft: "100px",
        bottomRight: "100px",
        topLeft: "100px",
        topRight: "100px",
      },
      boxShadow,
      position = "fixed",
      topPosition,
      topPositionTablet,
      topPositionMobile,
      bottomPosition = "50px",
      bottomPositionTablet,
      bottomPositionMobile,
      leftPosition,
      leftPositionTablet,
      leftPositionMobile,
      rightPosition = "30px",
      rightPositionTablet,
      rightPositionMobile,
      zindex = 100,
      offset,
      smoothScrolling,
      onlyShowWhenScrollingUp,
      hoverBoxShadow,
      hoverLayoutPadding,
      hoverLayoutMargin,
      hoverBorder,
      hoverBorderRadius,
      hoverColor,
      hoverBackgroundColor,
    } = props;

    return `

    .scroll-to-top-${id}{
      ${this.transitionSupport(props)}
      ${this.zindex(zindex)}
      ${this.position(position)}
      ${this.top(topPosition)}
      ${this.bottom(bottomPosition)}
      ${this.left(leftPosition)}
      ${this.right(rightPosition)}
      ${this.margin(layoutMargin)}
      ${this.padding(layoutPadding)}
      ${this.color(color)}
      ${this.backgroundColor(backgroundColor)}
      ${this.border(
        border,
        hoverBorder
          ? {
              top: {
                width: "0px",
                style: "solid",
                color: hoverBorder?.top?.color,
              },
              bottom: {
                width: "0px",
                style: "solid",
                color: hoverBorder?.bottom?.color,
              },
              left: {
                width: "0px",
                style: "solid",
                color: hoverBorder?.left?.color,
              },
              right: {
                width: "0px",
                style: "solid",
                color: hoverBorder?.right?.color,
              },
            }
          : undefined,
      )}
      ${this.borderRadius(borderRadius)}
      ${this.boxShadow(this.boxShadowCSS(boxShadow))}
    }
    
    .scroll-to-top-${id}:hover{
      ${this.color(hoverColor)}
      ${this.backgroundColor(hoverBackgroundColor)}
      ${this.border(hoverBorder)}
      ${this.borderRadius(hoverBorderRadius)}
      ${this.boxShadow(this.boxShadowCSS(hoverBoxShadow))}
      ${this.margin(hoverLayoutMargin)}
      ${this.padding(hoverLayoutPadding)}
    }

    .scroll-to-top-${id} .scroll-to-top__icon{
      ${this.width(size)}
      ${this.height(size)}
    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .scroll-to-top-${id}{
        ${this.top(topPositionTablet)}
        ${this.bottom(bottomPositionTablet)}
        ${this.left(leftPositionTablet)}
        ${this.right(rightPositionTablet)}  
      }
    }

    /* Mobile */
    @media (max-width: 767px) {
      .scroll-to-top-${id}{
        ${this.top(topPositionMobile)}
        ${this.bottom(bottomPositionMobile)}
        ${this.left(leftPositionMobile)}
        ${this.right(rightPositionMobile)}  
      }
    }

    `;
  }

  blockCSS__PostCategories(id, props) {
    const {
      gapHorizontal,
      gapVertical,
      prefixText,
      categoryColor = "#fff",
      categoryBackgroundColor = "#5ec9ff",
      categoryTypoSize,
      categoryTypoSizeTablet,
      categoryTypoSizeMobile,
      categoryTypoLineHeight,
      categoryTypoLetterSpacing,
      categoryTypoWordSpacing,
      categoryTypoTransform,
      categoryTypoStyle,
      categoryTypoDecoration,
      categoryTypoWeight,
      prefixColor,
      prefixBackgroundColor,
      prefixTypoSize,
      prefixTypoSizeTablet,
      prefixTypoSizeMobile,
      prefixTypoLineHeight,
      prefixTypoLetterSpacing,
      prefixTypoWordSpacing,
      prefixTypoTransform,
      prefixTypoStyle,
      prefixTypoDecoration,
      prefixTypoWeight,
      layoutPadding = {
        top: "3px",
        bottom: "3px",
        left: "10px",
        right: "10px",
      },
      layoutPaddingTablet,
      layoutPaddingMobile,
      layoutMargin,
      layoutMarginTablet,
      layoutMarginMobile,
      border,
      borderRadius,
      boxShadow,
      hoverCategoryColor,
      hoverCategoryBackgroundColor,
      hoverPrefixColor,
      hoverPrefixBackgroundColor,
      hoverBorder,
      hoverBorderRadius,
      activeCategoryColor,
      activeCategoryBackgroundColor,
      activePrefixColor,
      activePrefixBackgroundColor,
      activeBorder,
      activeBorderRadius,
      columnLayout = false,
      align,
    } = props;
    return `
    
    .post-categories-${id}{
      ${this.rowGap(gapVertical ? gapVertical + "px" : undefined)}
      ${this.columnGap(gapHorizontal ? gapHorizontal + "px" : undefined)}
      ${this.flexDirection(columnLayout ? "column" : undefined)}
      ${columnLayout ? this.alignItems(align) : this.justifyContent(align)}
    }

    ${
      prefixText
        ? `
        .post-categories-${id} .prefix{     
          ${this.transitionSupport(props)}
          ${this.color(prefixColor)}
          ${this.backgroundColor(prefixBackgroundColor)}
          ${this.fontSize(prefixTypoSize)}
          ${this.textDecoration(prefixTypoDecoration)}
          ${this.fontWeight(prefixTypoWeight)}
          ${this.fontStyle(prefixTypoStyle)}
          ${this.lineHeight(prefixTypoLineHeight)}
          ${this.letterSpacing(prefixTypoLetterSpacing)}
          ${this.textTransform(prefixTypoTransform)}
          ${this.wordSpacing(prefixTypoWordSpacing)} 
        }

        .post-categories-${id} .prefix:hover{
          ${this.color(hoverPrefixColor)}
          ${this.backgroundColor(hoverPrefixBackgroundColor)}
        }

        .post-categories-${id} .prefix.active{
          ${this.color(activePrefixColor)}
          ${this.backgroundColor(activePrefixBackgroundColor)}
        }

    `
        : ""
    }
    
    .post-categories-${id} .link{
      ${this.margin(layoutMargin)} 
    }

    .post-categories-${id} .link .category{
      ${this.transitionSupport(props)}
      ${this.fontSize(categoryTypoSize)}
      ${this.textDecoration(categoryTypoDecoration)}
      ${this.fontWeight(categoryTypoWeight)}
      ${this.fontStyle(categoryTypoStyle)}
      ${this.lineHeight(categoryTypoLineHeight)}
      ${this.letterSpacing(categoryTypoLetterSpacing)}
      ${this.textTransform(categoryTypoTransform)}
      ${this.wordSpacing(categoryTypoWordSpacing)} 
      ${this.color(categoryColor)} 
      ${this.backgroundColor(categoryBackgroundColor)} 
      ${this.padding(layoutPadding)} 
      ${this.border(border)} 
      ${this.borderRadius(borderRadius)} 
      ${this.boxShadow(this.boxShadowCSS(boxShadow))} 
    }

    .post-categories-${id} .link .category:hover{
      ${this.color(hoverCategoryColor)} 
      ${this.backgroundColor(hoverCategoryBackgroundColor)} 
      ${this.border(hoverBorder)} 
      ${this.borderRadius(hoverBorderRadius)} 
    }

    .post-categories-${id} .link.active .category{
      ${this.color(activeCategoryColor)} 
      ${this.backgroundColor(activeCategoryBackgroundColor)} 
      ${this.border(activeBorder)} 
      ${this.borderRadius(activeBorderRadius)} 
    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      ${
        prefixText
          ? `.post-categories-${id} .prefix{
            ${this.fontSize(prefixTypoSizeTablet)}
            
      }`
          : ""
      }
      .post-categories-${id} .link .category{
        ${this.fontSize(categoryTypoSizeTablet)}${this.margin(
      layoutMarginTablet,
    )} 
        ${this.padding(layoutPaddingTablet)} 
      }
    }

    /* Mobile */
    @media (max-width: 767px) {
      ${
        prefixText
          ? `.post-categories-${id} .prefix{
            ${this.fontSize(prefixTypoSizeMobile)}
      }`
          : ""
      }
      .post-categories-${id} .link .category{
        ${this.fontSize(categoryTypoSizeMobile)}
        ${this.margin(layoutMarginMobile)} 
        ${this.padding(layoutPaddingMobile)} 
      }
    }
    `;
  }

  blockCSS__PostTimeToRead(id, props) {
    const {
      typoSize,
      typoLineHeight,
      typoLetterSpacing,
      typoWordSpacing,
      typoTransform,
      typoStyle,
      typoDecoration,
      typoWeight,
      color,
      layoutPadding,
      layoutMargin,
    } = props;
    return `
    
      .post-time-to-read-${id}{
        ${this.margin(layoutMargin)}
        ${this.padding(layoutPadding)}
        ${this.color(color)}
      }

      .post-time-to-read-${id} .post-time-paragraph{
        ${this.fontSize(typoSize)}
        ${this.textDecoration(typoDecoration)}
        ${this.fontWeight(typoWeight)}
        ${this.fontStyle(typoStyle)}
        ${this.lineHeight(typoLineHeight)}
        ${this.letterSpacing(typoLetterSpacing)}
        ${this.textTransform(typoTransform)}
        ${this.wordSpacing(typoWordSpacing)} 
      }


      /* Tablet */
      @media (min-width: 768px) and (max-width: 1024px) {
        
      }

      /* Mobile */
      @media (max-width: 767px) {
        
      }
      
    `;
  }

  blockCSS__Lottie(id, props) {
    const {
      fileSource,
      lottieAnimationUrl,
      ariaLabel,
      showControls,
      autoplay = true,
      playOnHover,
      playOnPageScroll,
      playUntilInView,
      playbackSpeed,
      loopPlayback,
      bouncePlayback,
      delayBetweenLoops,
      limitLoops,
      maxWidth,
      layoutMargin,
      layoutMarginTablet,
      layoutMarginMobile,
      layoutPadding,
      layoutPaddingTablet,
      layoutPaddingMobile,
    } = props;

    return `
  .lottie-${id}{
      ${this.margin(layoutMargin)}
      ${this.padding(layoutPadding)}
      ${this.maxWidth(maxWidth)}

  }


  /* Tablet  */
  @media (min-width: 768px) and (max-width: 1024px) {
   .lottie-${id}{
      ${this.margin(layoutMarginTablet)}
      ${this.padding(layoutPaddingTablet)}
   }
  }
  
  /* Mobile */
  @media (max-width: 767px) {
    .lottie-${id}{
      ${this.margin(layoutMarginMobile)}
      ${this.padding(layoutPaddingMobile)}
    }
  }
  
  `;
  }

  blockCSS__FormText(id, props) {
    const {
      inputWidth,
      inputWidthTablet,
      inputWidthMobile,
      inputHeight,
      inputHeightTablet,
      inputHeightMobile,
      containerWidth,
      containerWidthTablet,
      containerWidthMobile,
      containerHeight,
      containerHeightTablet,
      containerHeightMobile,
      containerMaxWidth,
      containerMaxHeight,
      align,
      alignTablet,
      alignMobile,
      containerBackground,
      inputColor,
      inputPlaceholderColor,
      inputBackgroundColor,
      containerPadding,
      containerPaddingTablet,
      containerPaddingMobile,
      containerBorder,
      containerBorderRadius,
      containerBoxShadow,
      layoutMargin,
      layoutMarginTablet,
      layoutMarginMobile,
      inputMargin,
      inputMarginTablet,
      inputMarginMobile,
      inputPadding,
      inputPaddingTablet,
      inputPaddingMobile,
      inputBorder,
      inputBorderRadius,
      inputBoxShadow,
      inputType = "text",
      typoSize,
      showLabel,
      label,
      labelColor,
      labelRequiredColor,
    } = props;
    return `
    
    .form-text-${id} input[type=${inputType}]::placeholder {
      ${this.color(inputPlaceholderColor)}
    }

    .form-text-${id}{
      ${this.alignItems(align)}
      ${this.width(containerWidth)}
      ${this.height(containerHeight)}
      ${this.maxWidth(containerMaxWidth)}
      ${this.maxHeight(containerMaxHeight)}
      ${this.backgroundColor(containerBackground)}
      ${this.margin(layoutMargin)}
      ${this.padding(containerPadding)}
      ${this.border(containerBorder)}
      ${this.borderRadius(containerBorderRadius)}
      ${this.boxShadow(this.boxShadowCSS(containerBoxShadow))}
    }

    .form-text-${id} .form-input-field{
      ${this.margin(inputMargin)}
      ${this.fontSize(typoSize)}
      ${this.color(inputColor)}
      ${this.width(inputWidth)}
      ${this.height(inputHeight)}
      ${this.backgroundColor(inputBackgroundColor)}
      ${this.padding(inputPadding)}
      ${this.border(inputBorder)}
      ${this.borderRadius(inputBorderRadius)}
      ${this.boxShadow(this.boxShadowCSS(inputBoxShadow))}
    }

    ${
      showLabel
        ? `
      .form-text-${id} label {
        ${this.color(labelColor)}
      }
      .form-text-${id} label .required {
        ${this.color(labelRequiredColor)}
      }
      `
        : ``
    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .form-text-${id}{
        ${this.justifyContent(alignTablet)}
        ${this.width(containerWidthTablet)}
        ${this.margin(layoutMarginTablet)}
        ${this.height(containerHeightTablet)}
        ${this.padding(containerPaddingTablet)}
      }
      
      .form-text-${id} .form-input-field{
        ${this.margin(inputMarginTablet)}
        ${this.padding(inputPaddingTablet)}
      ${this.width(inputWidthTablet)}
      ${this.height(inputHeightTablet)}
       }

    }

    /* Mobile */
    @media (max-width: 767px) {
      .form-text-${id}{
        ${this.justifyContent(alignMobile)}
        ${this.width(containerWidthMobile)}
        ${this.margin(layoutMarginMobile)}
        ${this.height(containerHeightMobile)}
        ${this.padding(containerPaddingMobile)}
      }
      .form-text-${id} .form-input-field{
        ${this.margin(inputMarginMobile)}
        ${this.padding(inputPaddingMobile)}
      ${this.width(inputWidthMobile)}
      ${this.height(inputHeightMobile)}
       }
    }

    `;
  }

  blockCSS__FormSubmit(id, props) {
    const {
      containerWidth,
      containerWidthTablet,
      containerWidthMobile,
      containerHeight,
      containerHeightTablet,
      containerHeightMobile,
      containerMaxWidth,
      containerMaxHeight,
      buttonWidth,
      buttonWidthTablet,
      buttonWidthMobile,
      buttonHeight,
      buttonHeightTablet,
      buttonHeightMobile,
      buttonMaxWidth,
      buttonMaxHeight,
      align,
      alignTablet,
      alignMobile,
      buttonAlign,
      buttonAlignTablet,
      buttonAlignMobile,
      buttonColor,
      buttonBackgroundColor,
      containerBackgroundColor,
      containerPadding,
      containerPaddingTablet,
      containerPaddingMobile,
      containerBorder,
      containerBorderRadius,
      containerBoxShadow,
      containerMargin,
      containerMarginTablet,
      containerMarginMobile,
      buttonMargin,
      buttonMarginTablet,
      buttonMarginMobile,
      buttonPadding,
      buttonPaddingTablet,
      buttonPaddingMobile,
      buttonBorder,
      buttonBorderRadius,
      buttonBoxShadow,
      typoSize,
      hoverButtonColor,
      hoverButtonBackgroundColor,
      hoverContainerBackgroundColor,
      hoverContainerPadding,
      hoverContainerPaddingTablet,
      hoverContainerPaddingMobile,
      hoverContainerBorder,
      hoverContainerBorderRadius,
      hoverContainerBoxShadow,
      hoverContainerMargin,
      hoverContainerMarginTablet,
      hoverContainerMarginMobile,
      hoverButtonMargin,
      hoverButtonMarginTablet,
      hoverButtonMarginMobile,
      hoverButtonPadding,
      hoverButtonPaddingTablet,
      hoverButtonPaddingMobile,
      hoverButtonBorder,
      hoverButtonBorderRadius,
      hoverButtonBoxShadow,
    } = props;
    return `
  
    .form-submit-${id}{
      ${this.transitionSupport(props)}
      ${this.margin(containerMargin)}
      ${this.padding(containerPadding)}
      ${this.backgroundColor(containerBackgroundColor)}
      ${this.justifyContent(align)}
      ${this.border(
        containerBorder,
        hoverContainerBorder
          ? {
              top: {
                width: "0px",
                style: "solid",
                color: hoverBorder?.top?.color,
              },
              bottom: {
                width: "0px",
                style: "solid",
                color: hoverBorder?.bottom?.color,
              },
              left: {
                width: "0px",
                style: "solid",
                color: hoverBorder?.left?.color,
              },
              right: {
                width: "0px",
                style: "solid",
                color: hoverBorder?.right?.color,
              },
            }
          : undefined,
      )}
      ${this.borderRadius(containerBorderRadius)}
      ${this.boxShadow(this.boxShadowCSS(containerBoxShadow))}
      ${this.width(containerWidth)}
      ${this.height(containerHeight)}
      ${this.maxWidth(containerMaxWidth)}
      ${this.minHeight(containerMaxHeight)}

    }
    
    .form-submit-${id}:hover{
      ${this.margin(hoverContainerMargin)}
      ${this.padding(hoverContainerPadding)}
      ${this.backgroundColor(hoverContainerBackgroundColor)}
      ${this.border(hoverContainerBorder)}
      ${this.borderRadius(hoverContainerBorderRadius)}
      ${this.boxShadow(this.boxShadowCSS(hoverContainerBoxShadow))}
      ${this.border(hoverContainerBorder)}
    }

    .form-submit-${id} .form-input-submit{
      ${this.transitionSupport(props)}
      ${this.backgroundColor(buttonBackgroundColor)}
      ${this.color(buttonColor)}
      ${this.fontSize(typoSize)}
      ${this.margin(buttonMargin)}
      ${this.padding(buttonPadding)}
      ${this.backgroundColor(buttonBackgroundColor)}
      ${this.justifyContent(buttonAlign)}
      ${this.borderRadius(buttonBorderRadius)}
      ${this.boxShadow(this.boxShadowCSS(buttonBoxShadow))}
      ${this.width(buttonWidth)}
      ${this.height(buttonHeight)}
      ${this.maxWidth(buttonMaxWidth)}
      ${this.maxHeight(buttonMaxHeight)}
      ${this.border(
        buttonBorder,
        hoverButtonBorder
          ? {
              top: {
                width: "0px",
                style: "solid",
                color: hoverButtonBorder?.top?.color,
              },
              bottom: {
                width: "0px",
                style: "solid",
                color: hoverButtonBorder?.bottom?.color,
              },
              left: {
                width: "0px",
                style: "solid",
                color: hoverButtonBorder?.left?.color,
              },
              right: {
                width: "0px",
                style: "solid",
                color: hoverButtonBorder?.right?.color,
              },
            }
          : undefined,
      )}
    }
   
    .form-submit-${id}:hover .form-input-submit{
      ${this.backgroundColor(hoverButtonBackgroundColor)}
      ${this.color(hoverButtonColor)}
      ${this.margin(hoverButtonMargin)}
      ${this.padding(hoverButtonPadding)}
      ${this.borderRadius(hoverButtonBorderRadius)}
      ${this.boxShadow(this.boxShadowCSS(hoverButtonBoxShadow))}
      ${this.border(hoverButtonBorder)}
    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {

        .form-submit-${id}{
          ${this.margin(containerMarginTablet)}
          ${this.justifyContent(alignTablet)}
          ${this.padding(containerPaddingTablet)}
          ${this.width(containerWidthTablet)}
          ${this.height(containerHeightTablet)}
        }
        
        .form-submit-${id} .form-input-submit{
          ${this.justifyContent(buttonAlignTablet)}
          ${this.margin(buttonMarginTablet)}
          ${this.padding(buttonPaddingTablet)}
          ${this.width(buttonWidthTablet)}
          ${this.height(buttonHeightTablet)}
        }

        .form-submit-${id}:hover{
          ${this.margin(hoverContainerMarginTablet)}
          ${this.padding(hoverContainerPaddingTablet)}
        }
        
        .form-submit-${id} .form-input-submit:hover{
          ${this.margin(hoverButtonMarginTablet)}
          ${this.padding(hoverButtonPaddingTablet)}
        }

    }

    /* Mobile */
    @media (max-width: 767px) {

        .form-submit-${id}{
          ${this.justifyContent(alignMobile)}
          ${this.width(containerWidthMobile)}
          ${this.height(containerHeightMobile)}
          ${this.margin(containerMarginMobile)}
          ${this.padding(containerPaddingMobile)}
        }
        
        .form-submit-${id} .form-input-submit{
          ${this.justifyContent(buttonAlignMobile)}
          ${this.margin(buttonMarginMobile)}
          ${this.padding(buttonPaddingMobile)}
          ${this.width(buttonWidthMobile)}
          ${this.height(buttonHeightMobile)}
        }

        .form-submit-${id}:hover{
          ${this.margin(hoverContainerMarginMobile)}
          ${this.padding(hoverContainerPaddingMobile)}
        }
        
        .form-submit-${id} .form-input-submit:hover{
          ${this.margin(hoverButtonMarginMobile)}
          ${this.padding(hoverButtonPaddingMobile)}
        }

    }

    `;
  }

  blockCSS__FormRange(id, props) {
    const {
      width,
      height,
      align,
      alignTablet,
      alignMobile,
      layoutMargin,
      containerBackgroundColor,
      layoutMarginTablet,
      layoutMarginMobile,
      layoutBorder,
      layoutBorderRadius,
      layoutBoxShadow,
      layoutPadding,
      layoutPaddingTablet,
      layoutPaddingMobile,
      sliderThumbWidth,
      sliderThumbHeight,
      sliderThumbColor,
      sliderThumbBorder,
      sliderThumbBorderRadius,
      sliderTrackColor,
      sliderTrackWidth,
      sliderTrackHeight,
      sliderTrackBorder,
      sliderTrackBorderRadius,
    } = props;
    return `
   
    .form-range-${id}{
      ${this.width(width)}
      ${this.justifyContent(align)}
      ${this.padding(layoutPadding)}
      ${this.margin(layoutMargin)}
      ${this.border(layoutBorder)}
      ${this.borderRadius(layoutBorderRadius)}
      ${this.boxShadow(this.boxShadowCSS(layoutBoxShadow))} 
      ${this.margin(layoutMargin)}
      ${this.backgroundColor(containerBackgroundColor)}
    }

    .form-range-${id} .form-range-field{
      ${this.width(sliderTrackWidth)}
      ${this.height(height)}
    }

    .form-range-${id} .form-range-field[type='range'] {
      ${
        sliderThumbColor ||
        sliderThumbWidth ||
        sliderThumbHeight ||
        sliderThumbBorder ||
        sliderThumbBorderRadius ||
        sliderTrackColor ||
        sliderTrackWidth ||
        sliderTrackHeight ||
        sliderTrackBorder ||
        sliderTrackBorderRadius
          ? `-webkit-appearance: none;`
          : ""
      }
      }
      
    .form-range-${id} .form-range-field[type='range']::-webkit-slider-thumb {
      -webkit-appearance: none;
        ${this.width(sliderThumbWidth)}
        ${this.height(sliderThumbHeight)}
        ${this.backgroundColor(sliderThumbColor)}
        ${this.border(sliderThumbBorder)}
        ${this.borderRadius(sliderThumbBorderRadius)}

    }

    .form-range-${id} .form-range-field[type='range']::-webkit-slider-runnable-track {
      -webkit-appearance: none;
        ${this.width(sliderTrackWidth)}
        ${this.height(sliderTrackHeight)}
        ${this.backgroundColor(sliderTrackColor)}
        ${this.border(sliderTrackBorder)}
        ${this.borderRadius(sliderTrackBorderRadius)}
    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .form-range-${id} {
        ${this.justifyContent(alignTablet)}
        ${this.padding(layoutPaddingTablet)}
        ${this.margin(layoutMarginTablet)}
      }

    }

    /* Mobile */
    @media (max-width: 767px) {
      .form-range-${id}{
        ${this.justifyContent(alignMobile)}
        ${this.padding(layoutPaddingMobile)}
        ${this.margin(layoutMarginMobile)}
      }
      
    }

    `;
  }

  blockCSS__FormDate(id, props) {
    const {
      width,
      height,
      align,
      alignTablet,
      alignMobile,
      layoutMargin,
      layoutMarginTablet,
      layoutMarginMobile,
      layoutPadding,
      layoutPaddingTablet,
      layoutPaddingMobile,
      inputMargin,
      inputMarginTablet,
      inputMarginMobile,
      inputPadding,
      inputPaddingTablet,
      inputPaddingMobile,
      typoColor,
      typoBackgroundColor,
      containerBackgroundColor,
      typoSize,
      inputBorder,
      layoutBorder,
      layoutBorderRadius,
      inputBorderRadius,
      layoutBoxShadow,
      inputBoxShadow,
      showLabel,
      label,
      labelColor,
      labelRequiredColor,
    } = props;
    return `
   
    .form-date-${id}{
      ${this.alignItems(align)}
      ${this.margin(layoutMargin)}
      ${this.backgroundColor(containerBackgroundColor)}
      ${this.padding(layoutPadding)}
      ${this.border(layoutBorder)}
      ${this.borderRadius(layoutBorderRadius)}
      ${this.boxShadow(this.boxShadowCSS(layoutBoxShadow))}
    }

    .form-date-${id} .form-date-field{
      ${this.width(width)}
      ${this.height(height)}
      ${this.fontSize(typoSize)}
      ${this.color(typoColor)}
      ${this.backgroundColor(typoBackgroundColor)}
      ${this.border(inputBorder)}
      ${this.borderRadius(inputBorderRadius)}
      ${this.boxShadow(this.boxShadowCSS(inputBoxShadow))}
      ${this.margin(inputMargin)}
      ${this.padding(inputPadding)}
      
    }

    ${
      showLabel
        ? `
      .form-date-${id} label {
        ${this.color(labelColor)}
      }
      .form-date-${id} label .required {
        ${this.color(labelRequiredColor)}
      }
      `
        : ``
    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
       .form-date-${id}{
          ${this.justifyContent(alignTablet)}
          ${this.margin(layoutMarginTablet)}
          ${this.padding(layoutPaddingTablet)}
        }
        .form-date-${id} .form-date-field{
          ${this.margin(inputMarginTablet)}
          ${this.padding(inputPaddingTablet)}
        }

    }

    /* Mobile */
    @media (max-width: 767px) {
       .form-date-${id}{
          ${this.justifyContent(alignMobile)}
          ${this.margin(layoutMarginMobile)}
          ${this.padding(layoutPaddingMobile)}
        }
        .form-date-${id} .form-date-field{
          ${this.margin(inputMarginMobile)}
          ${this.padding(inputPaddingMobile)}
        }

    }

    `;
  }

  blockCSS__FormTextarea(id, props) {
    const {
      align,
      alignTablet,
      alignMobile,
      inputWidth,
      inputWidthTablet,
      inputWidthMobile,
      inputHeight,
      inputHeightTablet,
      inputHeightMobile,
      containerWidth,
      containerWidthTablet,
      containerWidthMobile,
      containerHeight,
      containerHeightTablet,
      containerHeightMobile,
      containerMaxWidth,
      containerMaxHeight,
      containerBackground,
      inputColor,
      inputPlaceholderColor,
      inputBackgroundColor,
      containerPadding,
      containerPaddingTablet,
      containerPaddingMobile,
      containerBorder,
      containerBorderRadius,
      containerBoxShadow,
      layoutMargin,
      layoutMarginTablet,
      layoutMarginMobile,
      inputMargin,
      inputMarginTablet,
      inputMarginMobile,
      inputPadding,
      inputPaddingTablet,
      inputPaddingMobile,
      inputBorder,
      inputBorderRadius,
      inputBoxShadow,
      showLabel,
      label,
      labelColor,
      labelRequiredColor,
    } = props;
    return `
    
    .form-textarea-${id} .form-textarea-field::placeholder {
      ${this.color(inputPlaceholderColor)}
    }

    .form-textarea-${id}{
      ${this.alignItems(align)}
      ${this.margin(layoutMargin)}
      ${this.width(containerWidth)}
      ${this.height(containerHeight)}
      ${this.maxWidth(containerMaxWidth)}
      ${this.maxHeight(containerMaxHeight)}
      ${this.backgroundColor(containerBackground)}
      ${this.padding(containerPadding)}
      ${this.border(containerBorder)}
      ${this.borderRadius(containerBorderRadius)}
      ${this.boxShadow(this.boxShadowCSS(containerBoxShadow))}
    }

    .form-textarea-${id} .form-textarea-field{
      ${this.color(inputColor)}
      ${this.backgroundColor(inputBackgroundColor)}
      ${this.width(inputWidth)}
      ${this.height(inputHeight)}
      ${this.padding(inputPadding)}
      ${this.margin(inputMargin)}
      ${this.border(inputBorder)}
      ${this.borderRadius(inputBorderRadius)}
      ${this.boxShadow(this.boxShadowCSS(inputBoxShadow))}
    }

    ${
      showLabel
        ? `
      .form-textarea-${id} label {
        ${this.color(labelColor)}
      }
      .form-textarea-${id} label .required {
        ${this.color(labelRequiredColor)}
      }
      `
        : ``
    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .form-textarea-${id}{
        ${this.margin(layoutMarginTablet)}
        ${this.justifyContent(alignTablet)}
        ${this.width(containerWidthTablet)}
        ${this.height(containerHeightTablet)}
        ${this.padding(containerPaddingTablet)}
      }
      
      .form-textarea-${id} .form-textarea-field{
        ${this.width(inputWidthTablet)}
        ${this.height(inputHeightTablet)}
        ${this.margin(inputMarginTablet)}
        ${this.padding(inputPaddingTablet)}
       }

    }

    /* Mobile */
    @media (max-width: 767px) {
      .form-textarea-${id}{
        ${this.margin(layoutMarginMobile)}
        ${this.justifyContent(alignMobile)}
        ${this.width(containerWidthMobile)}
        ${this.height(containerHeightMobile)}
        ${this.padding(containerPaddingMobile)}
      }

      .form-textarea-${id} .form-textarea-field{
        ${this.width(inputWidthMobile)}
        ${this.height(inputHeightMobile)}
        ${this.margin(inputMarginMobile)}
        ${this.padding(inputPaddingMobile)}
       }
    }

    `;
  }

  blockCSS__FormToggle(id, props) {
    const {
      width,
      height,
      align,
      alignTablet,
      alignMobile,
      thumbColor,
      thumbBackgroundColor,
      thumbOffColor,
      thumbBorder,
      thumbBorderRadius,
      thumbBoxShadow,
      thumbOffBackgroundColor,
      containerBackgroundColor,
      containerBorderRadius,
      trackBorderRadius,
      containerBorder,
      containerBoxShadow,
      layoutMargin,
      layoutMarginTablet,
      layoutMarginMobile,
      layoutPadding,
      layoutPaddingTablet,
      layoutPaddingMobile,
      trackBorder,
      trackBoxShadow,
      left,
      top,
      gap,
    } = props;
    return `
    
    .form-toggle-${id}{
      ${this.justifyContent(align)}
      ${this.margin(layoutMargin)}
      ${this.padding(layoutPadding)}
      ${this.width(width)}
      ${this.height(height)}
      ${this.backgroundColor(containerBackgroundColor)}
      ${this.boxShadow(this.boxShadowCSS(containerBoxShadow))}
      ${this.border(containerBorder)}
      ${this.borderRadius(containerBorderRadius)}
      ${this.columnGap(gap)}
    }

    .form-toggle-${id} .slider{
      ${this.backgroundColor(thumbOffColor)}
      ${this.boxShadow(this.boxShadowCSS(trackBoxShadow))}
      ${this.border(trackBorder)}
    }

    .form-toggle-${id} .slider:before {
      ${this.backgroundColor(thumbOffBackgroundColor)}
      ${this.border(thumbBorder)}
      ${this.boxShadow(this.boxShadowCSS(thumbBoxShadow))}
      ${this.left(left)}
      ${this.top(top)}

    }

    .form-toggle-${id} .form-input-toggle:checked+ .slider:before {
      ${this.backgroundColor(thumbColor)}
    }

    .form-toggle-${id} .form-input-toggle:checked + .slider {
      ${this.backgroundColor(thumbBackgroundColor)}
    }

    .form-toggle-${id} .slider.round {
      ${this.borderRadius(trackBorderRadius)}
    }
  
    .form-toggle-${id} .slider.round:before {
      ${this.borderRadius(thumbBorderRadius)}
    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .form-toggle-${id}{
        ${this.justifyContent(alignTablet)}
        ${this.margin(layoutMarginTablet)}
        ${this.padding(layoutPaddingTablet)}
      }
     
    }

    /* Mobile */
    @media (max-width: 767px) {
        .form-toggle-${id}{
          ${this.justifyContent(alignMobile)}
          ${this.margin(layoutMarginMobile)}
          ${this.padding(layoutPaddingMobile)}
        }
    }

    `;
  }

  blockCSS__FormCheckbox(id, props) {
    const {
      width,
      height,
      inputWidth,
      inputHeight,
      labelFontSize,
      labelColor,
      inputColor,
      containerBackgroundColor,
      inputMargin,
      layoutMargin,
      layoutMarginTablet,
      layoutMarginMobile,
      inputPadding,
      layoutPadding,
      layoutPaddingTablet,
      layoutPaddingMobile,
      align,
      alignTablet,
      alignMobile,
      inputBorder,
      inputBorderRadius,
      inputBoxShadow,
      layoutBorder,
      layoutBorderRadius,
      layoutBoxShadow,
      gapX = "8px",
      gapY = "5px",
    } = props;
    return `
    
    .form-checkbox-${id}{
      ${this.padding(layoutPadding)}
      ${this.margin(layoutMargin)}
      ${this.border(layoutBorder)}
      ${this.borderRadius(layoutBorderRadius)}
      ${this.boxShadow(this.boxShadowCSS(layoutBoxShadow))}
      ${this.alignItems(align)}
      ${this.backgroundColor(containerBackgroundColor)}
      ${this.rowGap(gapX)}
    }

    .form-checkbox-${id} .form-checkbox-container{
      ${this.columnGap(gapY)}
      ${this.width(width)}
      ${this.height(height)}
    }

    .form-checkbox-${id} .form-checkbox-container .form-checkbox-label{
      ${this.color(labelColor)}
      ${this.fontSize(labelFontSize)}
    }

    .form-checkbox-${id} .form-checkbox-container .form-input-checkbox[type=checkbox] {
      ${this.border(layoutBorder)}
     
  }

  .form-checkbox-${id} .form-checkbox-container .form-input-checkbox[type=checkbox]:after,
  .form-input-checkbox[type=checkbox]::after {
    ${this.border(inputBorder)}
    ${this.borderRadius(inputBorderRadius)}
    ${this.width(inputWidth)}
    ${this.height(inputHeight)}
    ${this.backgroundColor(layoutBorderRadius)}
    ${this.margin(inputMargin)}
    ${this.padding(inputPadding)}
    ${this.boxShadow(this.boxShadowCSS(inputBoxShadow))}
     
  }

  .form-checkbox-${id} .form-checkbox-container .form-input-checkbox[type=checkbox]:checked:after,
  .form-input-checkbox[type=checkbox]:checked::after {
    ${this.color(inputColor)}
    ${this.margin(inputMargin)}
    ${this.padding(inputPadding)}
  }


    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .form-checkbox-${id}{
        ${this.padding(layoutPaddingTablet)}
        ${this.margin(layoutMarginTablet)}
        ${this.alignItems(alignTablet)}
      }
     
    }

    /* Mobile */
    @media (max-width: 767px) {
        .form-checkbox-${id}{
          ${this.padding(layoutPaddingMobile)}
          ${this.margin(layoutMarginMobile)}
          ${this.alignItems(alignMobile)}
        }
    }

    `;
  }

  blockCSS__FormOption(id, props) {
    const {
      width,
      height,
      layoutMargin,
      layoutMarginTablet,
      layoutMarginMobile,
      layoutPadding,
      layoutPaddingTablet,
      layoutPaddingMobile,
      typoSize,
      labelColor,
      radioInputSize,
      containerBackgroundColor,
      gapX = "8px",
      gapY = "5px",
    } = props;
    return `
    
    .form-option-${id}{
      ${this.width(width)}
      ${this.height(height)}
      ${this.margin(layoutMargin)}
      ${this.padding(layoutPadding)}
      ${this.backgroundColor(containerBackgroundColor)}
      ${this.rowGap(gapX)}
    }

    .form-option-${id} .form-option-container{
      ${this.columnGap(gapY)}
    }

    .form-option-${id} .form-option-field{
      ${this.width(radioInputSize)}
      ${this.height(radioInputSize)}
    }

    .form-option-${id} .form-option-label{
      ${this.fontSize(typoSize)}
      ${this.color(labelColor)}

    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .form-option-${id}{
        ${this.margin(layoutMarginTablet)}
        ${this.padding(layoutPaddingTablet)}
      }
     
    }

    /* Mobile */
    @media (max-width: 767px) {
      .form-option-${id}{
        ${this.margin(layoutMarginMobile)}
        ${this.padding(layoutPaddingMobile)}
      }
    }

    `;
  }

  blockCSS__FormGoogleRecaptcha(id, props) {
    const {
      layoutMargin,
      layoutMarginTablet,
      layoutMarginMobile,
      layoutPadding,
      layoutPaddingTablet,
      layoutPaddingMobile,
      siteKey,
      secretKey,
    } = props;
    return `
    
    .form-google-recaptcha-${id}{
      ${this.margin(layoutMargin)}
      ${this.padding(layoutPadding)}
    }
   
    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
       .form-google-recaptcha-${id}{
          ${this.margin(layoutMarginTablet)}
          ${this.padding(layoutPaddingTablet)}
        }
     
    }

    /* Mobile */
    @media (max-width: 767px) {
      .form-google-recaptcha-${id}{
          ${this.margin(layoutMarginMobile)}
          ${this.padding(layoutPaddingMobile)}
       }
    }

    `;
  }

  blockCSS__FormDropdown(id, props) {
    const {
      width,
      inputWidth,
      inputWidthTablet,
      inputWidthMobile,
      height,
      inputHeight,
      inputHeightTablet,
      inputHeightMobile,
      inputMargin,
      inputMarginTablet,
      inputMarginMobile,
      inputPadding,
      inputPaddingTablet,
      inputPaddingMobile,
      layoutMargin,
      layoutMarginTablet,
      layoutMarginMobile,
      layoutPadding,
      layoutPaddingTablet,
      layoutPaddingMobile,
      typoSize,
      align,
      alignTablet,
      alignMobile,
      typoBackgroundColor,
      typoOptionColor,
      typoOptionBackgroundColor,
      typoOptionFontSize,
      typoOptionFontSizeTablet,
      typoOptionFontSizeMobile,
      inputBorder,
      inputBorderRadius,
      inputBoxShadow,
      border,
      borderRadius,
      boxShadow,
      typoColor,
      typoBackgroundColorContainer,
      showLabel,
      label,
      labelColor,
      labelRequiredColor,
    } = props;
    return `
    
    .form-dropdown-${id}{
      ${this.alignItems(align)}
      ${this.height(height)}
      ${this.width(width)}
      ${this.backgroundColor(typoBackgroundColorContainer)}
      ${this.margin(layoutMargin)}
      ${this.padding(layoutPadding)}
      ${this.border(border)}
      ${this.borderRadius(borderRadius)}
      ${this.boxShadow(this.boxShadowCSS(boxShadow))}

    }

    .form-dropdown-${id} .form-dropdown-field{
      ${this.height(inputHeight)}
      ${this.width(inputWidth)}
      ${this.fontSize(typoSize)}
      ${this.color(typoColor)}
      ${this.backgroundColor(typoBackgroundColor)}
      ${this.border(inputBorder)}
      ${this.borderRadius(inputBorderRadius)}
      ${this.boxShadow(this.boxShadowCSS(inputBoxShadow))}
      ${this.margin(inputMargin)}
      ${this.padding(inputPadding)}
    }

    .form-dropdown-${id} .form-dropdown-field .form-dropdown-option{
      ${this.fontSize(typoOptionFontSize)}
      ${this.color(typoOptionColor)}
      ${this.backgroundColor(typoOptionBackgroundColor)}
    }

    ${
      showLabel
        ? `
      .form-dropdown-${id} label {
        ${this.color(labelColor)}
      }
      .form-dropdown-${id} label .required {
        ${this.color(labelRequiredColor)}
      }
      `
        : ``
    }


    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
        .form-dropdown-${id}{
          ${this.justifyContent(alignTablet)}
          ${this.margin(layoutMarginTablet)}
          ${this.padding(layoutPaddingTablet)}
        }
        .form-dropdown-${id} .form-dropdown-field{  
          ${this.height(inputHeightTablet)}
          ${this.width(inputWidthTablet)}
          ${this.margin(inputMarginTablet)}
          ${this.padding(inputPaddingTablet)}
        }

        .form-dropdown-${id} .form-dropdown-option{
          ${this.fontSize(typoOptionFontSizeTablet)}
        }
    }

    /* Mobile */
    @media (max-width: 767px) {
          .form-dropdown-${id}{
            ${this.justifyContent(alignMobile)}
            ${this.margin(layoutMarginMobile)}
            ${this.padding(layoutPaddingMobile)}
          }
          .form-dropdown-${id} .form-dropdown-field{ 
            ${this.height(inputHeightMobile)}
            ${this.width(inputWidthMobile)}
            ${this.margin(inputMarginMobile)}
            ${this.padding(inputPaddingMobile)}
          }
        
        .form-dropdown-${id} .form-dropdown-option{
          ${this.fontSize(typoOptionFontSizeMobile)}
        }
    }

    `;
  }

  blockCSS__ProductHunt(id, props) {
    const {
      url,
      post,
      theme = "light",
      embedType,
      width,
      widthTablet,
      widthMobile,
      align,
      alignTablet,
      alignMobile,
    } = props;
    return `

    .product-hunt-${id}{
      ${this.justifyContent(align)}
    }
    
    .product-hunt-${id} .product-hunt-image{
      ${this.width(width)}

    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .product-hunt-${id}{
      ${this.justifyContent(alignTablet)}
    }
    
    .product-hunt-${id} .product-hunt-image{
      ${this.width(widthTablet)}
    }
    }

    /* Mobile */
    @media (max-width: 767px) {
      .product-hunt-${id}{
      ${this.justifyContent(alignMobile)}
    }
    
    .product-hunt-${id} .product-hunt-image{
      ${this.width(widthMobile)}
    }
    }
    `;
  }

  blockCSS__Slider(id, props) {
    const {
      totalSlides = 3,
      isClickable,
      loop,
      hasDynamicBullets,
      grabCursor,
      hasPagination = true,
      paginationType,
      spaceBetween,
      slidePerView,
      isCentered,
      isFreeMode,
      hasEffect,
      effectType,
      hasMouseWheel,
      hasAutoplay,
      hasParallax,
      isKeyboardChange,
      hasScrollbar,
      isVertical,
      width,
      widthTablet,
      widthMobile,
      height = "100%",
      heightMobile = "100%",
      heightTablet = "100%",
      autoplayDelay = 3000,
      disableAutoplayOnInteraction,
      parallaxBackground,
      navigation = true,
      navigationHeight,
      navigationHeightTablet,
      navigationHeightMobile,
      navigationWidth,
      navigationWidthTablet,
      navigationWidthMobile,
      navigationButtonColor,
      navigationButtonBackgroundColor,
      navigationButtonPadding,
      navigationButtonPaddingTablet,
      navigationButtonPaddingMobile,
      navigationButtonBorder,
      navigationButtonBorderRadius,
      navigationPosition,
      navigationButtonMargin,
      navigationButtonMarginTablet,
      navigationButtonMarginMobile,
      navigationSize,
      navigationAlign,
      paginationSize,
      paginationSizeTablet,
      paginationSizeMobile,
      paginationInactiveColor,
      paginationActiveColor,
      paginationBackgroundColor,
      paginationGap,
      paginationGapTablet,
      paginationGapMobile,
      paginationActiveOpacity = 1,
      paginationInactiveOpacity = 0.2,
      paginationFractionSize,
      paginationFractionSizeTablet,
      paginationFractionSizeMobile,
      paginationFractionColor,
      paginationFractionBackgroundColor,
      paginationPosition,
      sliderSpeed = 300,
      alignPagination,
      alignPaginationTablet,
      alignPaginationMobile,
      paginationBorderRadius,
      paginationBorder,
      paginationMargin,
      paginationMarginTablet,
      paginationMarginMobile,
      paginationPadding,
      paginationPaddingTablet,
      paginationPaddingMobile,
      hasStaticSlide,
      hasTouchMove = false,
      rewind,
      layoutWidth = "100%",
      layoutWidthTablet = "100%",
      layoutWidthMobile = "100%",
      layoutHeight = "80vh",
      layoutHeightTablet = "80vh",
      layoutHeightMobile = "80vh",
      overflow,
    } = props;
    return `
    
    .slider-${id}{
      ${this.width(layoutWidth)}
      ${this.height(layoutHeight)}
      ${this.overflow(overflow)}
    }

    .slider-${id} .swiper{
      ${this.width(width)}
      ${this.height(height)}
    }
   
    .slider-${id} .swiper .swiper-button-prev, .slider-${id} .swiper .swiper-button-next{
      ${this.color(navigationButtonColor)}
      ${this.backgroundColor(navigationButtonBackgroundColor)}
      ${this.padding(navigationButtonPadding)}
      ${this.height(navigationHeight)}
      ${this.width(navigationWidth)}
      ${this.border(navigationButtonBorder)}
      ${this.borderRadius(navigationButtonBorderRadius)}
      ${this.top(navigationPosition?.top)}
      ${this.alignItems(navigationAlign)}
      ${this.margin(navigationButtonMargin)}
      ${this.padding(navigationButtonPadding)}
    }

    .slider-${id} .swiper .swiper-button-prev::after, .slider-${id} .swiper .swiper-button-next::after{
      ${this.fontSize(navigationSize)}

    }

    .slider-${id} .swiper .swiper-pagination{
      ${this.textAlign(alignPagination)}
      ${this.margin(paginationMargin)}
      ${this.padding(paginationPadding)}
    }

    .slider-${id} .swiper .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active{
      ${this.opacity(paginationActiveOpacity)}
    }

    .slider-${id} .swiper .swiper-pagination .swiper-pagination-bullet{
      ${this.backgroundColor(paginationInactiveColor)}
      ${this.border(paginationBorder)}
      ${this.borderRadius(paginationBorderRadius)}
      ${this.opacity(paginationInactiveOpacity)}
      ${this.width(paginationSize)}
      ${this.height(paginationSize)}
      ${
        isVertical
          ? (this.marginTop(paginationGap), this.marginBottom(paginationGap))
          : (this.marginLeft(paginationGap), this.marginRight(paginationGap))
      }
    }

    .slider-${id} .swiper .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active{
      ${this.backgroundColor(paginationActiveColor)}
    }

    .slider-${id} .swiper .swiper-pagination-fraction{
      ${this.fontSize(paginationFractionSize)}
      ${this.color(paginationFractionColor)}
    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .slider-${id}{
        ${this.width(layoutWidthTablet)}
        ${this.height(layoutHeightTablet)}
      }

      .slider-${id} .swiper{
        ${this.width(widthTablet)}
        ${this.height(heightTablet)}
      }

      .slider-${id} .swiper .swiper-button-prev, .slider-${id} .swiper .swiper-button-next{
        ${this.padding(navigationButtonPaddingTablet)}
        ${this.height(navigationHeightTablet)}
        ${this.width(navigationWidthTablet)}
        ${this.margin(navigationButtonMarginTablet)}
        ${this.padding(navigationButtonPaddingTablet)}
      }

       .slider-${id} .swiper .swiper-pagination{
          ${this.textAlign(alignPaginationTablet)}
        }

         .slider-${id} .swiper .swiper-pagination .swiper-pagination-bullet{
          ${this.width(paginationSizeTablet)}
          ${this.height(paginationSizeTablet)}
          ${
            isVertical
              ? (this.marginTop(paginationGapTablet),
                this.marginBottom(paginationGapTablet))
              : (this.marginLeft(paginationGapTablet),
                this.marginRight(paginationGapTablet))
          }
        }

        .slider-${id} .swiper .swiper-pagination-fraction{
          ${this.fontSize(paginationFractionSizeTablet)}
        }

    }

    /* Mobile */
    @media (max-width: 767px) {
      .slider-${id}{
        ${this.width(layoutWidthMobile)}
        ${this.height(layoutHeightMobile)}
      }

      .slider-${id} .swiper{
        ${this.width(widthMobile)}
        ${this.height(heightMobile)}
      }

      .slider-${id} .swiper .prev-button, .slider-${id} .swiper .next-button{
        ${this.padding(navigationButtonPaddingMobile)}
        ${this.height(navigationHeightMobile)}
        ${this.width(navigationWidthMobile)}
        ${this.margin(navigationButtonMarginMobile)}
        ${this.padding(navigationButtonPaddingMobile)}
      }

       .slider-${id} .swiper .swiper-pagination{
          ${this.textAlign(alignPaginationMobile)}
        }

         .slider-${id} .swiper .swiper-pagination .swiper-pagination-bullet{
          ${this.width(paginationSizeMobile)}
          ${this.height(paginationSizeMobile)}
          ${
            isVertical
              ? (this.marginTop(paginationGapMobile),
                this.marginBottom(paginationGapMobile))
              : (this.marginLeft(paginationGapMobile),
                this.marginRight(paginationGapMobile))
          }
        }

      .slider-${id} .swiper .swiper-pagination-fraction{
        ${this.fontSize(paginationFractionSizeMobile)}
      }

    }

    `;
  }

  blockCSS__Dropdown(id, props) {
    const {
      width = "200px",
      widthTablet,
      widthMobile,
      height,
      heightTablet,
      heightMobile,
      margin,
      marginTablet,
      marginMobile,
      padding,
      paddingTablet,
      paddingMobile,
      toggle = "show",
      openListOnHover,
      color,
      activeColor,
      backgroundColor,
      activeBackgroundColor,
      position,
    } = props;
    return `
  
    .dropdown-${id}{
      ${this.height(height)}
      ${this.width(width)}
      ${this.margin(margin)}
      ${this.padding(padding)}
    }

    .dropdown-${id}.is-opened >.g-container{
      ${this.color(color)}
      ${this.color(activeColor)}
      ${this.backgroundColor(backgroundColor)}
      ${this.backgroundColor(activeBackgroundColor)}
    }

    .dropdown-${id} > .dropdown-list{
      ${
        position === "left"
          ? `
          ${this.top("0")}
          ${this.right("100%")}
        `
          : position === "right"
          ? `
          ${this.top("0")}
          ${this.left("100%")}
        `
          : position === "top"
          ? `
          ${this.top("0")}
          ${this.left("0")}
          ${this.transform([{ wrapper: "translate", value: "0,-100%" }])}
          `
          : ``
      }

    }

    /* Tablet */
    @media (min-width: 768px) and (max-width: 1024px) {
      .dropdown-${id}{
        ${this.width(widthTablet)}
        ${this.height(heightTablet)}
        ${this.margin(marginTablet)}
        ${this.padding(paddingTablet)}
      }
    }

    /* Mobile */
    @media (max-width: 767px) {
      .dropdown-${id}{
        ${this.width(widthMobile)}
        ${this.height(heightMobile)}
        ${this.margin(marginMobile)}
        ${this.padding(paddingMobile)}
      }
    }

    `;
  }

  blockCSS__ContentLockerInline(id, props) {
    let css = "";
    const {
      align,
      alignMobile,
      alignTablet,
      dismissable,
      headingFontSize,
      headingFontSizeTablet,
      headingFontSizeMobile,
      descriptionFontSize,
      inputFontSize,
      buttonFontSize,
      cardBackgroundColor,
      headingColor,
      descriptionColor,
      buttonColor,
      buttonBackgroundColor,
      inputColor,
      inputBackgroundColor,
      cardShadow,
    } = props;

    // Main container styles
    css += `
      .content-locker-inline-${id} {
        ${this.textAlign(align)}
        flex-direction: column;
        align-items: ${
          align === "left"
            ? "flex-start"
            : align === "right"
            ? "flex-end"
            : "center"
        };
      }

      @media (max-width: 1024px) {
        .content-locker-inline-${id} {
          ${this.textAlign(alignTablet)}
          align-items: ${
            alignTablet === "left"
              ? "flex-start"
              : alignTablet === "right"
              ? "flex-end"
              : "center"
          };
        }
      }

      @media (max-width: 767px) {
        .content-locker-inline-${id} {
          ${this.textAlign(alignMobile)}
          align-items: ${
            alignMobile === "left"
              ? "flex-start"
              : alignMobile === "right"
              ? "flex-end"
              : "center"
          };
        }
      }
    `;

    // Card styles
    css += `
      .content-locker-inline-${id} .g-content-locker-inline__card {
        ${this.backgroundColor(cardBackgroundColor)}
        ${this.boxShadow(this.boxShadowCSS(cardShadow))}
        padding: 20px;
        border-radius: 8px;
        max-width: 100%;
      }
    `;

    // Title styles
    css += `
      .content-locker-inline-${id} .g-content-locker-inline__title-container {
        margin-bottom: 15px;
      }

      .content-locker-inline-${id} .g-content-locker-inline__title-container div {
        ${this.fontSize(headingFontSize)}
        ${this.color(headingColor)}
        margin: 0;
      }

      @media (max-width: 1024px) {
        .content-locker-inline-${id} .g-content-locker-inline__title-container div {
          ${this.fontSize(headingFontSizeTablet)}
        }
      }

      @media (max-width: 767px) {
        .content-locker-inline-${id} .g-content-locker-inline__title-container div {
          ${this.fontSize(headingFontSizeMobile)}
        }
      }
    `;

    // Subtitle styles
    css += `
      .content-locker-inline-${id} .g-content-locker-inline__subtitle-container {
        margin-bottom: 20px;
      }

      .content-locker-inline-${id} .g-content-locker-inline__subtitle-container div {
        ${this.fontSize(descriptionFontSize)}
        ${this.color(descriptionColor)}
        margin: 0;
      }
    `;

    // Form styles
    css += `
      .content-locker-inline-${id} .g-content-locker-inline__form {
        display: flex;
        flex-direction: row;
        gap: 10px;
      }
    `;

    // Input styles
    css += `
      .content-locker-inline-${id} .g-content-locker-inline__input {
        ${this.fontSize(inputFontSize)}
        ${this.color(inputColor)}
        ${this.backgroundColor(inputBackgroundColor)}
        padding: 10px;
        border: 1px solid #ddd;
        border-radius: 4px;
        width: 100%;
      }
    `;

    // Button styles
    css += `
      .content-locker-inline-${id} button {
        ${this.fontSize(buttonFontSize)}
        ${this.color(buttonColor)}
        ${this.backgroundColor(buttonBackgroundColor)}
        padding: 10px 20px;
        border: none;
        border-radius: 4px;
        cursor: pointer;
      }
    `;

    return css;
  }

  blockCSS__ContentLockerPopup(id, props) {
    let css = "";
    const {
      align,
      alignMobile,
      alignTablet,
      dismissable,
      headingFontSize,
      headingFontSizeTablet,
      headingFontSizeMobile,
      descriptionFontSize,
      inputFontSize,
      buttonFontSize,
      cardBackgroundColor,
      headingColor,
      descriptionColor,
      buttonColor,
      buttonBackgroundColor,
      inputColor,
      inputBackgroundColor,
      cardShadow,
    } = props;

    // Card styles
    css += `
      .content-locker-popup-${id} .g-content-locker-popup__card {
        ${this.backgroundColor(cardBackgroundColor)}
        ${this.boxShadow(this.boxShadowCSS(cardShadow))}
      }
    `;

    // Title styles
    css += `
      .content-locker-popup-${id} .g-content-locker-popup__title-container div {
        ${this.fontSize(headingFontSize)}
        ${this.color(headingColor)}
      }

      @media (max-width: 1024px) {
        .content-locker-popup-${id} .g-content-locker-popup__title-container div {
          ${this.fontSize(headingFontSizeTablet)}
        }
      }

      @media (max-width: 767px) {
        .content-locker-popup-${id} .g-content-locker-popup__title-container div {
          ${this.fontSize(headingFontSizeMobile)}
        }
      }
    `;

    // Subtitle styles
    css += `
      .content-locker-popup-${id} .g-content-locker-popup__subtitle-container div {
        ${this.fontSize(descriptionFontSize)}
        ${this.color(descriptionColor)}
      }
    `;

    // Input styles
    css += `
      .content-locker-popup-${id} .g-content-locker-popup__input {
        ${this.fontSize(inputFontSize)}
        ${this.color(inputColor)}
        ${this.backgroundColor(inputBackgroundColor)}
      }
    `;

    // Button styles
    css += `
      .content-locker-popup-${id} .g-content-locker-popup__form button {
        ${this.fontSize(buttonFontSize)}
        ${this.color(buttonColor)}
        ${this.backgroundColor(buttonBackgroundColor)}
      }
    `;

    return css;
  }
}

var _instance = new GrigoraCSSRenderer();

export default _instance;
